import type { Translations } from "../index";

export const th: Translations = {
  lang: {
    en: "EN",
    ja: "日本語",
    "zh-HK": "繁中",
    "zh-TW": "繁中",
    "zh-CN": "简中",
    ru: "RU",
    ko: "한국어",
    th: "ไทย",
    current: "ไทย",
  },

  nav: {
    platform: "แพลตฟอร์ม",
    forDesigners: "สำหรับนักออกแบบ",
    forBrands: "สำหรับแบรนด์",
    forManufacturers: "การผลิต",
    forStudio: "Studio",
    caraAi: "Cara AI",
    pricing: "ราคา",
    more: "เพิ่มเติม",
    about: "เกี่ยวกับเรา",
    academy: "Academy",
    accessPlatform: "เข้าสู่แพลตฟอร์ม →",
    subline: "ที่ซึ่งการออกแบบพบกับการผลิต",
    sublineBrand: "จัดหา · ผลิต · เปิดตัว",
    sublineDesigner: "รันเวย์สำหรับเครื่องประดับของคุณ",
    inspire: "Inspire",
    newsroom: "ห้องข่าว",
    contact: "ติดต่อเรา",
    catalog: "แคตตาล็อก",
    showcase: "โชว์เคส",
    switchToDesigners: "สำหรับนักออกแบบ →",
    switchToBrands: "สำหรับแบรนด์ →",
    howItWorks: "วิธีการทำงาน",
    overview: "ภาพรวม",
  },

  footer: {
    subline: "เครื่องประดับดีไซเนอร์ · การจัดหา B2B · การผลิต EPH",
    tagline: "\"ตลาดกลางที่การออกแบบอันเป็นเลิศ\nพบกับการผลิตที่สมบูรณ์แบบ\"",
    accessPlatform: "เข้าสู่แพลตฟอร์ม →",
    ephCertified: "การผลิตที่ได้รับการรับรอง EPH",
    copyright: "Caratzon Ltd. All rights reserved.",
    columns: {
      platform: "แพลตฟอร์ม",
      company: "บริษัท",
      resources: "ทรัพยากร",
      contact: "ติดต่อ",
    },
    links: {
      forDesigners: "สำหรับนักออกแบบ",
      forBrands: "สำหรับแบรนด์",
      forManufacturers: "การผลิต",
      caraAi: "Cara AI",
      tradeCatalogue: "แคตตาล็อกค้าส่ง",
      accessPlatform: "เข้าสู่แพลตฟอร์ม",
      aboutCaratzon: "เกี่ยวกับ Caratzon",
      ourStory: "เรื่องราวของเรา",
      leadership: "ผู้บริหาร",
      pressMedia: "สื่อมวลชน",
      investorRelations: "นักลงทุนสัมพันธ์",
      howItWorks: "วิธีการทำงาน",
      ephHub: "ศูนย์การผลิต EPH",
      sustainabilityReport: "รายงานความยั่งยืน",
      cadStandards: "มาตรฐาน CAD",
      supplierCode: "จรรยาบรรณซัพพลายเออร์",
      academy: "Academy",
      inspire: "Inspire",
      newsroom: "ห้องข่าว",
      aiCredits: "AI Credits",
      contactUs: "ติดต่อเรา",
      becomeManufacturer: "สมัครเป็นพันธมิตรการผลิต",
    },
    offices: {
      hongkong: "Design Gateway · 香港",
      guangdong: "Manufacturing Hub · 广东",
      london: "Europe Trade Desk",
    },
    legal: {
      terms: "ข้อกำหนดการใช้บริการ",
      privacy: "นโยบายความเป็นส่วนตัว",
      cookies: "นโยบายคุกกี้",
      supplierCode: "จรรยาบรรณซัพพลายเออร์",
    },
  },

  home: {
    meta: {
      title: "Caratzon — แพลตฟอร์มจัดหาเครื่องประดับ B2B · CAD พร้อมผลิต · AI Marketing",
      description:
        "แพลตฟอร์มจัดหาเครื่องประดับ B2B ชั้นนำสำหรับเครื่องประดับอิสระชั้นสูง ไลเซนส์แบบ CAD พร้อมผลิต ผลิตอย่างยั่งยืนที่ EPH และสร้างสื่อการตลาดทันทีด้วย Caratzon Studio สามระดับ IP พร้อมการจัดการการผลิตครบวงจร",
    },
    emergence: {
      tagline: "จากสเก็ตช์สู่ชั้นวาง ออกแบบ ไลเซนส์ ผลิต — เฉพาะ Caratzon",
      subtitle: "แพลตฟอร์ม B2B สำหรับการออกแบบ ไลเซนส์ และผลิตเครื่องประดับ",
      cta: "เรียกดูแคตตาล็อก",
      ctaSecondary: "วิธีการทำงาน",
    },
    process: {
      overline: "วิธีการทำงาน",
      steps: [
        { number: "01", heading: "ค้นพบ", body: "เรียกดูผลงานต้นฉบับที่ผ่านการวิศวกรรมล่วงหน้าจากนักออกแบบอิสระทั่วโลก", hook: "ไม่มีค่า R&D ไม่มีค่า NRE" },
        { number: "02", heading: "ไลเซนส์", body: "เลือกระดับ IP ของคุณและรับสิทธิ์เชิงพาณิชย์ได้ในไม่กี่วินาที", hook: "สื่อการตลาดรวมอยู่ในทุกไลเซนส์" },
        { number: "03", heading: "ผลิต", body: "แบบจะถูกส่งตรงไปยังศูนย์การผลิตที่ยั่งยืนของ EPH เสร็จสิ้น", hook: "ไม่ต้องจัดการโรงงาน ตรวจสอบย้อนกลับได้ครบถ้วน" },
      ],
    },
    storyBeat: {
      line1: "จากสเก็ตช์สู่ชั้นวาง",
      line2: "ออกแบบ ให้สิทธิ์ ผลิต",
      line3: "มีเพียง Caratzon",
      splitLabel: "ฉันเป็น",
      splitDesigner: "นักออกแบบ",
      splitBrand: "ผู้ซื้อแบรนด์",
    },
    showcase: {
      pieces: [
        {
          sku: "FD001-251225032",
          designer: "Ya Yu Studio",
          name: "สร้อยคอ Celestial Drape",
          descriptor: "ทองคำเหลว ลอยอยู่ในแสง",
        },
        {
          sku: "FD016-251224017",
          designer: "Golden Hulu",
          name: "จี้น้ำเต้า Fortune Gourd",
          descriptor: "สัญลักษณ์โบราณ ซิลูเอตสมัยใหม่",
        },
        {
          sku: "FD033-251225049",
          designer: "Peony Atelier",
          name: "ต่างหู Bloom Drop",
          descriptor: "กลีบดอกไม้ หยุดนิ่งกลางอากาศ",
        },
        {
          sku: "FD051-251226013",
          designer: "Jade River Design",
          name: "กำไล Ripple Cuff",
          descriptor: "สายน้ำบนข้อมือ แข็งตัวในทองคำ",
        },
      ],
    },
    stats: [
      { value: "48+", numericValue: 48, label: "แบบต้นฉบับ" },
      { value: "12", numericValue: 12, label: "นักออกแบบอิสระ" },
      { value: "6", numericValue: 6, label: "ประเทศ" },
      { value: "80%", numericValue: 80, label: "ส่วนแบ่งรายได้นักออกแบบ", suffix: "%" },
    ],
    fork: {
      heading: "คุณอยู่ฝั่งไหน?",
      designer: {
        eyebrow: "สำหรับนักออกแบบ",
        line: "ฝีมือของคุณสมควรได้เวทีระดับโลก — ไม่ใช่แค่โพสต์ Instagram อีกโพสต์",
        cta: "เข้าในฐานะนักออกแบบ",
      },
      brand: {
        eyebrow: "สำหรับแบรนด์",
        line: "ข้าม R&D ไลเซนส์พร้อมสื่อการตลาด เปิดตัววันนี้",
        cta: "เข้าในฐานะแบรนด์",
      },
    },
    close: {
      line: "บทต่อไปเริ่มต้นที่นี่",
      cta: "เริ่มต้นใช้งาน",
    },
    hero: {
      overline: "แพลตฟอร์มจัดหา B2B · การผลิตอย่างยั่งยืนผ่าน EPH",
      h1Line1: "จัดหาแบบ",
      h1Line2: "ข้าม R&D",
      h1Line3: "เปิดตัวทันที",
      tagline:
        "แพลตฟอร์มจัดหาเครื่องประดับ B2B ชั้นนำสำหรับเครื่องประดับอิสระชั้นสูง ไลเซนส์แบบ CAD พร้อมผลิต ผลิตอย่างยั่งยืนที่ศูนย์ EPH ของเรา และให้ AI Studio สร้างสื่อการตลาดให้คุณทันทีที่คลิก 'ซื้อ'",
      cta: "เรียกดูแคตตาล็อกค้าส่ง",
      ctaSecondary: "เรียนรู้เกี่ยวกับ Caratzon Studio",
    },
    pillars: {
      overline: "ความสามารถของแพลตฟอร์ม",
      subtitle: "เวิร์กโฟลว์ครบวงจร",
      items: [
        {
          heading: "เครื่องมือการตลาด AI (Caratzon Studio)",
          body: "ไม่ต้องรอสัปดาห์เพื่อถ่ายตัวอย่าง ทุกไลเซนส์รวม Essentials Kit (ภาพถ่ายอีคอมเมิร์ซ สเปค และ SEO copy) อัปเกรดเป็น Caratzon Kit เพื่อสร้างภาพถ่ายไลฟ์สไตล์ สื่อโซเชียลมีเดีย และ PDF line sheet ที่ออกแบบตามสีแบรนด์ของคุณโดยอัตโนมัติ",
        },
        {
          heading: "สามระดับ IP มีเอกสารทางกฎหมาย",
          body: "Standard (ไม่จำกัดสิทธิ์), Seasonal Embargo (สิทธิ์พิเศษ 12 เดือน) หรือ Full Vault IP (โอน IP ถาวร) สิทธิ์เชิงพาณิชย์ที่มีผลผูกพันทางกฎหมาย — ไม่ใช่แค่การจับมือ",
        },
        {
          heading: "การผลิต EPH ครบวงจร",
          body: "คำสั่งซื้อของคุณส่งตรงไปยังเครือข่ายผู้ผลิต EPH ที่ผ่านการตรวจสอบ การหล่อ การฝัง QC และโลจิสติกส์จัดการในศูนย์รวมที่ยั่งยืนเพียงแห่งเดียว ไม่ต้องเจรจากับโรงงาน",
        },
      ],
    },
    quote: {
      text: "\"คอลเลกชันถัดไปของคุณ — ไม่มี R&D ไม่มีเอเจนซี่ ไม่มีโรงงานให้จัดการ\nจัดหาถึงชั้นวาง แพลตฟอร์มเดียว\"",
      attribution: "หลักการ Caratzon",
    },
    marquee: {
      ariaLabel: "ตัวอย่างแคตตาล็อก",
    },
    howItWorks: {
      overline: "วิธีการทำงาน",
      subtitle: "สามขั้นตอน",
      items: [
        {
          heading: "ค้นพบ",
          body: "เรียกดูผลงานต้นฉบับที่ผ่านการวิศวกรรมจากนักสร้างสรรค์อิสระ ดูตัวอย่าง Essentials Kit ของทุกชิ้น — ภาพถ่ายแคตตาล็อก สเปค เรื่องราวเชิงบรรณาธิการ และ 3D viewer แบบอินเทอร์แอกทีฟ — เพื่อประเมินแพ็กเกจทั้งหมดก่อนตัดสินใจ",
        },
        {
          heading: "ไลเซนส์ & สร้าง",
          body: "เลือกระดับ IP (Standard, Embargo หรือ Vault) และรับสิทธิ์เชิงพาณิชย์ได้ในไม่กี่วินาที ทันทีที่ไลเซนส์ผ่าน Caratzon Studio จะสร้างชุดการตลาดครบชุดให้ทีมขายของคุณเริ่มทำงานได้ทันที",
        },
        {
          heading: "ผลิตผ่าน EPH",
          body: "แบบที่ได้รับอนุมัติจะส่งไปยังศูนย์รวมของ EPH การชุบด้วยไฟฟ้าที่ยั่งยืน กระบวนการเป็นมิตรต่อสิ่งแวดล้อม การติดตามความคืบหน้าครบวงจร — ในขณะที่สื่อการตลาดของคุณเผยแพร่แล้ว",
        },
      ],
    },
    eph: {
      overline: "พันธมิตรการผลิต",
      location: "จีน",
      headline: "ศูนย์การผลิตเครื่องประดับและการชุบแบบยั่งยืนครบวงจรที่ใหญ่ที่สุดในจีน",
      body: "ทุกคำสั่งผลิตผ่าน Caratzon จะดำเนินการที่ศูนย์รวมของ EPH — การหล่อ การฝังอัญมณี การขัดเงา และการชุบแบบรักษ์สิ่งแวดล้อมภายใต้หลังคาเดียว พร้อมการปฏิบัติตามข้อกำหนดด้านสิ่งแวดล้อมและการตรวจสอบย้อนกลับครบถ้วน",
      attrs: [
        {
          label: "การชุบด้วยไฟฟ้าที่ยั่งยืน",
          body: "สายการชุบแบบปล่อยมลพิษต่ำ — ทอง โรเดียม และโลหะผสม ด้วยระบบบำบัดน้ำแบบวงจรปิดและการลดของเสียเคมีที่ได้รับการตรวจสอบ",
        },
        {
          label: "ศูนย์รวมครบวงจร",
          body: "การหล่อ การฝัง การขัดเงา และการชุบภายใต้หลังคาเดียว ลดการส่งต่อระหว่างขั้นตอน ค่าเผื่อที่แม่นยำยิ่งขึ้น รอบเวลาที่เร็วขึ้น",
        },
        {
          label: "การเชื่อมต่อโดยตรง",
          body: "แบบที่ได้รับอนุมัติบน Caratzon จะส่งเข้าคิวการผลิตของ EPH โดยอัตโนมัติ ไม่มีการจัดหาใหม่ด้วยมือ ไม่มีห่วงโซ่อุปทานที่ขาดตอน",
        },
        {
          label: "ตรวจสอบย้อนกลับได้ครบถ้วน",
          body: "ทุกขั้นตอนการผลิตถูกบันทึกและแสดงในแดชบอร์ด Caratzon ของคุณ — ตั้งแต่รับวัตถุดิบจนถึงการตรวจ QC ขั้นสุดท้าย",
        },
      ],
    },
    forWhom: {
      overline: "สำหรับใคร",
      heading: "สร้างขึ้นเพื่อ\nผู้ซื้อค้าส่ง",
      items: [
        {
          title: "ร้านค้าเครื่องประดับ",
          desc: "จัดหาผลงานตรงจากนักออกแบบที่คู่แข่งหาไม่ได้ ทุกไลเซนส์รวม Essentials Kit — ภาพถ่ายแคตตาล็อก สเปค และ SEO copy พร้อมใช้ทันที อัปเกรดเป็น Caratzon Kit เพื่อรับภาพถ่ายไลฟ์สไตล์และสื่อโซเชียล ลงเว็บไซต์ ใส่แคตตาล็อก และโพสต์ Instagram ได้ในวันเดียวกับที่ไลเซนส์",
        },
        {
          title: "เจ้าของบูติก",
          desc: "ข้ามค่า NRE (ค่าวิศวกรรมเริ่มต้น) มากกว่า $1,500 ต่อแบบ ไลเซนส์ผลงานต้นฉบับที่ทดสอบแล้วและพร้อมผลิต สร้าง Caratzon Kit และเปิดตัวสินค้าใหม่บน Shopify ในวันเดียวกับที่เซ็นไลเซนส์",
        },
        {
          title: "ผู้จัดจำหน่ายหลายแบรนด์",
          desc: "จัดหาจากนักออกแบบอิสระทั่วโลกหลายสิบรายผ่านโปรไฟล์ผู้ขายเดียว สร้าง PDF line sheet ค้าส่งที่จัดรูปแบบสมบูรณ์แบบโดยอัตโนมัติ เพื่อแชร์กับลูกค้าปลีกของคุณทันที",
        },
      ],
    },
    caraAI: {
      overline: "Cara AI · วิศวกรรมอัจฉริยะ",
      heading: "AI ที่ออกแบบเพื่อ\nพื้นโรงงาน",
      body: "Cara ไม่สร้างภาพจินตนาการ แต่วิศวกรรมเครื่องประดับที่ทนทานต่อการหล่อ lost-wax การฝังอัญมณี และการสวมใส่ตลอดวัน — จากนั้นสร้างรายการวัสดุครบถ้วนก่อนที่คุณจะดื่มกาแฟหมดแก้ว",
      stats: [
        { value: "±0.15mm", label: "การชดเชยการหดตัวตามโลหะผสม" },
        { value: "0.6mm", label: "ความหนาผนังขั้นต่ำที่บังคับใช้" },
        { value: "4-Prong+", label: "การยึดอัญมณีที่ได้รับการออกแบบ" },
        { value: "R≥0.4mm", label: "รัศมีขอบสำหรับการสวมใส่ตลอดวัน" },
      ],
      cta: "ลอง Cara AI — สาธิตสด",
      ctaSecondary: "เรียนรู้เพิ่มเติม",
    },
    inspirePreview: {
      overline: "ค้นพบบน Inspire",
      heading: "เลื่อนดู บันทึก จัดหา",
      body: "ยินดีต้อนรับสู่ Caratzon Inspire — ฟีดค้นพบ B2B ของคุณ เรียกดูสตรีมผลงาน 3D CAD ที่ดีที่สุดในโลกที่คัดสรรแล้ว สร้างมูดบอร์ดของแบรนด์คุณ ติดตามนักสร้างสรรค์อิสระคนโปรด และเปลี่ยนจากแรงบันดาลใจสู่การผลิตในคลิกเดียว",
      cta: "สำรวจ Inspire",
    },
    designerBanner: {
      overline: "สำหรับนักออกแบบ",
      heading: "ไฟล์ CAD ของคุณสมควรได้\nพอร์ตโฟลิโอที่ดีกว่า",
      body: "เข้าร่วมเครือข่ายนักสร้างสรรค์ 3D ระดับโลกที่คัดสรร อัปโหลดแบบที่ผ่านการวิศวกรรมของคุณ และปลดล็อกพอร์ตโฟลิโอ Caratzon Inspire ระดับพรีเมียมโดยอัตโนมัติ ให้ AI เรนเดอร์ไฟล์ของคุณฟรี แสดงผลงานต่อผู้ซื้อปลีกที่ยืนยันแล้วหลายพันราย และรับค่าลิขสิทธิ์มาร์จินสูง",
      cta: "สมัครพอร์ตโฟลิโอนักออกแบบ",
    },
    footerCta: {
      overline: "พร้อมจัดหา",
      heading: "คอลเลกชันถัดไปของคุณ\nแพลตฟอร์มเดียว ไร้ช่องว่าง",
      cta: "เรียกดูแคตตาล็อกค้าส่ง",
      tradeOnly: "สำหรับบัญชีค้าส่งเท่านั้น",
    },
  },

  forDesigners: {
    meta: {
      title: "สำหรับนักออกแบบ · Caratzon",
      description:
        "เรื่องราวของคุณ เล่าโดย AI แบบของคุณ จัดแสดงทั่วโลก เข้าร่วม Caratzon Inspire — อัปโหลด CAD ตอบคำถามเกี่ยวกับงานฝีมือของคุณ แล้ว AI จะเขียนเรื่องราวนักออกแบบให้ รับ 80% ของค่าไลเซนส์ทุกครั้งพร้อมค่าลิขสิทธิ์ตลอดกาล",
    },
    hero: {
      overline: "สำหรับนักออกแบบเครื่องประดับอิสระ",
      h1Line1: "เรื่องราวของคุณ",
      h1Line2: "เล่าอย่างงดงาม",
      tagline:
        "ตอบคำถามเกี่ยวกับงานฝีมือ แรงบันดาลใจ และวิสัยทัศน์ของคุณ AI จะแปลงคำตอบเป็นเรื่องเล่านักออกแบบที่น่าดึงดูด — และนำผลงานของคุณไปถึงสายตาผู้ซื้อทั่วโลก",
      cta: "เป็นแรงบันดาลใจ →",
    },
    stats: {
      share: "ส่วนแบ่งค่าไลเซนส์ของคุณ",
      ipProtected: "IP ได้รับการคุ้มครอง",
      cadNote: "CAD ไม่ถูกส่งมอบให้ผู้ซื้อ",
      perpetual: "ตลอดกาล",
      royaltiesNote: "ค่าลิขสิทธิ์ต่อหน่วยที่ผลิต",
      zeroMarketing: "ไม่ต้องทำการตลาด",
      portfolioNote: "AI สร้างเรื่องราวของคุณ",
    },
    pain: {
      overline: "ความเป็นจริง",
      p1: "คุณเป็นนักออกแบบเครื่องประดับที่มีความสามารถ ผลงานของคุณเป็นต้นฉบับ สวยงาม และพร้อมสำหรับการผลิต",
      p2: "แต่เพื่อให้หาเลี้ยงชีพได้ คุณถูกบังคับให้เป็นผู้จัดการโซเชียลมีเดีย นักเขียนโฆษณา ช่างภาพไลฟ์สไตล์ และผู้ประสานงานโรงงาน ผลงานดีที่สุดของคุณนอนอยู่ในฮาร์ดไดรฟ์เพราะไม่มีเวลาหรือทุนเพียงพอที่จะทำตลาดถึงแบรนด์ B2B ทั่วโลก",
      quote: "เราสร้าง Caratzon เพื่อให้นักออกแบบเครื่องประดับที่มีพรสวรรค์ที่สุดในโลกสามารถมุ่งเน้นสิ่งที่ถนัดที่สุด — การออกแบบ",
      quoteAttribution: "— ทีมผู้ก่อตั้ง Caratzon",
    },
    inspire: {
      overline: "เป็นแรงบันดาลใจ",
      subtitle: "เรื่องราวของคุณ สร้างสรรค์โดย AI",
      heading: "เจ็ดคำถาม\nหนึ่งเรื่องราวที่ลืมไม่ลง",
      p1: "ในขั้นตอนออนบอร์ดดิ้ง เราจะถามเกี่ยวกับจุดเริ่มต้น ปรัชญา แรงบันดาลใจ และโลกทางอารมณ์เบื้องหลังผลงานของคุณ ไม่ใช่แบบฟอร์ม — แต่เป็นบทสนทนาเกี่ยวกับตัวตนของคุณในฐานะนักสร้างสรรค์",
      p2: "AI จะนำคำตอบของคุณไปสร้างโปรไฟล์นักออกแบบระดับนิตยสาร — หัวข้อข่าว เรื่องเล่า ส่วนเนื้อหาตามธีม และคีย์เวิร์ดเสียงของแบรนด์ เรื่องราวที่ทำให้ผู้ซื้อหยุดเลื่อนและติดต่อเข้ามา",
      previewLabel: "ตัวอย่าง AI",
      previewTitle: "Tension — โลกของ Aria",
      previewBody: "เธอออกแบบเครื่องประดับเหมือนสถาปนิกคิดเรื่องแสง — ไม่ใช่เพื่อตกแต่ง แต่เพื่อเผยให้เห็น",
      previewExtended:
        "ในสตูดิโอที่เต็มไปด้วยแสงแดดมองลงไปยังช่องแคบบอสฟอรัส Aria Atelier ทำงานที่จุดตัดของความแม่นยำและความเป็นธรรมชาติ ผลงานของเธอเริ่มจากภาพร่างสีน้ำบนกระดาษเนื้อหยาบ — เธอต้องรู้สึกถึงน้ำหนักก่อนจะสัมผัสหน้าจอ…",
      previewKeywords: ["ความตึง", "ทองคำ", "สถาปัตยกรรม", "วาบิ-ซาบิ", "ความมั่นใจที่เงียบ", "แสงบอสฟอรัส"],
      cta: "เป็นแรงบันดาลใจ →",
      features: [
        {
          label: "จุดเริ่มต้นของคุณ เสียงของคุณ",
          description: "เราจะถามว่าคุณมาเป็นนักออกแบบได้อย่างไร วัสดุอะไรที่ดึงดูดคุณ และอิทธิพลทางวัฒนธรรมใดที่หล่อหลอมสุนทรียภาพของคุณ คำพูดของคุณจะเป็นรากฐานของเรื่องราวสาธารณะ",
        },
        {
          label: "ปรัชญาและโลกภายใน",
          description: "ผู้สวมใส่เครื่องประดับของคุณควรรู้สึกอย่างไร? ความตึงเครียดเชิงสร้างสรรค์ใดที่กำหนดผลงานของคุณ? คำถามที่ลึกซึ้งเหล่านี้ให้ AI มีเนื้อสัมผัสทางจิตวิทยาเพื่อเขียนสิ่งที่ฟังดูเหมือนคุณ ไม่ใช่แม่แบบ",
        },
        {
          label: "เผยแพร่บน Inspire",
          description: "เรื่องราวที่ AI สร้างจะเผยแพร่บนหน้า Inspire ของคุณ — โปรไฟล์สาธารณะที่ผู้ซื้อ สื่อ และผู้ร่วมงานค้นพบได้ แก้ไขได้ตลอดเวลาจากแดชบอร์ด Studio ของคุณ",
        },
      ],
    },
    designOfWeek: {
      overline: "Design of the Week",
      subtitle: "คัดเลือกทุกสัปดาห์ จัดแสดงทั่วโลก",
      heading: "ได้รับคัดเลือกเป็น\nDesign of the Week",
      badgeLabel: "Design of the Week",
      featuredTitle: "แหวน Prismatic Petals",
      featuredAttribution: "โดย Aria Atelier · จัดแสดง 3 มีนาคม 2026",
      p1: "ทุกสัปดาห์ ทีมบรรณาธิการ Caratzon จะคัดเลือกหนึ่งแบบที่โดดเด่นเพื่อจัดแสดงบนแพลตฟอร์มทั้งหมด นักออกแบบที่ได้รับคัดเลือกจะได้ตำแหน่งเด่นบนหน้าแรก Inspire บทความบรรณาธิการเฉพาะ และการเปิดเผยโดยตรงต่อเครือข่ายผู้ซื้อทั้งหมดของเรา",
      p2: "Design of the Week ไม่ใช่แค่การเปิดเผย — แต่เป็นสัญญาณให้ผู้ซื้อว่าผลงานของคุณได้รับการยอมรับจากภัณฑารักษ์ที่มีวิจารณญาณที่สุดในอุตสาหกรรม การคัดเลือกในอดีตนำไปสู่ข้อตกลงไลเซนส์ การลงสื่อ และพันธมิตรแบรนด์ระยะยาว",
      benefits: [
        {
          label: "สปอตไลท์หน้าแรก",
          description: "แบบและเรื่องราวของคุณจะจัดแสดงอย่างโดดเด่นบนหน้าแรก Inspire เป็นเวลาเจ็ดวัน — สิ่งแรกที่ผู้ซื้อเห็นเมื่อเข้าแพลตฟอร์ม",
        },
        {
          label: "บทความบรรณาธิการ",
          description: "บทความบรรณาธิการเฉพาะที่สร้างจากเรื่องราว AI ของคุณ เสริมด้วยบริบทเกี่ยวกับแรงบันดาลใจของแบบ วัสดุ และแนวทางการผลิต",
        },
        {
          label: "การแจ้งเตือนเครือข่ายผู้ซื้อ",
          description: "ผู้ซื้อที่ใช้งานทุกรายบนแพลตฟอร์มจะได้รับการแจ้งเตือนที่คัดสรรเกี่ยวกับแบบของคุณ ท่อส่งตรงสู่การเจรจาไลเซนส์",
        },
      ],
    },
    platform: {
      overline: "แพลตฟอร์มทำงานอย่างไรสำหรับคุณ",
      subtitle: "ไม่ต้องลงแรง เข้าถึงได้สูงสุด",
      items: [
        {
          heading: "AI เล่าเรื่องราวของคุณ",
          body: "ตอบคำถามเกี่ยวกับงานฝีมือในขั้นตอนออนบอร์ดดิ้ง AI จะเขียนเรื่องเล่านักออกแบบ สร้างคีย์เวิร์ดเสียงแบรนด์ และเผยแพร่หน้า Inspire ของคุณ — พอร์ตโฟลิโอที่มีชีวิตซึ่งพัฒนาไปกับผลงาน",
        },
        {
          heading: "เข้าถึงผู้ซื้อทั่วโลกโดยตรง",
          body: "พอร์ตโฟลิโอที่สร้างโดยอัตโนมัติจะไปถึงสายตาผู้จัดการฝ่ายผลิตและผู้ซื้อของแบรนด์ค้าปลีกรายใหญ่ที่กำลังจัดหาอยู่ คุณไม่ต้องขาย พวกเขาเรียกดูโชว์เคสที่คัดสรรและพบคุณเอง",
        },
        {
          heading: "ไม่มีปัญหาเรื่องการผลิต",
          body: "เมื่อแบรนด์ซื้อแบบของคุณ คุณไม่ต้องพูดคุยกับโรงงานเลย แพลตฟอร์มจะส่งไฟล์อย่างปลอดภัยไปยังพันธมิตรผู้ผลิตที่ผ่านการตรวจสอบ เราจัดการเรื่องการหล่อ QC และโลจิสติกส์",
        },
        {
          heading: "การคุ้มครอง IP ที่แข็งแกร่ง",
          body: "ไฟล์ CAD ของคุณจะไม่ถูกแชร์กับผู้ซื้อ — ไม่ว่าจะไลเซนส์ประเภทใด แบรนด์จะได้รับเฉพาะสิทธิ์การผลิต ไฟล์ต้นฉบับจะส่งให้เฉพาะพันธมิตรผู้ผลิตที่ผ่านการตรวจสอบภายใต้ NDA เท่านั้น การโอนแบบจะเกิดขึ้นเฉพาะกรณีซื้อ IP ทั้งหมด",
        },
      ],
    },
    collections: {
      overline: "คอลเลกชัน + AI Storytelling",
      subtitle: "แบบของคุณสมควรได้มากกว่าการแสดงแบบตาราง",
      heading: "จัดกลุ่มผลงาน\nAI เล่าเรื่องราว",
      p1: "เลือกแบบที่เผยแพร่แล้วตั้งแต่สองชิ้นขึ้นไป AI จะค้นหาสิ่งที่เชื่อมโยงกัน — วัสดุร่วม อารมณ์ สุนทรียภาพ — และสร้างงานนำเสนอครบชุดจากแกนกลางนั้น",
      p2: "แบรนด์ไม่ได้เห็นแค่ชิ้นงานแต่ละชิ้น พวกเขาเห็นนักออกแบบที่มีวิสัยทัศน์สร้างสรรค์ที่สอดคล้องกันและผลงานที่เชื่อมโยงกัน นั่นคือสิ่งที่ทำให้พวกเขาติดต่อเข้ามา",
      features: [
        {
          label: "เสียงเดียวในทุกชิ้นงาน",
          description: "AI ระบุสายใยสร้างสรรค์ที่เชื่อมแบบของคุณ — จานสี อารมณ์ แรงบันดาลใจที่ร่วมกัน — เพื่อให้ผู้ซื้อเห็นวิสัยทัศน์ที่สอดคล้อง ไม่ใช่ไฟล์สุ่ม",
        },
        {
          label: "ผลงานของคุณเล่าเรื่องเดียวกัน",
          description: "เรื่องเล่าเดียวที่เอ่ยชื่อแต่ละแบบและเชื่อมโยงระหว่างกัน ผู้ซื้อเข้าใจแนวคิดเบื้องหลังคอลเลกชันก่อนจะสอบถาม",
        },
        {
          label: "ทุกคอลเลกชันพร้อมลง Vogue",
          description: "โชว์เคสระดับนิตยสารด้วยเทมเพลตบรรณาธิการที่สอดคล้อง — ภาพปก สปอตไลท์ชิ้นงาน และรูปลักษณ์ภาพที่เป็นหนึ่งเดียวในทุกคอลเลกชัน",
        },
      ],
      cta: "สำรวจคอลเลกชันใน Studio →",
    },
    badges: {
      premium: "พรีเมียม",
    },
    revenue: {
      overline: "รายได้ของคุณ สามทาง",
      subtitle: "สามวิธีในการรับรายได้",
      heading: "แบรนด์ซื้อสามวิธี\nคุณรับรายได้สามวิธี",
      footnote:
        "คุณรับ 80% ของค่าไลเซนส์ทุกครั้งในทั้งสามรูปแบบ Caratzon เก็บ 20% เพื่อครอบคลุมการดำเนินงานแพลตฟอร์ม การตลาด และการประสานงานการผลิต ไลเซนส์ Standard และ Seasonal Embargo จะได้รับค่าลิขสิทธิ์ตลอดกาลต่อหน่วยที่ผลิต — แบบของคุณยังคงสร้างรายได้นานหลังจากข้อตกลงแรก Full Exclusive Rights เป็นการซื้อขาด IP แบบเรียบง่าย: ไม่มีค่าลิขสิทธิ์ต่อเนื่อง เพียงค่าพรีเมียมครั้งเดียวในราคาขั้นต่ำที่คุณกำหนดเอง",
      models: [
        {
          tier: "Standard",
          label: "ไลเซนส์การผลิตแบบไม่จำกัดสิทธิ์",
          heading: "ไลเซนส์ Standard",
          description:
            "แบรนด์ไลเซนส์สิทธิ์ในการผลิตแบบของคุณผ่านเครือข่ายผู้ผลิตของ Caratzon ไม่จำกัดสิทธิ์ — หลายแบรนด์สามารถถือไลเซนส์ Standard พร้อมกันได้ คุณรับ 80% ของค่าไลเซนส์ทุกครั้งและค่าลิขสิทธิ์ตลอดกาลต่อหน่วยที่ผลิต",
          benefit: "80% เป็นของคุณ · ค่าลิขสิทธิ์ตลอดกาล · แบบยังอยู่ในตลาด",
        },
        {
          tier: "Premium",
          label: "สิทธิ์การผลิตพิเศษ 12 เดือน",
          heading: "Seasonal Embargo",
          description:
            "แบรนด์จ่ายพรีเมียมเพื่อระงับแบบของคุณ 12 เดือน ผลงานจะถูกซ่อนจากตลาดระหว่างช่วงแคมเปญ — คู่แข่งไม่สามารถผลิตได้ คุณรับ 80% ของค่าระงับและค่าลิขสิทธิ์ตลอดกาลต่อหน่วยที่ผลิต เมื่อหมดระยะ แบบจะกลับสู่ตลาดเปิด",
          benefit: "80% เป็นของคุณ · ค่าล่วงหน้าสูงกว่า · จำกัดระยะเวลา · ทำซ้ำได้",
        },
        {
          tier: "Vault",
          label: "สิทธิ์พิเศษทั้งหมด",
          heading: "สิทธิ์พิเศษทั้งหมด",
          description:
            "แบรนด์ได้รับความเป็นเจ้าของถาวรและรับไฟล์การผลิตดิบ (.STL / .3DM) โดยตรง แบบจะถูกลบออกจากตลาดอย่างถาวร คุณรับ 80% ของราคาพรีเมียมครั้งเดียวที่คุณกำหนดเอง ออกจากระบบอย่างเรียบร้อย: จ่ายครั้งเดียว แบบเกษียณ ไม่มีภาระผูกพันเพิ่มเติม",
          benefit: "80% เป็นของคุณ · คุณกำหนดราคาขั้นต่ำ · ออกจากระบบอย่างเรียบร้อย",
        },
      ],
    },
    steps: {
      overline: "จากออนบอร์ดดิ้งสู่รายได้",
      subtitle: "สามขั้นตอน",
      items: [
        {
          heading: "เป็นแรงบันดาลใจ",
          body: "ตอบคำถามเกี่ยวกับงานฝีมือ ปรัชญา และแรงบันดาลใจของคุณ AI จะสร้างเรื่องเล่านักออกแบบและเผยแพร่หน้า Inspire ของคุณ — โปรไฟล์นักสร้างสรรค์สาธารณะที่ผู้ซื้อค้นพบ อัปโหลด CAD ชิ้นแรกเพื่อทำพอร์ตโฟลิโอให้ครบ",
        },
        {
          heading: "AI สร้างแบรนด์ของคุณ",
          body: "Story Lab สร้างภาพถ่ายลุคบุ๊กระดับสตูดิโอและเรื่องเล่าบรรณาธิการสำหรับแต่ละชิ้นงาน จัดกลุ่มแบบเป็นคอลเลกชันแล้ว AI จะเขียนเรื่องราวรวม ได้รับคัดเลือกเป็น Design of the Week เพื่อการเปิดเผยสูงสุด",
        },
        {
          heading: "รับรายได้",
          body: "แบรนด์ค้นพบผลงานของคุณและขอไลเซนส์ คุณอนุมัติหรือเสนอเงื่อนไขตอบกลับ เมื่อยืนยันแล้ว การผลิตจะเริ่มอัตโนมัติ — 80% ของค่าไลเซนส์ได้รับการรับประกันก่อนที่จะหล่อแม้แต่กรัมเดียว พร้อมค่าลิขสิทธิ์ที่ไหลเข้ามาต่อทุกหน่วยที่ผลิต",
        },
      ],
    },
    bottomLine: {
      overline: "สรุป",
      p1: "งานของคุณคือสร้างสรรค์ AI เล่าเรื่องราวของคุณ แพลตฟอร์มขายผลงานของคุณ",
      p2: "ตั้งแต่คำถามออนบอร์ดดิ้งข้อแรกจนถึงข้อตกลงไลเซนส์แรก — เราดูแลเรื่องเล่า ภาพถ่าย การค้นพบโดยผู้ซื้อ และการผลิต คุณแค่ออกแบบ",
      shareLabel: "ของคุณ",
      shareNote:
        "80% ของค่าไลเซนส์ทุกครั้ง ค่าลิขสิทธิ์ตลอดกาลต่อหน่วยสำหรับ Standard และ Seasonal Embargo ค่าพรีเมียมครั้งเดียวที่คุณกำหนดราคาเองสำหรับ Full Exclusive Rights 20% ของ Caratzon สนับสนุนเครื่องมือการตลาดที่ขายงานของคุณในขณะที่คุณหลับ",
    },
    cta: {
      overline: "เป็นแรงบันดาลใจ",
      heading: "เรื่องราวของคุณ\nสปอตไลท์ของคุณ",
      primary: "เป็นแรงบันดาลใจ →",
      secondary: "เป็นนักออกแบบอยู่แล้ว? เปิด Studio →",
    },
  },

  forBrands: {
    meta: {
      title: "สำหรับแบรนด์ · Caratzon",
      description:
        "จัดหาแบบเครื่องประดับต้นฉบับจากนักสร้างสรรค์อิสระ — ทุกไลเซนส์รวม Essentials Kit พร้อมภาพถ่ายแคตตาล็อก สเปค และ SEO copy อัปเกรดเป็น Caratzon Kit สำหรับภาพถ่ายไลฟ์สไตล์ AI line sheet และสื่อโซเชียลมีเดีย เปิดตัวสู่ตลาดวันเดียวกับที่ไลเซนส์",
    },
    howItWorks: {
      meta: {
        title: "วิธีการทำงาน — Caratzon สำหรับแบรนด์",
        description: "จากการค้นพบสู่หน้าบ้าน — เรียกดูแบบต้นฉบับนักออกแบบ เลือกระดับไลเซนส์ และให้เครือข่ายผู้ผลิตจัดการการผลิตในขณะที่สื่อการตลาดเผยแพร่ทันที",
      },
      headline: "จากการค้นพบ\nสู่หน้าบ้าน",
      intro: "เรียกดูแบบต้นฉบับนักออกแบบที่ผ่านการยืนยัน เลือกไลเซนส์ของคุณ การผลิตจะผ่านเครือข่ายผู้ผลิตในขณะที่สื่อการตลาดเผยแพร่ทันที นี่คือวิธีการทำงานอย่างละเอียด",
    },
    hero: {
      overline: "สำหรับแบรนด์เครื่องประดับ · บูติก · ผู้จัดจำหน่าย",
      h1Line1: "คอลเลกชันถัดไปของคุณ",
      h1Line2: "ไม่มี R&D ไม่มีเอเจนซี่",
      h1Line3: "ไม่มีโรงงานให้จัดการ",
      tagline:
        "เรียกดูแบบต้นฉบับจากนักสร้างสรรค์อิสระ ไลเซนส์สิ่งที่คุณชอบ — ภาพถ่ายแคตตาล็อก สเปค และสื่อการตลาดมาพร้อมกับทุกชิ้น การผลิตผ่านเครือข่าย EPH ของเรา จัดหาถึงชั้นวาง แพลตฟอร์มเดียว",
      ctaPrimary: "เรียกดูแคตตาล็อกค้าส่ง",
      ctaSecondary: "ดูวิธีการทำงาน →",
    },
    marquee: {
      ariaLabel: "ตัวอย่างแคตตาล็อก",
    },
    badges: {
      fullIp: "FULL IP",
    },
    stats: {
      tiers: "ระดับการจัดหา",
      designerDirect: "ตรงจากนักออกแบบ",
      noIntermediaries: "ไม่มีตัวกลาง",
      contentReady: "สื่อการตลาดรวมอยู่",
      contentReadySub: "Essentials Kit มาพร้อมทุกไลเซนส์ · อัปเกรดเป็น Caratzon Kit ได้",
      productionManaged: "การผลิตมีการจัดการ",
      endToEnd: "ครบวงจร",
    },
    acquire: {
      overline: "รูปแบบการจัดหา",
      subtitle: "คอลเลกชันของคุณ เงื่อนไขของคุณ",
      heading: "สามวิธีในการจัดหา\nแบบ Caratzon",
      models: [
        {
          tier: "Standard",
          label: "ค่าเปิดใช้งานและสื่อ",
          heading: "ไลเซนส์ Standard",
          description:
            "นี่ไม่ใช่แค่ใบอนุญาต — แต่เป็นทางลัดที่คุ้มค่าหลายเท่า คุณซื้อแบบพร้อมผลิตพร้อม Essentials Kit: ภาพถ่ายพร้อมลงแคตตาล็อก SEO copy และสเปคเทคนิคครบถ้วน — ทุกอย่างที่ต้องการเพื่อลงสินค้าในร้านวันเดียวกับที่เซ็น อัปเกรดเป็น Caratzon Kit สำหรับภาพถ่ายไลฟ์สไตล์ line sheet และสื่อโซเชียลมีเดีย",
          gets: [
            "Essentials Kit รวมอยู่ — ภาพถ่ายพร้อมลงแคตตาล็อก เรื่องราวสินค้า SEO และสเปคสำหรับร้านของคุณ พร้อมในวันเดียวกัน",
            "อัปเกรดเป็น Caratzon Kit ได้ — ภาพถ่ายไลฟ์สไตล์ line sheet และสื่อโซเชียลมีเดีย",
            "เข้าถึงการผลิตทันที — แบบปลดล็อกในไลน์การผลิตของเราทันที",
            "ไม่มีค่า R&D — CAD ที่ผ่านการวิศวกรรมล่วงหน้าและตรวจสอบแล้วสำหรับการผลิตจำนวนมาก",
            "สิทธิ์เชิงพาณิชย์ — ติดแบรนด์ของคุณ ขายภายใต้ชื่อตัวเอง ไม่จำกัดระยะเวลา",
          ],
          benefit: "Essentials Kit รวมอยู่ · ข้าม R&D · เปิดตัววันเดียวกัน",
        },
        {
          tier: "Embargo",
          label: "สิทธิ์การผลิตพิเศษ 12 เดือน",
          heading: "Seasonal Embargo",
          description:
            "ล็อกแบบสำหรับแคมเปญถัดไปของคุณ สิทธิ์การผลิตพิเศษ 12 เดือน — ชิ้นงานจะถูกซ่อนจากตลาดจนกว่าระยะระงับจะหมด คู่แข่งไม่สามารถผลิตได้ในช่วงเวลาของคุณ เมื่อหมดระยะ แบบจะกลับสู่ตลาด",
          gets: [
            "ล็อกพิเศษ — คู่แข่งไม่สามารถผลิตได้ในช่วงเวลาของคุณ",
            "สิทธิประโยชน์ทั้งหมดของ Standard License รวมอยู่",
            "Essentials Kit รวมอยู่ — ภาพถ่ายและเรื่องราวแคตตาล็อกพิเศษ เป็นของคุณเท่านั้น 12 เดือน อัปเกรดเป็น Caratzon Kit ได้",
            "แบบถูกซ่อนจากตลาดตลอดระยะเวลาระงับ",
          ],
          benefit: "ป้องกันคู่แข่ง · เนื้อหาพิเศษ · ศักยภาพผลิตภัณฑ์หลัก",
        },
        {
          tier: "Vault",
          label: "สิทธิ์พิเศษทั้งหมด",
          heading: "สิทธิ์พิเศษทั้งหมด",
          description:
            "เป็นเจ้าของ IP ตลอดกาล ได้รับความเป็นเจ้าของถาวร — แบบจะถูกลบออกจากตลาดทันที คุณจะได้รับไฟล์การผลิตดิบ (.STL / .3DM) โดยตรงเมื่อชำระเงิน ไม่มีแบรนด์อื่นใดที่สามารถจัดหาแบบนี้ได้อีก นี่เป็นกรณีเดียวที่ไฟล์ต้นฉบับถูกโอน",
          gets: [
            "ความเป็นเจ้าของ IP ถาวร — แบบถูกถอนออกจากตลาด",
            "ไฟล์การผลิตดิบ (.STL / .3DM) โอนตรงถึงคุณ",
            "Caratzon Kit รวมอยู่ — ข้ามเอเจนซี่ สร้างภาพถ่ายไลฟ์สไตล์ line sheet และชุดโซเชียลไม่จำกัดด้วย AI ออกแบบตามแบรนด์ของคุณ",
            "ราคาขั้นต่ำกำหนดโดยนักออกแบบ — เจรจาขึ้นจากนั้น",
          ],
          benefit: "สิทธิ์พิเศษถาวร · Caratzon Kit รวมอยู่ · CAD ในมือ",
        },
      ],
      whyStandard: {
        label: "ทำไมต้องจ่ายค่า Standard License?",
        heading: "คุณไม่ได้จ่ายค่าใบอนุญาต คุณซื้อทางลัดมหาศาล",
        points: [
          {
            heading: "ข้ามค่า NRE",
            body: "ในการผลิตแบบดั้งเดิม แบบเดียวต้องจ่าย $500–$2,000+ ค่าออกแบบ 3D พิมพ์แว็กซ์ หล่อทดสอบ และแก้ไข ก่อนจะผลิตได้แม้แต่ชิ้นเดียว ไลเซนส์ Standard ทดแทนทั้งหมด — ไฟล์ผ่านการวิศวกรรมและทดสอบความเครียดแล้ว",
          },
          {
            heading: "Essentials Kit — ลงร้านวันนี้",
            body: "ทุก Standard License รวม Essentials Kit: ภาพถ่ายแคตตาล็อกความละเอียดสูง คำอธิบายสินค้าที่เพิ่มประสิทธิภาพ SEO และสเปคเทคนิคครบถ้วน — สร้างทันทีที่คุณไลเซนส์ ลงสินค้าในร้านวันเดียวกับที่เซ็น เมื่อพร้อมสำหรับชุดสร้างสรรค์ครบชุด อัปเกรดเป็น Caratzon Kit สำหรับภาพถ่ายไลฟ์สไตล์ AI line sheet ที่มีแบรนด์ และสื่อโซเชียลมีเดียพร้อมโพสต์",
          },
          {
            heading: "ติดแบรนด์ได้ ไม่มีความเสี่ยงทางกฎหมาย",
            body: "คุณได้รับสิทธิ์เชิงพาณิชย์เต็มรูปแบบในการขายภายใต้ชื่อแบรนด์ตัวเอง ในบรรจุภัณฑ์ของตัวเอง นักออกแบบตกลงที่จะไม่ดำเนินคดีด้านลิขสิทธิ์ สร้างธุรกิจบนงานศิลป์ของพวกเขาได้อย่างปลอดภัย",
          },
        ],
      },
      ipNotes: {
        standardLabel: "Standard License & Seasonal Embargo",
        standardBody:
          "ไฟล์การผลิตถูกรักษาความปลอดภัยโดย Caratzon และส่งมอบเฉพาะพันธมิตรผู้ผลิตที่ผ่านการตรวจสอบภายใต้ NDA เท่านั้น คุณจะไม่ได้รับ CAD ดิบ — การผลิตจะผ่านเครือข่ายของเราโดยอัตโนมัติ",
        vaultLabel: "สิทธิ์พิเศษทั้งหมด",
        vaultBody:
          "เมื่อชำระเงิน ไฟล์ .STL / .3DM พร้อมผลิตของนักออกแบบจะถูกโอนตรงถึงคุณ แบบจะถูกถอนออกจากแคตตาล็อกอย่างถาวร — ไม่มีแบรนด์อื่นที่สามารถจัดหาได้อีก",
      },
    },
    process: {
      overline: "วิธีการทำงาน",
      subtitle: "จากค้นพบสู่จัดส่ง",
      items: [
        {
          heading: "ค้นพบ",
          body: "เรียกดูแบบต้นฉบับนักออกแบบที่ผ่านการยืนยัน ดูตัวอย่าง Essentials Kit สำหรับทุกชิ้น — ภาพถ่ายแคตตาล็อก สเปค เรื่องราวบรรณาธิการ และ 3D viewer แบบอินเทอร์แอกทีฟ — ประเมินแพ็กเกจทั้งหมดก่อนตัดสินใจ",
        },
        {
          heading: "ไลเซนส์",
          body: "เลือกระดับของคุณ ส่งคำขอจัดหา เจรจาเงื่อนไขโดยตรงกับนักออกแบบ และล็อกไลเซนส์ มีเอกสารครบถ้วนและมีโครงสร้างทางกฎหมาย",
        },
        {
          heading: "ผลิต",
          body: "คำสั่งซื้อของคุณส่งไปยังเครือข่ายผู้ผลิต — การหล่อ การฝัง QC และโลจิสติกส์จัดการครบวงจร ในขณะที่การผลิตดำเนินไป Essentials Kit ของคุณเผยแพร่ในร้านแล้ว อัปเกรดเป็น Caratzon Kit เพื่อให้ภาพไลฟ์สไตล์ line sheet และสื่อโซเชียลเผยแพร่เช่นกัน โปรโมตก่อนสินค้าถึง",
        },
      ],
      quote: "\"จัดหาของแท้ ผลิตในระดับใหญ่\nไม่ต้องมีความสัมพันธ์กับโรงงาน\"",
      bullets: [
        "เครือข่ายผู้ผลิตที่ผ่านการตรวจสอบทั่วเอเชียและยุโรป",
        "การหล่อ การฝัง QC และโลจิสติกส์จัดการครบวงจร",
        "Essentials Kit มาพร้อมทุกไลเซนส์ — ภาพถ่ายแคตตาล็อก สเปค และ SEO copy",
        "อัปเกรด Caratzon Kit: ภาพถ่ายไลฟ์สไตล์ AI line sheet ที่มีแบรนด์ และสื่อโซเชียลมีเดียตามต้องการ",
      ],
      teaserItems: [
        { heading: "ค้นพบ", body: "เรียกดูแบบต้นฉบับนักออกแบบที่ผ่านการยืนยันพร้อมตัวอย่างครบถ้วน" },
        { heading: "ไลเซนส์", body: "เลือกระดับและล็อกสิทธิ์เชิงพาณิชย์ของคุณ" },
        { heading: "ผลิต", body: "การผลิตจัดการครบวงจรในขณะที่สื่อของคุณเผยแพร่แล้ว" },
      ],
      teaserCta: "ดูวิธีการทำงาน →",
    },
    vs: {
      overline: "เทียบกับค้าส่งแบบดั้งเดิม",
      traditional: "แบบดั้งเดิม",
      caratzon: "Caratzon",
      rows: [
        ["ที่มา", "ไม่ทราบแหล่งที่มา ห่วงโซ่หลายชั้น", "ตรงจากนักออกแบบอิสระที่ผ่านการยืนยัน"],
        [
          "ค่า R&D / NRE",
          "$500–$2,000+ ต่อแบบ (นักออกแบบ 3D พิมพ์แว็กซ์ หล่อทดสอบ แก้ไข)",
          "ศูนย์ — ผ่านการวิศวกรรมและตรวจสอบแล้วสำหรับการผลิตจำนวนมาก",
        ],
        [
          "ระยะเวลาสู่ตลาด",
          "หลายสัปดาห์ของวิศวกรรม + ทำตัวอย่างก่อนลงสินค้าได้",
          "ไลเซนส์วันนี้ ลงร้านวันนี้ — Essentials Kit รวมอยู่ทันที",
        ],
        [
          "สื่อการตลาด",
          "จ้างช่างภาพ สไตลิสต์ และนักเขียน — หลายสัปดาห์และหลายพันต่อคอลเลกชัน",
          "Essentials Kit รวมอยู่ทันที Caratzon Kit (ไลฟ์สไตล์ โซเชียล line sheet) ที่ AI สร้างพร้อมใช้ตามต้องการ",
        ],
        [
          "สิทธิ์เชิงพาณิชย์",
          "เจรจาแยก มักไม่ชัดเจน",
          "สิทธิ์ติดแบรนด์รวมอยู่ — ขายภายใต้แบรนด์ตัวเองไม่จำกัดระยะเวลา",
        ],
        [
          "สิทธิ์พิเศษ",
          "ไม่มีกลไกป้องกันคู่แข่ง",
          "Standard, Seasonal Embargo (12 เดือน) หรือ Full Exclusive Rights (ถาวร)",
        ],
        [
          "การผลิต",
          "จัดการความสัมพันธ์กับโรงงานเอง",
          "ส่งผ่านเครือข่ายผู้ผลิตของเราโดยอัตโนมัติ",
        ],
      ],
    },
    studio: {
      overline: "Caratzon Studio",
      heading: "จัดหาแบบ\nเราสร้างสื่อการตลาดให้",
      intro:
        "การจัดหาสินค้าใหม่เคยหมายถึงการรอหลายสัปดาห์เพื่อให้ตัวอย่างมาถึงเพื่อถ่ายรูป ด้วย Caratzon Studio สื่อการตลาดของคุณจะถูกสร้างทันทีที่คุณไลเซนส์ เลือกกลยุทธ์เปิดตัวของคุณ:",
      essentials: {
        heading: "Essentials Kit",
        badge: "รวมอยู่ในทุกไลเซนส์",
        body: "ข้ามการกรอกข้อมูล รับสเปคพร้อมผลิต ภาพถ่ายแคตตาล็อกคมชัด และ SEO copy ที่สร้างทันทีเมื่อคุณไลเซนส์ พื้นฐานที่สมบูรณ์แบบเพื่อลงสินค้าใหม่ในร้านวันนี้",
        features: [
          "ภาพถ่ายอีคอมเมิร์ซความละเอียดสูง พื้นหลังขาว",
          "คำอธิบายสินค้าที่เพิ่มประสิทธิภาพ SEO",
          "สเปคเทคนิคและวัสดุครบถ้วน",
        ],
      },
      caratzonKit: {
        heading: "Caratzon Kit",
        badge: "อัปเกรดเปิดตัวระดับพรีเมียม",
        body: "ข้ามการถ่ายรูป แทนที่เอเจนซี่สร้างสรรค์ทั้งหมดด้วยคลิกเดียว รับโลโก้ สีแบรนด์ และสุนทรียภาพของคุณรวมเข้าในภาพไลฟ์สไตล์ line sheet และชุดโซเชียลมีเดียอย่างลงตัว",
        features: [
          "ภาพถ่ายไลฟ์สไตล์และนางแบบที่ AI สร้าง",
          "PDF line sheet ค้าส่งจัดรูปแบบอัตโนมัติตามแบรนด์ของคุณ",
          "สื่อโซเชียลมีเดียพร้อมโพสต์ (ครอป Reels/TikTok & แคปชัน)",
        ],
      },
    },
    caraAI: {
      overline: "Cara AI · วิศวกรรมอัจฉริยะ",
      heading: "ไม่ใช่เครื่องมือสร้างภาพ\nแต่เป็น AI วิศวกรรมเครื่องประดับ",
      intro: "AI ส่วนใหญ่สร้างภาพสวย Cara สร้างแบบที่อยู่รอดในพื้นโรงงานและรู้สึกดีบนมือ ผลลัพธ์ไม่ใช่มูดบอร์ด — แต่เป็นพิมพ์เขียวพร้อมผลิตพร้อมรายการวัสดุครบถ้วน",
      pillars: [
        {
          stat: "±0.15mm",
          label: "การชดเชยการหดตัว",
          body: "Cara คำนวณอัตราการหดตัวเฉพาะโลหะในการหล่อ lost-wax — ทอง เงิน แพลทินัม ทองเหลือง — เพื่อให้ชิ้นงานสุดท้ายตรงกับโมเดลดิจิทัล ไม่ใช่เวอร์ชันที่หดลง",
        },
        {
          stat: "0.6mm",
          label: "ความหนาผนังขั้นต่ำ",
          body: "ทุกรูปทรงที่สร้างเคารพความหนาผนังขั้นต่ำเฉพาะโลหะ — 0.6mm สำหรับแพลทินัม 0.8mm สำหรับทองและเงิน ไม่มีเขี้ยวบาง ไม่มีกรอบพับ แบบมีความแข็งแรงเชิงโครงสร้างก่อนถึงช่างหล่อ",
        },
        {
          stat: "4-Prong+",
          label: "การแมปค่าเผื่ออัญมณี",
          body: "Cara คำนวณตำแหน่งเขี้ยว ความลึกที่นั่ง และระยะห่างเอวสำหรับทุกชนิดและการเจียระไนของอัญมณี การฝังได้รับการออกแบบเพื่อยึดมั่นคงในการใช้งานประจำวัน — ไม่ใช่แค่ดูน่าเชื่อถือ",
        },
        {
          stat: "R≥0.4mm",
          label: "การสวมใส่และความรู้สึกบนมือ",
          body: "Cara ประเมินโปรไฟล์แหวน ความโค้งด้านใน การกระจายน้ำหนัก และรัศมีขอบเพื่อให้ทุกชิ้นรู้สึกดีเท่ากับที่ดูดี ขอบคม น้ำหนักเอียง และจุดหนีบถูกระบุก่อนออกจากหน้าจอ",
        },
      ],
      capabilities: [
        { label: "กลศาสตร์การหล่อ", detail: "ตำแหน่ง sprue ขนาด gate และการวิเคราะห์การไหลสำหรับการหล่อที่ไร้ข้อบกพร่อง" },
        { label: "การวิเคราะห์โครงสร้าง", detail: "ตรวจสอบความหนาผนังและการกระจายน้ำหนักภายใต้ความเครียดทั่วทั้งชิ้นงาน" },
        { label: "รายการวัสดุ", detail: "น้ำหนักโลหะที่แม่นยำ จำนวนอัญมณี และการประมาณต้นทุนตั้งแต่ขั้นตอนแนวคิด" },
        { label: "ความรู้โลหะผสม", detail: "คุณสมบัติเฉพาะวัสดุสำหรับทอง 10K–24K เงิน 925 แพลทินัม 950 และทองเหลือง" },
        { label: "ความพร้อมสำหรับการผลิต", detail: "ทุกผลลัพธ์ถูกประเมินเทียบกับค่าเผื่อการผลิตจริงของ EPH" },
        { label: "สะพาน Sketch-to-CAD", detail: "อัปโหลดภาพร่างบนกระดาษ — Cara สกัดรูปทรงและวิศวกรรมเพื่อการผลิต" },
      ],
      closing: "แนวคิดที่ Cara วิศวกรรมได้รับการออกแบบเพื่อหล่อได้ถูกต้องตั้งแต่ครั้งแรก — ไม่ต้องทำซ้ำ ไม่เสียแว็กซ์ ไม่ถูกปฏิเสธจากโรงงาน เมื่อผู้ซื้อเห็นแนวคิดของ Cara พวกเขากำลังดูชิ้นงานที่ผ่านการทดสอบความเครียดกับข้อจำกัดเดียวกันที่ผู้ผลิตจะบังคับใช้ นั่นคือความแตกต่างระหว่าง AI สร้างภาพและ AI วิศวกรรม",
      tryCara: "ลอง Cara AI — สาธิตสด",
      learnMore: "เรียนรู้เพิ่มเติม",
    },
    cta: {
      overline: "เริ่มจัดหา",
      heading: "เรียกดู\nแคตตาล็อกค้าส่ง",
      body: "ทุก Standard License รวม Essentials Kit — ภาพถ่ายแคตตาล็อก สเปค และ SEO copy พร้อมทันที อัปเกรดเป็น Caratzon Kit สำหรับภาพถ่ายไลฟ์สไตล์ line sheet และสื่อโซเชียลมีเดีย เรียกดู ประเมินใน 3D และเปิดตลาดได้เร็วกว่าไลน์ดั้งเดิม",
      primary: "เรียกดูแบบ",
      secondary: "ดูวิธีการทำงาน",
      tradeOnly: "สำหรับบัญชีค้าส่งเท่านั้น",
    },
  },

  forManufacturers: {
    meta: {
      title: "การผลิต · Caratzon",
      description:
        "ทุกคำสั่งซื้อ Caratzon ผลิตที่ EPH — ศูนย์การผลิตเครื่องประดับครบวงจรที่ใหญ่ที่สุดในจีน ผู้ผลิต 5,000+ ราย การชุบที่ได้รับการรับรอง ตรวจสอบย้อนกลับครบถ้วนจาก CAD สู่การจัดส่ง",
    },
    hero: {
      overline: "การผลิต · ศูนย์ EPH",
      h1Line1: "หนึ่งศูนย์",
      h1Line2: "ทุกความสามารถ",
      h1Line3: "ผู้ผลิต 5,000+ ราย",
      tagline:
        "ทุกคำสั่งซื้อ Caratzon ผ่าน EPH — ศูนย์การผลิตเครื่องประดับครบวงจรที่ใหญ่ที่สุดในจีน ผู้ผลิต 5,000+ รายภายใต้หลังคาเดียว การชุบรักษ์สิ่งแวดล้อมที่ได้รับอนุญาต และตรวจสอบย้อนกลับครบถ้วนจากไฟล์ CAD สู่ชิ้นงานสำเร็จ",
      cta: "เรียกดูแคตตาล็อก",
    },
    stats: {
      cadReady: "5,000+",
      everyOrder: "ผู้ผลิตภายใต้หลังคาเดียว",
      phases: "ครบห่วงโซ่",
      milestone: "หล่อ · ฝัง · ขัด · ชุบ · QC",
      ecoPlating: "ใบอนุญาตรักษ์สิ่งแวดล้อม",
      ephCertified: "ศูนย์บำบัดน้ำเสีย",
      fullTrace: "ตรวจสอบครบถ้วน",
      clientVis: "จากพิมพ์แว็กซ์ถึงจัดส่ง",
    },
    orderContents: {
      overline: "ชิ้นงานของคุณผลิตอย่างไร",
      subtitle: "จากไฟล์สู่ชิ้นงานสำเร็จ",
      items: [
        {
          heading: "CAD สู่พิมพ์แว็กซ์",
          body: "ไฟล์การผลิตของคุณส่งไปยัง EPH ที่ซึ่งจะถูกแปลงเป็นแม่พิมพ์แว็กซ์ — ขั้นตอนแรกจากการออกแบบดิจิทัลสู่ชิ้นงานจริง",
        },
        {
          heading: "การหล่อและการฝัง",
          body: "การหล่อ lost-wax การฝังอัญมณี และการประกอบเกิดขึ้นในศูนย์เดียว ไม่มีการส่งต่อระหว่างโรงงาน ไม่มีค่าเผื่อที่สูญหาย",
        },
        {
          heading: "การชุบและการตกแต่งรักษ์สิ่งแวดล้อม",
          body: "การชุบทอง โรเดียม และโลหะผสมบนสายการผลิตรักษ์สิ่งแวดล้อมที่ได้รับอนุญาตพร้อมระบบบำบัดน้ำเสียในสถานที่ การขัดเงาและตกแต่งตามสเปค",
        },
        {
          heading: "QC และจัดส่ง",
          body: "การควบคุมคุณภาพหลายจุดก่อนจัดส่ง ความคืบหน้าการผลิตเห็นได้บนแดชบอร์ด ใบนำส่งออกเมื่อเสร็จสิ้น",
        },
      ],
    },
    workflow: {
      overline: "ขั้นตอนการผลิต",
      subtitle: "คำสั่งซื้อของคุณ ทีละขั้นตอน",
      phases: [
        ["ยืนยันคำสั่งซื้อ", "แบบของคุณเข้าคิวการผลิต EPH"],
        ["NRE และหล่อทดสอบ", "ผลิตพิมพ์แว็กซ์ ส่งตัวอย่างเพื่ออนุมัติ"],
        ["การหล่อ", "เทโลหะ ตรวจสอบน้ำหนักและโลหะผสม"],
        ["การฝังและการประกอบ", "ฝังอัญมณี ตรวจสอบค่าเผื่อ ประกอบชิ้นส่วน"],
        ["การชุบและการตกแต่ง", "ชุบรักษ์สิ่งแวดล้อมที่ได้รับการรับรองตามสเปคของคุณ"],
        ["QC และจัดส่ง", "ตรวจสอบหลายจุดขั้นสุดท้าย ออกใบนำส่ง"],
      ],
    },
    eph: {
      overline: "ศูนย์การผลิต EPH",
      location: "จีน",
      headline: "ผู้ผลิต 5,000+ ราย หลังคาเดียว ห่วงโซ่อุปทานครบถ้วน",
      body: "EPH คือศูนย์การผลิตเครื่องประดับครบวงจรที่ใหญ่ที่สุดในจีน — และเป็นศูนย์ผลิตเฉพาะสำหรับทุกคำสั่งซื้อ Caratzon ด้วยระบบบำบัดน้ำเสียที่ได้รับอนุญาต สายชุบรักษ์สิ่งแวดล้อมที่ผ่านการรับรอง และห่วงโซ่การผลิตครบวงจรภายใต้หลังคาเดียว EPH กำหนดมาตรฐานการผลิตเครื่องประดับอย่างยั่งยืนในระดับใหญ่",
      attrs: [
        {
          label: "ห่วงโซ่อุปทานครบวงจร",
          body: "การหล่อ การฝัง การขัดเงา และการชุบในศูนย์เดียว ไม่มีโลจิสติกส์ข้ามโรงงาน ไม่มีการส่งต่อที่สูญหาย",
        },
        {
          label: "การชุบรักษ์สิ่งแวดล้อมที่ได้รับอนุญาต",
          body: "การตกแต่งทอง โรเดียม และโลหะผสมบนสายที่ได้รับการรับรองพร้อมระบบบำบัดน้ำเสียในสถานที่ — การปล่อยสารเคมีที่ได้รับการตรวจสอบว่าลดลง",
        },
        {
          label: "ขนาดและความเชี่ยวชาญ",
          body: "ผู้ผลิต 5,000+ รายที่มีความเชี่ยวชาญเฉพาะทางลึกในทุกหมวดเครื่องประดับ ตั้งแต่เครื่องประดับเจ้าสาวถึงโอตกูตูร์",
        },
        {
          label: "การเชื่อมต่อดิจิทัลโดยตรง",
          body: "ไฟล์ CAD ส่งตรงจากแพลตฟอร์ม Caratzon เข้าคิวการผลิต EPH — ไม่มีการกรอกข้อมูลใหม่ด้วยมือ ตรวจสอบย้อนกลับครบถ้วน",
        },
      ],
    },
    cta: {
      overline: "ดูแคตตาล็อก",
      heading: "ดูสิ่งที่เรา\nสามารถผลิตได้",
      primary: "เรียกดูแคตตาล็อก",
      secondary: "สมัครเป็นผู้ผลิต →",
    },
    inquiryForm: {
      overline: "ใบสมัครพันธมิตร",
      heading: "สมัครเข้าร่วม\nเครือข่ายผู้ผลิต",
      subtitle:
        "บอกเราเกี่ยวกับโรงงานและความสามารถของคุณ ทีมพันธมิตรจะตรวจสอบใบสมัครและตอบกลับภายใน 3 วันทำการ",
      companyName: "ชื่อบริษัท / โรงงาน",
      contactName: "ชื่อผู้ติดต่อหลัก",
      email: "อีเมลธุรกิจ",
      phone: "หมายเลขโทรศัพท์",
      website: "เว็บไซต์บริษัท",
      location: "ที่ตั้งโรงงาน (เมือง, ประเทศ)",
      capabilities: "ความสามารถการผลิต",
      capabilitiesHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
      capabilityOptions: [
        "การหล่อ",
        "การฝังอัญมณี",
        "การชุบ",
        "การขัดเงา",
        "CAD/CAM",
        "CNC",
        "การประกอบ",
        "การแกะสลัก",
        "การลงยา",
        "QC / การตรวจสอบ",
      ],
      specializations: "ความเชี่ยวชาญเครื่องประดับ",
      specializationsHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
      specializationOptions: [
        "แหวน",
        "ต่างหู",
        "สร้อยคอ",
        "กำไล",
        "เครื่องประดับเจ้าสาว",
        "เครื่องประดับผู้ชาย",
        "นาฬิกา",
        "สั่งทำพิเศษ",
      ],
      certifications: "ใบรับรอง",
      certificationsHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
      certificationOptions: [
        "RJC",
        "ISO 9001",
        "ISO 14001",
        "Hallmark",
        "Fairmined",
        "BSCI / Sedex",
      ],
      productionCapacity: "กำลังการผลิตต่อเดือน (ชิ้น)",
      capacityOptions: [
        "ต่ำกว่า 500",
        "500 – 2,000",
        "2,000 – 10,000",
        "10,000 – 50,000",
        "50,000+",
      ],
      additionalInfo: "ข้อมูลเพิ่มเติม",
      additionalInfoPlaceholder:
        "สิ่งอื่นที่คุณต้องการให้เราทราบ — ความเชี่ยวชาญพิเศษ ระยะเวลาการส่งมอบ พันธมิตรปัจจุบัน ฯลฯ",
      submit: "ส่งใบสมัคร",
      submitting: "กำลังส่ง…",
      successHeading: "ได้รับใบสมัครแล้ว",
      successBody:
        "ขอบคุณที่สนใจเข้าร่วมเครือข่ายผู้ผลิตของ Caratzon ทีมพันธมิตรจะตรวจสอบใบสมัครของคุณและติดต่อกลับภายใน 3 วันทำการ",
      errorRequired: "กรุณากรอกข้อมูลที่จำเป็นทั้งหมด",
      errorEmail: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
      errorSend: "เกิดข้อผิดพลาด กรุณาลองอีกครั้งหรือส่งอีเมลถึงเราโดยตรง",
    },
  },

  partnerApplication: {
    meta: {
      title: "ใบสมัครพันธมิตร · Caratzon",
      description:
        "สมัครเข้าร่วมเครือข่ายผู้ผลิต Caratzon บอกเราเกี่ยวกับโรงงาน ความสามารถ และใบรับรองของคุณ",
    },
  },

  contact: {
    meta: {
      title: "ติดต่อเรา · Caratzon",
      description:
        "ติดต่อทีม Caratzon พูดคุยกับ Trade Desk ของเรา เชื่อมต่อในฐานะนักออกแบบ หรือส่งคำถามทั่วไป",
    },
    overline: "ติดต่อ",
    heading: "ติดต่อ Caratzon",
    subtitle:
      "ไม่ว่าคุณจะเป็นแบรนด์ค้าปลีกที่ต้องการจัดหาแบบพิเศษ หรือวิศวกร 3D CAD ที่ต้องการสร้างรายได้จาก IP ทีมระดับโลกของเราพร้อมช่วยเหลือ",
    tabs: {
      brand: "ฉันเป็นแบรนด์ / ร้านค้าปลีก",
      designer: "ฉันเป็นนักออกแบบ",
      general: "ทั่วไป / สื่อ / นักลงทุน",
    },
    brand: {
      headline: "พูดคุยกับ Trade Desk ของเรา",
      copy: "พร้อมข้าม R&D และเพิ่มประสิทธิภาพการผลิต? เชื่อมต่อกับผู้เชี่ยวชาญด้านการจัดหาเพื่อหารือเกี่ยวกับการเข้าถึงแพลตฟอร์ม ปริมาณระดับองค์กร หรือความสามารถการผลิต EPH ของเรา",
      firstName: "ชื่อ",
      lastName: "นามสกุล",
      workEmail: "อีเมลที่ทำงาน",
      companyName: "ชื่อบริษัท / แบรนด์",
      companyWebsite: "เว็บไซต์บริษัท",
      helpWith: "เราช่วยอะไรได้บ้าง?",
      helpOptions: [
        "อัปเกรดเป็นแพลน Source / Atelier",
        "การจัดหาปริมาณระดับองค์กร",
        "ความสามารถการผลิต EPH",
        "สาธิต Caratzon Studio AI",
        "คำถามทั่วไปเกี่ยวกับแพลตฟอร์ม",
      ] as readonly string[],
      selectPlaceholder: "เลือกหัวข้อ…",
      message: "ข้อความ",
      messagePlaceholder: "บอกเราเกี่ยวกับความต้องการการจัดหา ไทม์ไลน์ หรือคำถามเฉพาะ…",
      submit: "ส่งข้อความ",
      submitting: "กำลังส่ง…",
    },
    designer: {
      headline: "เข้าร่วมเครือข่ายนักออกแบบ Caratzon",
      copy: "สร้างรายได้จากแบบเครื่องประดับ 3D CAD ของคุณผ่านตลาดไลเซนส์ระดับโลก อัปโหลดพอร์ตโฟลิโอ กำหนดเงื่อนไข และให้แบรนด์มาหาคุณ",
      firstName: "ชื่อ",
      lastName: "นามสกุล",
      email: "ที่อยู่อีเมล",
      portfolioUrl: "URL พอร์ตโฟลิโอ / Behance / Instagram",
      cadSoftware: "ซอฟต์แวร์ CAD หลัก",
      cadOptions: [
        "Rhino / Grasshopper",
        "Matrix / MatrixGold",
        "ZBrush",
        "Blender",
        "SolidWorks",
        "อื่น ๆ",
      ] as readonly string[],
      selectPlaceholder: "เลือกเครื่องมือหลักของคุณ…",
      designCount: "จำนวนแบบโดยประมาณ",
      designCountOptions: [
        "1–10",
        "11–50",
        "51–200",
        "200+",
      ] as readonly string[],
      designCountPlaceholder: "เลือกช่วง…",
      message: "เล่าเกี่ยวกับผลงานของคุณ",
      messagePlaceholder: "อธิบายสไตล์การออกแบบ ความเชี่ยวชาญเฉพาะทาง และสิ่งที่คุณมองหาในพันธมิตรไลเซนส์…",
      submit: "สมัครเป็นนักออกแบบ",
      submitting: "กำลังส่ง…",
    },
    general: {
      headline: "คำถามทั่วไป",
      copy: "สำหรับสื่อ พันธมิตร หรือนักลงทุนสัมพันธ์ กรุณาติดต่อทีมองค์กรของเรา",
      name: "ชื่อ",
      email: "ที่อยู่อีเมล",
      topic: "หัวข้อ",
      topicOptions: [
        "สื่อมวลชน",
        "นักลงทุนสัมพันธ์",
        "พันธมิตร",
        "อื่น ๆ",
      ] as readonly string[],
      selectPlaceholder: "เลือกหัวข้อ…",
      message: "ข้อความ",
      messagePlaceholder: "เราช่วยอะไรได้บ้าง?",
      submit: "ส่งคำถาม",
      submitting: "กำลังส่ง…",
    },
    success: {
      heading: "ได้รับข้อความแล้ว",
      body: "ขอบคุณที่ติดต่อเรา สมาชิกในทีมจะตอบกลับภายใน 24 ชั่วโมง ในระหว่างนี้ เชิญสำรวจแพลตฟอร์ม",
      backToHome: "กลับหน้าแรก",
      explorePlatform: "สำรวจแพลตฟอร์ม →",
    },
    errors: {
      required: "กรุณากรอกข้อมูลที่จำเป็นทั้งหมด",
      invalidEmail: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
      sendFailed: "เกิดข้อผิดพลาด กรุณาลองอีกครั้งหรือส่งอีเมลถึงเราโดยตรงที่ hello@caratzon.com",
    },
    offices: {
      heading: "สำนักงานทั่วโลก",
      hongkong: { city: "ฮ่องกง", label: "Trade Desk เอเชียแปซิฟิก" },
      guangdong: { city: "กวางตุ้ง", label: "สำนักงานใหญ่การผลิตและปฏิบัติการ" },
      london: { city: "ลอนดอน", label: "Trade Desk ยุโรป" },
    },
  },

  about: {
    meta: {
      title: "เกี่ยวกับ Caratzon — เรื่องราวของเรา",
      description:
        "Caratzon คือระบบนิเวศสองฝั่งระดับโลกที่เชื่อมนักออกแบบเครื่องประดับอิสระกับการผลิตระดับโลก เรียนรู้ว่าเรากำลังเปลี่ยนแปลงห่วงโซ่อุปทานเครื่องประดับอย่างไร",
    },
    hero: {
      overline: "เกี่ยวกับ Caratzon · ก่อตั้ง 2024",
      h1Line1: "ที่ซึ่งการออกแบบ",
      h1Line2: "อันยอดเยี่ยม",
      h1Line3: "พบกับการผลิตที่สมบูรณ์แบบ",
      tagline:
        "Caratzon เกิดจากอีเมลเดียวที่สูญหายซึ่งเกือบทำให้แบรนด์เครื่องประดับสูญเสียฤดูกาลวันหยุดทั้งหมด วันนี้ เราเป็นระบบนิเวศสองฝั่งระดับโลกที่เชื่อมนักออกแบบอิสระผู้มีพรสวรรค์กับการผลิตระดับโลกที่มีการจัดการครบถ้วน",
      lastUpdated: "อัปเดตล่าสุด กุมภาพันธ์ 2026",
    },
    stats: {
      overline: "ขนาดแพลตฟอร์ม",
      subtitle: "ตัวเลข",
      items: [
        { value: "10,000+", label: "แบบ CAD พิเศษ" },
        { value: "150+", label: "พันธมิตรผู้ผลิตที่ผ่านการตรวจสอบ" },
        { value: "1M+", label: "โหนดการผลิตที่ประสานงาน" },
        { value: "$50M+", label: "สร้างรายได้ให้นักสร้างสรรค์" },
        { value: "0", label: "ความล่าช้าห่วงโซ่อุปทานแบบกล่องดำ" },
      ],
    },
    origin: {
      overline: "จุดกำเนิด",
      subtitle: "ทุกแพลตฟอร์มมีจุดเริ่มต้น",
      p1: "ทุกวัน Caratzon เสริมพลังนักสร้างสรรค์ในการสร้างรายได้จากงานศิลป์ และช่วยให้แบรนด์ B2B จัดหาคอลเลกชันใหม่พิเศษ — ด้วยความมั่นใจในห่วงโซ่อุปทานแบบโหนดที่โปร่งใส",
      p2: "เราดำรงอยู่เพื่อขจัดความเสี่ยงและอุปสรรคของการจัดหาระดับโลก เมื่อแบรนด์ตกหลุมรักแบบบนแพลตฟอร์ม พวกเขาไม่ต้องหาวิธีผลิตเอง Caratzon จัดการวิศวกรรม CAD การสร้างต้นแบบ โลจิสติกส์หลายซัพพลายเออร์ การควบคุมคุณภาพ และการจัดส่งสุดท้าย — ครบวงจร",
      digitalDesign: "การออกแบบดิจิทัล",
      precisionCraft: "งานฝีมือความแม่นยำ",
    },
    timeline: {
      overline: "เรื่องราว Caratzon",
      subtitle: "สี่ช่วง",
      phases: [
        {
          heading: "ห่วงโซ่ที่แตกหัก",
          subheading: "จุดเริ่มต้นของเรื่องราว",
          label: "ปัญหา",
          body: "เริ่มจากชิ้นงานหลายส่วนที่ออกแบบอย่างยอดเยี่ยมซึ่งต้องการแซฟไฟร์เจียระไนพิเศษ การหล่อ lost-wax ที่แม่นยำ และการชุบโรเดียมเฉพาะทาง การส่งไฟล์ CAD ไปยังโรงงานสามแห่งในสองทวีปส่งผลให้เกิดความล่าช้ามหาศาล — เนื่องจากปัญหารูพรุนเล็กน้อยที่โรงงานพยายามซ่อน เห็นได้ชัดว่าการพึ่งพาใบแจ้งหนี้ PDF อัปเดตทาง WhatsApp และความเชื่อใจแบบตาบอดของอุตสาหกรรมเครื่องประดับนั้นไม่ยั่งยืน",
        },
        {
          heading: "ผู้มีพรสวรรค์ที่ถูกกักขัง",
          subheading: "ช่องว่างตลาดที่ซ่อนอยู่ตรงหน้า",
          label: "ข้อค้นพบ",
          body: "ในเวลาเดียวกัน เราตระหนักถึงช่องว่างมหาศาลในตลาด นักออกแบบเครื่องประดับอิสระที่มีพรสวรรค์มีฮาร์ดไดรฟ์เต็มไปด้วย 3D CAD ที่สวยงาม แต่ไม่มีความสัมพันธ์กับโรงงานหรือทุนในการผลิตเลย ในขณะที่แบรนด์ค้าปลีก B2B ขนาดใหญ่กระหายสุนทรียภาพใหม่แต่หวาดกลัวความเสี่ยงในการผลิตจากนักสร้างสรรค์ที่ไม่รู้จัก ศิลปะและโลจิสติกส์ขัดแย้งกันโดยพื้นฐาน",
        },
        {
          heading: "สร้างระบบปฏิบัติการ",
          subheading: "วิศวกรรมระบบประสาทส่วนกลาง",
          label: "การสร้าง",
          body: "เราตัดสินใจสร้างสะพานสูงสุด เราวิศวกรรมแพลตฟอร์มแบบโมดูลาร์บนพื้นฐานโหนดที่เป็นกรรมสิทธิ์ซึ่งทำหน้าที่เป็นระบบประสาทส่วนกลางของการผลิตเครื่องประดับ ออกแบบให้เชื่อมวิสัยทัศน์ของนักออกแบบเทคนิคกับโรงงานภายนอกโดยตรง ติดตาม P&L แบบเรียลไทม์ และรักษาความปลอดภัยสเปคเทคนิคทุกรายการ — ทั้งหมดในขณะที่แยกซัพพลายเออร์แต่ละรายอย่างสิ้นเชิง",
        },
        {
          heading: "ตลาดกลางแห่งสุดยอด",
          subheading: "การออกแบบพบกับการผลิตที่สมบูรณ์แบบ",
          label: "ผลลัพธ์",
          body: "Caratzon เปิดตัวอย่างเป็นทางการไม่ใช่แค่เครื่องมือติดตาม แต่เป็นตลาดนักออกแบบที่คัดสรรพร้อมเครื่องมือการผลิตที่จัดการครบวงจร วันนี้ เมื่อแบรนด์ตกหลุมรักแบบบนแพลตฟอร์ม พวกเขาไม่ต้องหาวิธีผลิตเอง ด้วยคลิกเดียว Caratzon ส่งแบบนั้นผ่านเครือข่ายที่ผ่านการตรวจสอบโดยอัตโนมัติ จัดการวิศวกรรม CAD การสร้างต้นแบบ และการควบคุมคุณภาพขั้นสุดท้าย",
        },
      ],
    },
    vision: {
      overline: "วิสัยทัศน์และพันธกิจ",
      visionLabel: "วิสัยทัศน์ของเรา",
      visionBody:
        "เป็นระบบนิเวศระดับโลกที่เป็นเกณฑ์มาตรฐานซึ่งการออกแบบเครื่องประดับระดับโลกพบกับการผลิตที่สมบูรณ์แบบอย่างไร้รอยต่อ — เปลี่ยนห่วงโซ่อุปทานที่กระจัดกระจายให้เป็นเครื่องมือที่โปร่งใสและมีกำไรสูงสำหรับนักสร้างสรรค์และแบรนด์",
      missionLabel: "พันธกิจของเรา",
      missionBody:
        "เสริมพลังนักออกแบบเครื่องประดับอิสระโดยเชื่อมงานศิลป์กับแบรนด์ B2B ทั่วโลก — สนับสนุนอย่างไร้รอยต่อด้วยระบบปฏิบัติการการผลิตที่จัดการครบวงจร เราดำรงอยู่เพื่อขจัดความเสี่ยงและอุปสรรคของการจัดหาระดับโลก",
    },
    howItWorks: {
      overline: "วิธีการทำงาน",
      subtitle: "คลิกเดียว ครบวงจร",
      steps: [
        {
          heading: "นักออกแบบอัปโหลด",
          body: "นักออกแบบอิสระอัปโหลดไฟล์ CAD กำหนดเงื่อนไข IP และเผยแพร่เรื่องราวบรรณาธิการ ผลงานได้รับการคุ้มครองหลัง URL ที่ลงนามและหมดอายุ",
        },
        {
          heading: "แบรนด์ค้นพบ",
          body: "แบรนด์ค้าปลีกเรียกดูแบบพิเศษ 10,000+ ชิ้นในแคตตาล็อกที่คัดสรร ดูตัวอย่างชิ้นงานใน 3D viewer แบบอินเทอร์แอกทีฟภายในแพลตฟอร์ม",
        },
        {
          heading: "Caratzon ส่งต่อ",
          body: "เมื่อตกลงกัน เครื่องมือบนพื้นฐานโหนดของเราจะส่งแบบผ่านเครือข่ายผู้ผลิตที่ผ่านการตรวจสอบโดยอัตโนมัติ — วิศวกรรม CAD การสร้างต้นแบบ QC",
        },
        {
          heading: "ส่งมอบพร้อมมาร์จิน",
          body: "ความสามารถในการมองเห็น P&L แบบเรียลไทม์ การติดตามความคืบหน้า และการจัดส่งสุดท้าย — ไม่มีความล่าช้าแบบกล่องดำ พร้อมความโปร่งใสของห่วงโซ่อุปทานตลอดกระบวนการ",
        },
      ],
    },
    leadership: {
      overline: "ผู้บริหาร",
      founderRole: "ผู้ก่อตั้งและประธานเจ้าหน้าที่บริหาร",
      founderName: "[ชื่อผู้ก่อตั้ง]",
      founderBio:
        "ประวัติย่อ 1–2 ประโยคเกี่ยวกับพื้นหลังด้านการออกแบบเครื่องประดับ การจัดการห่วงโซ่อุปทาน และเทคโนโลยี — และสิ่งที่ขับเคลื่อนวิสัยทัศน์ Caratzon",
      tags: ["การออกแบบเครื่องประดับ", "ห่วงโซ่อุปทาน", "เทคโนโลยี"],
    },
    supplyChain: {
      overline: "สถาปัตยกรรมห่วงโซ่อุปทาน",
      heading: "พื้นฐานโหนด\nโปร่งใสทั้งหมด",
      items: [
        {
          title: "ซัพพลายเออร์แยกกัน",
          desc: "โหนดโรงงานแต่ละแห่งทำงานอิสระ ไม่มีซัพพลายเออร์ใดเห็นสเปค ราคา หรือข้อมูลกำลังการผลิตของรายอื่น",
        },
        {
          title: "P&L แบบเรียลไทม์",
          desc: "ความสามารถในการมองเห็นมาร์จินที่ทุกจุดการผลิต — นักออกแบบ แบรนด์ และผู้จัดการเห็นเฉพาะข้อมูลที่เกี่ยวข้องกับบทบาท",
        },
        {
          title: "บันทึกการตรวจสอบที่แก้ไขไม่ได้",
          desc: "ทุกเวอร์ชัน CAD การอนุมัติ และเหตุการณ์การผลิตถูกประทับเวลาและบันทึก — สายโซ่การดูแลครบถ้วนอยู่ปลายนิ้วคุณ",
        },
      ],
    },
    quote: {
      text: "\"ศิลปะและโลจิสติกส์ขัดแย้งกันโดยพื้นฐาน\nเราสร้างสะพาน\"",
      attribution: "Caratzon · หลักการก่อตั้ง",
    },
    cta: {
      overline: "ร่วมมือกับ Caratzon",
      heading: "สร้างอนาคต\nของเครื่องประดับชั้นสูง",
      primary: "เรียกดูแคตตาล็อก",
      secondary1: "สำหรับแบรนด์และร้านค้าปลีก →",
      secondary2: "สำหรับนักออกแบบอิสระ →",
    },
  },

  forStudio: {
    meta: {
      title: "Caratzon Studio · ที่ซึ่ง AI พบกับโต๊ะทำงานช่างเครื่องประดับ",
      description: "พื้นที่ทำงานออกแบบที่ขับเคลื่อนด้วย AI สำหรับนักสร้างสรรค์เครื่องประดับ พบกับ Cara — ผู้ช่วยออกแบบที่คิดเป็นมิลลิเมตร ค่าความแข็ง Mohs และความแข็งแรงดึง",
    },
    hero: {
      overline: "Caratzon Studio",
      h1Line1: "แบบของคุณ",
      h1Line2: "สมควรได้อาตีเลียร์",
      tagline: "Caratzon Studio คือพื้นที่ทำงานที่ขับเคลื่อนด้วย AI สำหรับนักออกแบบเครื่องประดับอิสระ อัปโหลด CAD เล่าเรื่องราวของคุณ และให้แพลตฟอร์มจัดการทุกอย่าง — การตลาด ไลเซนส์ การส่งต่อการผลิต และผู้ช่วยออกแบบอัจฉริยะ",
      cta: "สมัครเป็นนักออกแบบ →",
      ctaSecondary: "ดูราคา →",
    },
    stats: {
      aiAssisted: "AI ช่วยเหลือ",
      designTools: "เครื่องมือออกแบบ",
      stoneTypes: "50+",
      stoneLabel: "ฐานข้อมูลอัญมณีและโลหะผสม",
      phases: "6",
      phasesLabel: "ขั้นตอนจากภาพร่างสู่การขาย",
      renders: "ทันที",
      rendersLabel: "ภาพเรนเดอร์แคตตาล็อก",
    },
    cara: {
      overline: "พบกับ Cara",
      subtitle: "จากภาพร่างสู่การขาย",
      heading: "จากภาพร่างบนกระดาษ\nสู่การขายทั่วโลก",
      p1: "Cara คือผู้ช่วยออกแบบ AI ที่เปลี่ยนภาพร่างด้วยมือเป็นเครื่องประดับพร้อมผลิตและพร้อมลงตลาด — จัดการทุกขั้นตอนตั้งแต่การชี้แจงแนวคิดจนถึงภาพเรนเดอร์แคตตาล็อก เรื่องเล่า และการลงรายการค้าส่ง",
      p2: "ถ่ายรูปภาพร่างของคุณ Cara จะถามคำถามที่ถูกต้อง — วัสดุ ขนาด การวางอัญมณี — จากนั้นเรนเดอร์แนวคิดที่ซื่อสัตย์ต่อวิสัยทัศน์ดั้งเดิมของคุณทุกเส้นและสัดส่วน",
      pipeline: [
        { num: "01", label: "ร่าง", heading: "อัปโหลดภาพร่าง", body: "ถ่ายรูปภาพร่างด้วยมือหรือบนกระดาษทิชชู โมเดลวิชันของ Cara วิเคราะห์ซิลูเอต สัดส่วน ตำแหน่งอัญมณี และรายละเอียดตกแต่ง — สกัดเจตนาของคุณอย่างแม่นยำ", icon: "pencil" },
        { num: "02", label: "ชี้แจง", heading: "ถาม-ตอบอัจฉริยะ", body: "ก่อนแตะพิกเซลใด Cara ถามคำถามชี้แจง — ชนิดโลหะ การเจียระไนอัญมณี ขนาดแหวน ความชอบการตกแต่ง คำตอบของคุณกลายเป็นบรีฟออกแบบที่ล็อกความซื่อสัตย์", icon: "message-circle" },
        { num: "03", label: "เรนเดอร์", heading: "เรนเดอร์ AI ที่ซื่อสัตย์", body: "Cara สร้างแนวคิดภาพเหมือนจริงที่จำลองภาพร่างของคุณอย่างแม่นยำ — ซิลูเอตเดิม สัดส่วนเดิม ตำแหน่งอัญมณีเดิม ปรับปรุงผ่านบทสนทนาจนสมบูรณ์แบบ", icon: "image" },
        { num: "04", label: "บันทึก", heading: "บันทึกลง Studio", body: "คลิกเดียวบันทึกเรนเดอร์ที่อนุมัติลง Studio เป็นร่างแบบใหม่ — พร้อมภาพร่างต้นฉบับ ประวัติบทสนทนา และพารามิเตอร์แบบทั้งหมดสำหรับการปรับปรุงในอนาคต", icon: "save" },
        { num: "05", label: "เรื่องราว", heading: "เรื่องเล่าเบื้องหลังการสร้างสรรค์", body: "ภาพร่างและบทสนทนา Cara ทั้งหมดของคุณกลายเป็นวัตถุดิบสำหรับเรื่องเล่า 'เบื้องหลังการสร้าง' ที่ AI สร้าง — เรื่องเล่าบรรณาธิการที่น่าสนใจซึ่งติดตามการเดินทางสร้างสรรค์จากเส้นแรกสู่เรนเดอร์สุดท้าย", icon: "book-open" },
        { num: "06", label: "ขาย", heading: "ลงรายการและรับรายได้", body: "ภาพเรนเดอร์แคตตาล็อก สื่อลุคบุ๊ก และรายการค้าส่งถูกสร้างโดยอัตโนมัติ แบบของคุณเข้าสู่แคตตาล็อกทั่วโลกที่แบรนด์ค้นพบ ไลเซนส์ และสั่งผลิต — คุณรับ 80% ทุกธุรกรรม", icon: "trending-up" },
      ],
      conversationDemo: {
        label: "Cara — Sketch-to-Concept",
        userSketch: "ฉันร่างแหวนค็อกเทลนี้ — ช่วยเปลี่ยนเป็นแนวคิดจริงได้ไหม?",
        caraAnalysis: "ฉันเห็นวงแหวนไม่สมมาตรหนาพร้อมอัญมณีฝังแบบ tension ตรงกลางและไหล่แหวนเรียว ก่อนเรนเดอร์ ขอชี้แจงสักเล็กน้อย:",
        caraQuestions: [
          "คุณจินตนาการโลหะอะไร? เส้นเหลี่ยมแนะนำแพลทินัมหรือทองคำขาว",
          "อัญมณีตรงกลาง — เป็นเจียระไน emerald cut ใช่ไหม? น้ำหนักประมาณกี่กะรัต?",
          "ฉันเห็นลายเนื้อบนวง — เป็นฟินิชแปรงหรือตอก?",
        ],
        userReply: "แพลทินัม มรกตเจียระไน emerald cut 2 กะรัต ฟินิชแปรงบนวง",
        caraConfirm: "สมบูรณ์แบบ กำลังเรนเดอร์แนวคิดของคุณ — ซิลูเอตเดิม สัดส่วนเดิม แพลทินัมฟินิชแปรงพร้อมมรกตเจียระไน emerald cut 2 กะรัตในการฝังแบบ tension…",
        toolLabel: "กำลังเรนเดอร์แนวคิดที่ซื่อสัตย์…",
      },
      cta: "ลอง Cara ใน Studio →",
    },
    storyLab: {
      overline: "AI Story Lab",
      subtitle: "การเล่าเรื่องอัตโนมัติ",
      heading: "เรื่องราวของคุณ\nเล่าอย่างงดงาม",
      p1: "ตอบเจ็ดคำถามนำทางในขั้นตอนออนบอร์ดดิ้ง AI จะสร้างเรื่องราวนักออกแบบแบบบรรณาธิการ หน้าโปรไฟล์ และลุคบุ๊ก — เนื้อหาระดับที่เคยต้องใช้นักเขียน ช่างภาพ และอาร์ตไดเรกเตอร์",
      p2: "นักออกแบบแต่ละคนได้โปรไฟล์ Inspire เฉพาะที่ผู้ซื้อค้นพบผลงานผ่านเรื่องเล่า AI ไม่ใช่รายการสินค้าทั่วไป",
      features: [
        { label: "โปรไฟล์บรรณาธิการ", description: "เรื่องราวนักออกแบบที่ AI สร้างซึ่งอ่านเหมือนบทความนิตยสาร — ไม่ใช่ประวัติแม่แบบ" },
        { label: "ลุคบุ๊ก AI", description: "เรื่องเล่าภาพที่สอดคล้องกันทั่วพอร์ตโฟลิโอ สร้างโดยอัตโนมัติจากแบบของคุณ" },
        { label: "การเล่าเรื่องคอลเลกชัน", description: "จัดกลุ่มชิ้นงานเป็นคอลเลกชันตามธีมและให้ AI ร้อยเรียงเรื่องเล่าข้ามชุด" },
      ],
    },
    workspace: {
      overline: "พื้นที่ทำงานนักออกแบบ",
      subtitle: "ทุกอย่างในที่เดียว",
      heading: "อัปโหลด จัดการ\nรับรายได้",
      p1: "พื้นที่ทำงาน Studio เป็นศูนย์บัญชาการของคุณ — อัปโหลดไฟล์ CAD ติดตามรายได้ไลเซนส์ จัดการคอลเลกชัน ดูการวิเคราะห์ และสื่อสารกับผู้ซื้อ ทั้งหมดจากแดชบอร์ดเดียว",
      features: [
        { num: "01", heading: "3D Viewer", body: "ผู้ซื้อตรวจสอบแบบของคุณใน 3D เต็มรูปแบบก่อนไลเซนส์ ไฟล์ CAD ไม่ถูกเปิดเผย — แสดงเฉพาะเรนเดอร์และตัวอย่าง" },
        { num: "02", heading: "แดชบอร์ดรายได้", body: "ติดตามค่าไลเซนส์ ค่าลิขสิทธิ์ และรอบการผลิตแบบเรียลไทม์ ส่วนแบ่งรายได้ 80% ต่อทุกไลเซนส์" },
        { num: "03", heading: "การคุ้มครอง IP", body: "ไฟล์ CAD ถูกเข้ารหัสระดับ vault และไม่แสดงต่อผู้ซื้อ ระดับไลเซนส์ที่มีโครงสร้างพร้อมเงื่อนไขชัดเจน" },
        { num: "04", heading: "การส่งข้อความโดยตรง", body: "สื่อสารกับผู้ซื้อและผู้จัดการฝ่ายผลิตโดยตรงภายในแพลตฟอร์ม" },
      ],
    },
    revenue: {
      overline: "รูปแบบรายได้",
      subtitle: "สามระดับไลเซนส์",
      heading: "รับรายได้\nตามเงื่อนไขของคุณ",
      models: [
        { tier: "standard", label: "ไลเซนส์ Standard", heading: "ไม่จำกัดสิทธิ์", description: "ผู้ซื้อหลายรายสามารถไลเซนส์แบบเดียวกัน คุณรับ 80% ของค่าไลเซนส์พร้อมค่าลิขสิทธิ์ตลอดกาลในทุกรอบการผลิต", benefit: "80% + ค่าลิขสิทธิ์ตลอดกาล" },
        { tier: "embargo", label: "Seasonal Embargo", heading: "สิทธิ์พิเศษ 12 เดือน", description: "ผู้ซื้อรายเดียวได้สิทธิ์พิเศษป้องกันคู่แข่ง 1 ปี ค่าล่วงหน้าสูงกว่า หลัง 12 เดือน แบบกลับสู่ Standard", benefit: "80% + ค่าสิทธิ์พิเศษพรีเมียม" },
        { tier: "vault", label: "สิทธิ์พิเศษทั้งหมด", heading: "โอน IP ถาวร", description: "การซื้อขาดครั้งเดียวพร้อมโอน IP ถาวรรวมไฟล์ CAD ค่าล่วงหน้าสูงสุด Caratzon Kit รวมอยู่", benefit: "ซื้อขาด + Caratzon Kit" },
      ],
    },
    steps: {
      overline: "เริ่มต้น",
      subtitle: "สามขั้นตอน",
      items: [
        { heading: "สมัครและออนบอร์ด", body: "ตอบเจ็ดคำถามออนบอร์ดดิ้ง AI จะสร้างโปรไฟล์บรรณาธิการ เรื่องราวนักออกแบบ และหน้า Inspire โดยอัตโนมัติ" },
        { heading: "อัปโหลดและสร้าง", body: "อัปโหลดไฟล์ CAD ใช้ Cara ปรับปรุงแบบ ทำการวิเคราะห์โครงสร้าง และสร้างเรนเดอร์พร้อมลงแคตตาล็อก จัดกลุ่มชิ้นงานเป็นคอลเลกชัน" },
        { heading: "รับรายได้และเติบโต", body: "ผู้ซื้อค้นพบ ไลเซนส์ และสั่งผลิตแบบของคุณ คุณรับ 80% ทุกไลเซนส์ การผลิตจัดการโดยศูนย์ผลิต EPH ที่ได้รับการรับรอง" },
      ],
    },
    cta: {
      overline: "เข้าร่วม Studio",
      heading: "ออกแบบอนาคต\nเราจัดการที่เหลือ",
      primary: "สมัครเป็นนักออกแบบ →",
      secondary: "สำรวจแคตตาล็อก →",
    },
  },

  studio: {
    nav: { guide: "คู่มือ", inbox: "กล่องข้อความ", storyLab: "แบบของฉัน", collections: "คอลเลกชัน", cara: "Cara", publishing: "เผยแพร่", admin: "ผู้ดูแล →", catalog: "← แคตตาล็อก", analytics: "การวิเคราะห์" },
    notifications: { heading: "การแจ้งเตือน", empty: "ยังไม่มีการแจ้งเตือน" },
    cara: {
      title: "Cara",
      subtitle: "ผู้ช่วยออกแบบ AI",
      newSession: "เซสชันออกแบบใหม่",
      placeholder: "อธิบายวิสัยทัศน์ของคุณหรืออัปโหลดภาพแรงบันดาลใจ…",
      emptyTitle: "พบกับ Cara",
      emptyDescription: "ผู้ช่วยออกแบบ AI ของคุณ — ทั้งช่างเครื่องประดับผู้เชี่ยวชาญและวิศวกรเครื่องกล อธิบายวิสัยทัศน์หรืออัปโหลดภาพแรงบันดาลใจเพื่อเริ่ม",
      analyzing: "กำลังวิเคราะห์แรงบันดาลใจ…",
      rendering: "กำลังสร้างเรนเดอร์แบบ…",
      structuralAnalysis: "กำลังจำลองความสามารถในการผลิต…",
      calculatingBom: "กำลังคำนวณรายการวัสดุ…",
      generatingVideo: "กำลังสร้างตัวอย่างหมุนรอบ — อาจใช้เวลาถึงหนึ่งนาที…",
      processing: "กำลังประมวลผล…",
      phases: {
        spark: "จุดประกาย",
        architect: "สถาปนิก",
        crucible: "เบ้าหลอม",
        bench: "โต๊ะทำงาน",
      },
      artifacts: {
        title: "อาร์ทิแฟกต์",
        empty: "อาร์ทิแฟกต์จะปรากฏที่นี่เมื่อ Cara สร้าง",
        moodBoards: "มูดบอร์ด",
        renders: "เรนเดอร์แบบ",
        structuralAnalysis: "การวิเคราะห์โครงสร้าง",
        materialAnalysis: "การวิเคราะห์วัสดุ",
        bom: "รายการวัสดุ",
        videos: "วิดีโอ",
      },
      sessions: {
        empty: "ยังไม่มีเซสชัน",
        emptyHint: "เริ่มเซสชันออกแบบแรกกับ Cara",
        untitled: "เซสชันไม่มีชื่อ",
      },
      errors: {
        streamFailed: "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
        rateLimited: "คุณส่งข้อความเร็วเกินไป กรุณารอสักครู่",
      },
    },
    gettingStarted: {
      overline: "Designer Studio",
      title: "เริ่มต้นใช้งาน",
      subtitle: "คำแนะนำภาพของฟีเจอร์หลักสามประการของ Studio — เพื่อให้คุณเข้าใจขั้นตอนครบวงจรก่อนเริ่ม",
      howItWorks: {
        title: "วิธีการทำงาน",
        steps: [
          { title: "อัปโหลดและสร้าง", label: "แบบของฉัน", body: "อัปโหลดไฟล์ CAD และสื่อสนับสนุน จากนั้นให้ AI สร้างเรื่องราวแคตตาล็อกพร้อมเผยแพร่สำหรับแบบของคุณ" },
          { title: "ตอบกลับคำขอ", label: "กล่องข้อความ", body: "แบรนด์ส่งคำขอปรับแต่ง คุณร่วมมือ เจรจาเงื่อนไข และส่งไฟล์ CAD แก้ไข — ทั้งหมดติดตามในเธรดเดียว" },
          { title: "คัดสรรคอลเลกชัน", label: "คอลเลกชัน", body: "จัดกลุ่มแบบที่เผยแพร่เป็นคอลเลกชันบรรณาธิการตามธีม AI ร้อยเรียงเรื่องเล่าแต่ละชิ้นเป็นเรื่องราวที่สอดคล้อง" },
        ],
      },
      storyLabWorkflow: {
        title: "เวิร์กโฟลว์แบบ",
        subtitle: "สองเฟสเปลี่ยนไฟล์ CAD เป็นหน้า Inspire ที่เผยแพร่แล้ว",
        phase1: {
          title: "เฟส 1 — ร่างแบบ",
          subtitle: "วิซาร์ดห้าขั้นตอนรวบรวมทุกอย่างที่แพลตฟอร์มต้องการก่อน AI เข้ามา",
          steps: [
            { title: "อัตลักษณ์", body: "ตั้งชื่อชิ้นงานและเขียนคำอธิบายสั้น" },
            { title: "ราคาและสเปค", body: "กำหนดราคาไลเซนส์พื้นฐาน น้ำหนักโลหะ และจำนวนอัญมณี" },
            { title: "การคุ้มครอง IP", body: "เลือก Standard, Seasonal Embargo หรือ Full Exclusive Rights" },
            { title: "อัปโหลดสื่อ", body: "อัปโหลด CAD สำหรับผลิต ไฟล์ 3D viewer และเรนเดอร์หลัก" },
            { title: "ตรวจสอบและสร้าง", body: "ยืนยันทุกอย่างและสร้างร่างแบบ" },
          ],
        },
        phase2: {
          title: "เฟส 2 — เรื่องราว AI",
          subtitle: "หกขั้นตอนแปลงร่างเป็นเรื่องราวพร้อมลงแคตตาล็อกด้วยเรื่องเล่าและภาพที่ AI สร้าง",
          steps: [
            { title: "คีย์เวิร์ดแรงบันดาลใจ", body: "อัปโหลดภาพอ้างอิง AI วิเคราะห์อารมณ์ วัสดุ และธีม" },
            { title: "เลือกคีย์เวิร์ด", body: "เลือกคำที่จับจิตวิญญาณของชิ้นงานได้ดีที่สุด" },
            { title: "สร้างเรื่องราว", body: "อธิบายวัสดุและเจตนา AI สร้างเรื่องเล่าแคตตาล็อก" },
            { title: "ปรับปรุงเรื่องราว", body: "แก้ไขร่าง AI — ข้อความนี้คือสิ่งที่ผู้ซื้ออ่าน" },
            { title: "สร้างโชว์เคส", body: "AI สร้างเลย์เอาต์แคตตาล็อกพร้อมส่วน หัวข้อ และช่องภาพ" },
            { title: "ส่งเพื่ออนุมัติ", body: "ล็อกการแก้ไขและส่งให้ทีมตรวจสอบ" },
          ],
        },
      },
      afterSubmission: {
        title: "หลังจากส่งแล้วจะเกิดอะไรขึ้น",
        body: "ผู้ดูแลจะตรวจสอบเรื่องราวและโชว์เคสของคุณ คุณจะได้รับแจ้งผลการตัดสินใจ — แบบที่ได้รับอนุมัติจะเผยแพร่ในแคตตาล็อกค้าส่ง ส่วนที่ถูกปฏิเสธจะส่งกลับพร้อมข้อเสนอแนะสำหรับแก้ไข",
        steps: [
          { label: "ส่งแล้ว", body: "แบบของคุณเข้าคิวตรวจสอบ" },
          { label: "ตรวจสอบแล้ว", body: "ผู้ดูแลประเมินคุณภาพเรื่องราวและความครบถ้วนของสื่อ" },
          { label: "เผยแพร่แล้ว", body: "แบบที่อนุมัติแล้วจะปรากฏในแคตตาล็อกค้าส่งให้แบรนด์ค้นพบ" },
        ],
      },
      fileRequirements: {
        title: "ข้อกำหนดไฟล์",
        subtitle: "ข้อมูลอ้างอิงสำหรับรูปแบบไฟล์และขนาดที่รับ",
        columns: { asset: "สื่อ", formats: "รูปแบบ", maxSize: "ขนาดสูงสุด", required: "จำเป็น" },
        rows: [
          { asset: "CAD สำหรับผลิต", formats: ".stl, .3dm, .step", maxSize: "50 MB", required: "ใช่" },
          { asset: "3D Viewer", formats: ".glb", maxSize: "25 MB", required: "ใช่" },
          { asset: "เรนเดอร์หลัก", formats: ".jpg, .png, .webp", maxSize: "10 MB", required: "ใช่" },
          { asset: "ภาพอ้างอิง", formats: ".jpg, .png, .webp", maxSize: "5 MB แต่ละไฟล์", required: "ไม่บังคับ" },
        ],
      },
      ipTiers: {
        title: "อธิบายระดับ IP",
        subtitle: "สามรูปแบบไลเซนส์ — เลือกที่เหมาะกับเป้าหมายของคุณ",
        tiers: [
          { title: "ไลเซนส์ Standard", body: "CAD ของคุณอยู่กับ Caratzon ส่งให้เฉพาะผู้ผลิตที่ผ่านการตรวจสอบภายใต้ NDA คุณรับ 80% ของค่าไลเซนส์แต่ละครั้งพร้อมค่าลิขสิทธิ์ตลอดกาล หลายแบรนด์สามารถไลเซนส์พร้อมกันได้" },
          { title: "Seasonal Embargo", body: "แบรนด์หนึ่งถือสิทธิ์พิเศษ 12 เดือน แบบถูกซ่อนในช่วงเวลานั้นและกลับสู่ตลาดเมื่อหมดระยะ ราคาพรีเมียม" },
          { title: "สิทธิ์พิเศษทั้งหมด", body: "แบรนด์ได้ IP ทั้งหมดอย่างถาวร CAD สำหรับผลิตโอนตรงถึงพวกเขา ธุรกรรมมูลค่าสูงครั้งเดียว — แบบถูกลบออกจากตลาดอย่างถาวร" },
        ],
      },
      cta: {
        title: "พร้อมเริ่ม?",
        button: "สร้างแบบแรกของคุณ",
      },
    },
    storyLab: {
      overline: "Designer Studio",
      title: "แบบของฉัน",
      subtitle: "อัปโหลดแบบ สร้างเรื่องราว AI และเผยแพร่ไปยังหน้า Inspire ของคุณ",
      newDraft: "ร่างแบบใหม่",
      overlineLabel: "แบบของฉัน",
      cancel: "ยกเลิก",
      continue: "ดำเนินการต่อ",
      back: "ย้อนกลับ",
      stepOf: "ขั้นตอน {current} จาก {total}",
      keyboardHint: "เคล็ดลับ: Alt + ปุ่มลูกศรเพื่อนำทางขั้นตอน",
      editing: "กำลังแก้ไข…",
      draftInProgress: "ร่างกำลังดำเนินการ",
      emptyTitle: "ยังไม่มีแบบ",
      emptySubtitle: "อัปโหลดแบบแรกเพื่อเริ่มสร้างพอร์ตโฟลิโอ Inspire ของคุณ",
      newDesign: "แบบใหม่",
      emptyHint: "หรือเลือกแบบที่มีอยู่จากแถบด้านข้าง",
      batchUpload: "อัปโหลดเป็นชุด",
      batchUploadSubtitle: "วางภาพถ่ายเครื่องประดับได้สูงสุด 20 ภาพ — AI สร้างชื่อ คำอธิบาย และคีย์เวิร์ดให้แต่ละชิ้น",
      batchProcessing: "กำลังประมวลผล {count} ชิ้น…",
      batchGenerate: "สร้าง {count} แบบ",
      batchCreated: "สร้างแล้ว {count} แบบ",
      batchDuplicates: "ข้ามซ้ำ {count} รายการ",
      batchPossibleDuplicates: "อาจซ้ำ {count} รายการ",
      batchFailed: "ล้มเหลว {count} รายการ",
      batchDuplicateExact: "อัปโหลดแล้วในชื่อ \"{title}\"",
      batchDuplicateNear: "อาจคล้ายกับ \"{title}\" (ตรงกัน {confidence}%)",
      batchViewInLab: "ดูในแบบของฉัน",
      batchDropHere: "วางภาพถ่ายเครื่องประดับได้สูงสุด 20 ภาพที่นี่",
      batchDropHint: "AI จะสร้างชื่อ คำอธิบาย และคีย์เวิร์ดให้แต่ละชิ้น",
      celebrationTitle: "สร้างร่างแบบแล้ว!",
      celebrationSubtitle: "แบบของคุณพร้อมแล้ว เริ่มสร้างเรื่องราวด้วยการสร้างคีย์เวิร์ดด้านล่าง",
      selectDesign: "เลือกแบบ\nเพื่อดำเนินการต่อ",
      selectDesignHint: "เลือกร่างจากแผง หรือสร้างแบบใหม่",
      sidebar: { newDesign: "+ แบบใหม่", designs: "แบบ", noDesigns: "ยังไม่มีแบบ" },
      steps: {
        identity: {
          title: "ตั้งชื่อชิ้นงาน",
          subtitle: "ตั้งชื่อและเขียนคำอธิบายสั้นที่จับแก่นแท้ของแบบ นี่คือสิ่งแรกที่ผู้ซื้อจะเห็น",
          designTitle: "ชื่อแบบ",
          titleTip: "นี่จะเป็นชื่อสาธารณะบนตลาด Caratzon ให้เป็นชื่อที่ชวนจินตนาการและจดจำได้ — ผู้ซื้อเรียกดูตามชื่อก่อน",
          titlePlaceholder: "เช่น ต่างหู Lunette Drop",
          titleHint: "เลือกชื่อที่จับแก่นแท้ของชิ้นงาน",
          description: "คำอธิบายสั้น",
          descriptionPlaceholder: "หนึ่งหรือสองประโยคอธิบายชิ้นงานและลักษณะเฉพาะ",
          descriptionHint: "ข้อความนี้จะปรากฏในแคตตาล็อก ให้กระชับและน่าสนใจ",
        },
        pricing: {
          title: "ราคาและสเปค",
          subtitle: "กำหนดราคาไลเซนส์พื้นฐานและระบุสเปควัสดุ ข้อมูลเหล่านี้ช่วยผู้ซื้อประเมินต้นทุนและผู้ผลิตเตรียมใบเสนอราคา",
          basePrice: "ราคาพื้นฐาน (USD)",
          basePriceTip: "นี่คือค่าไลเซนส์ แบรนด์จ่ายจำนวนนี้เพื่อใช้แบบของคุณ คุณรับ 80% หลังหักค่าแพลตฟอร์ม",
          basePriceHint: "ค่าไลเซนส์ที่แบรนด์จ่ายเพื่อใช้แบบของคุณ คุณรับ 80%",
          metalWeight: "น้ำหนักโลหะ (กรัม)",
          metalWeightTip: "น้ำหนักโดยประมาณช่วยผู้ผลิตประเมินต้นทุนและให้ใบเสนอราคาที่แม่นยำ",
          metalWeightHint: "น้ำหนักโดยประมาณของโลหะในแบบ",
          stoneCount: "จำนวนอัญมณี",
          stoneCountHint: "จำนวนอัญมณีทั้งหมดที่ฝังในชิ้นงาน",
          howPricingWorks: "ระบบราคาทำงานอย่างไร:",
          howPricingBody: "ราคาพื้นฐานคือค่าไลเซนส์แบบ ค่าผลิตจะเสนอราคาแยกโดยโรงงานที่ผ่านการตรวจสอบตามน้ำหนักโลหะ อัญมณี และความซับซ้อน",
        },
        licensing: {
          title: "เลือกการคุ้มครอง IP",
          subtitle: "เลือกวิธีที่แบรนด์สามารถใช้แบบของคุณ แต่ละระดับมีระดับการคุ้มครองและรูปแบบรายได้ที่แตกต่างกัน",
          licensingTip: "ระดับ IP กำหนดวิธีที่แบรนด์สามารถใช้แบบของคุณ Standard อนุญาตไลเซนส์หลายราย Exclusive ให้แบรนด์หนึ่งสิทธิ์ชั่วคราว Vault โอนความเป็นเจ้าของทั้งหมด",
          standard: "ไลเซนส์ Standard",
          standardDesc: "CAD ของคุณอยู่กับ Caratzon ส่งให้เฉพาะผู้ผลิตที่ผ่านการตรวจสอบภายใต้ NDA คุณรับ 80% ของค่าไลเซนส์แต่ละครั้งพร้อมค่าลิขสิทธิ์ตลอดกาล",
          standardDetail: "เหมาะสำหรับนักออกแบบที่ต้องการรายได้พาสซีฟต่อเนื่อง หลายแบรนด์สามารถไลเซนส์พร้อมกัน",
          exclusive: "Seasonal Embargo",
          exclusiveDesc: "แบรนด์หนึ่งถือสิทธิ์พิเศษ 12 เดือน แบบถูกซ่อนในช่วงเวลานั้น กลับสู่ตลาดเมื่อหมดระยะ",
          exclusiveDetail: "ราคาพรีเมียมสำหรับสิทธิ์พิเศษ แบรนด์จ่ายค่าไลเซนส์สูงกว่าสำหรับช่วงระงับ",
          vault: "สิทธิ์พิเศษทั้งหมด",
          vaultDesc: "แบรนด์ได้ IP ทั้งหมดอย่างถาวร CAD สำหรับผลิตโอนตรงถึงพวกเขา คุณรับ 80% ของราคาซื้อขาด",
          vaultDetail: "ธุรกรรมมูลค่าสูงครั้งเดียว แบบถูกลบออกจากตลาดอย่างถาวร",
          ipTransfer: "โอน IP",
        },
        assets: {
          title: "อัปโหลดสื่อ",
          subtitle: "อัปโหลดไฟล์แบบที่ผู้ซื้อและผู้ผลิตต้องการ CAD สำหรับผลิตได้รับการคุ้มครอง — เฉพาะผู้ผลิตที่ผ่านการตรวจสอบเท่านั้นที่เห็นภายใต้ NDA",
          assetsTip: "CAD สำหรับผลิตไม่ถูกแชร์กับผู้ซื้อ เฉพาะผู้ผลิตที่ Caratzon ตรวจสอบแล้วเท่านั้นที่เข้าถึงภายใต้เงื่อนไข NDA ที่เข้มงวด",
          requiredFiles: "ไฟล์ที่จำเป็น",
          optionalFiles: "ไม่บังคับ — ปรับปรุงคุณภาพเรื่องราว AI",
          vaultNotice: "สิทธิ์พิเศษทั้งหมด",
          vaultNoticeDetail: "CAD ของคุณจะถูกโอนตรงถึงแบรนด์ที่ซื้อ",
          cadProtected: "CAD ได้รับการคุ้มครอง IP",
          cadProtectedDetail: "เฉพาะผู้ผลิตที่ Caratzon ตรวจสอบแล้วเท่านั้นที่ได้รับภายใต้ NDA",
          cadLabel: "CAD สำหรับผลิต",
          cadLabelVault: "CAD สำหรับผลิตเพื่อโอน IP",
          cadHint: ".stl · .3dm · .step — ไฟล์ต้นฉบับ ไม่ถูกแชร์กับผู้ซื้อ",
          viewerLabel: "สื่อ 3D Viewer",
          viewerHint: ".glb — ไฟล์ส่งออกจาก CAD สำหรับตัวอย่างผู้ซื้อแบบอินเทอร์แอกทีฟ",
          renderLabel: "เรนเดอร์ 2D / ภาพหลัก",
          renderHint: ".jpg · .png · .webp — ภาพขนาดย่อแคตตาล็อกหลัก",
        },
        review: {
          title: "ตรวจสอบและสร้าง",
          submit: "สร้างร่างแบบ",
          submitting: "กำลังสร้าง…",
          identity: "อัตลักษณ์",
          pricingSpecs: "ราคาและสเปค",
          licensingTier: "ระดับไลเซนส์",
          assets: "สื่อ",
          edit: "แก้ไข",
          uploaded: "อัปโหลดแล้ว",
          missing: "ขาดหาย",
          allRequired: "ต้องอัปโหลดไฟล์ที่จำเป็นทั้งหมดก่อนสร้าง",
        },
      },
      workflow: {
        featured: "จัดแสดง",
        revisionRequired: "ต้องแก้ไข",
        revisionHint: "จัดการข้อเสนอแนะด้านบน จากนั้นส่งอีกครั้ง",
        noReason: "ไม่มีเหตุผลที่ระบุ",
        step01: "คีย์เวิร์ดแรงบันดาลใจ",
        step01Sub: "อัปโหลดภาพอ้างอิงและเพิ่มบริบท AI วิเคราะห์อารมณ์ วัสดุ และธีมเพื่อสร้างจานคีย์เวิร์ด",
        additionalContext: "บริบทเพิ่มเติม",
        contextPlaceholder: "เช่น อิทธิพล Art Deco แซฟไฟร์สีน้ำเงินเที่ยงคืน…",
        generateKeywords: "สร้างคีย์เวิร์ด",
        regenerateKeywords: "สร้างคีย์เวิร์ดใหม่",
        analysingRefs: "กำลังวิเคราะห์ภาพอ้างอิง…",
        step02: "เลือกคีย์เวิร์ด",
        step02Sub: "เลือกคำที่จับจิตวิญญาณของชิ้นงานได้ดีที่สุด — เป็นสมอของเรื่องราวที่ AI สร้าง",
        saveKeywords: "บันทึกคีย์เวิร์ดที่เลือก",
        saving: "กำลังบันทึก…",
        step03: "สร้างเรื่องราว",
        step03Sub: "อธิบายวัสดุ เจตนา และความหมายซ่อนเร้น AI สร้างเรื่องเล่าที่ปรากฏบนหน้าแคตตาล็อกของคุณ",
        pieceDescription: "คำอธิบายชิ้นงาน",
        describePlaceholder: "อธิบายแบบ",
        materialsColors: "วัสดุและสี",
        materialsPlaceholder: "เงินบริสุทธิ์ เพชรปาเว่…",
        initialSpark: "จุดประกายเริ่มต้น",
        sparkPlaceholder: "ภาพ ความทรงจำ หรืออารมณ์…",
        hiddenSymbolism: "สัญลักษณ์ซ่อนเร้น",
        symbolismPlaceholder: "ความหมายอะไรที่ซ่อนอยู่ในชิ้นงานนี้?",
        generateStory: "สร้างเรื่องราว",
        regenerateStory: "สร้างเรื่องราวใหม่",
        writingStory: "กำลังเขียนเรื่องราวของคุณ…",
        step04: "ปรับปรุงเรื่องราว",
        step04Sub: "ตรวจสอบร่าง AI แก้ไขชื่อและเนื้อหาได้อิสระ — ข้อความนี้คือสิ่งที่ผู้ซื้ออ่านบนหน้าแคตตาล็อก",
        saveStory: "บันทึกเรื่องราว",
        step05: "สร้างโชว์เคส",
        step05Sub: "AI สร้างเลย์เอาต์แคตตาล็อก — จำนวนส่วน ช่องภาพ และหัวข้อ ทั้งหมดสร้างจากเรื่องราวของคุณ",
        currentLayout: "เลย์เอาต์ปัจจุบัน:",
        sections: "ส่วน",
        generatedImages: "ภาพที่สร้าง",
        generatedImagesPlural: "ภาพที่สร้าง",
        regenerateWarning: "การสร้างใหม่จะแทนที่เลย์เอาต์ปัจจุบัน",
        generateShowcase: "สร้างโชว์เคส",
        regenerateShowcase: "สร้างโชว์เคสใหม่",
        buildingShowcase: "กำลังสร้างโชว์เคส…",
        step06: "ส่งเพื่ออนุมัติ",
        step06Sub: "ล็อกการแก้ไขจนกว่าผู้ดูแลจะตรวจสอบเรื่องราวและโชว์เคส คุณจะได้รับแจ้งผลการตัดสินใจ",
        awaitingReview: "แบบของคุณอยู่กับทีมตรวจสอบ คุณจะได้รับการแจ้งเตือนเมื่อมีการตัดสินใจ",
        submitForApproval: "ส่งเพื่ออนุมัติ",
        awaitingAdmin: "รอการตรวจสอบจากผู้ดูแล…",
        published: "เผยแพร่แล้ว",
        submitting: "กำลังส่ง…",
        viewPublished: "ดูเรื่องราวที่เผยแพร่",
      },
      upload: {
        dragOrClick: "ลากมาที่นี่หรือ",
        clickToBrowse: "คลิกเพื่อเรียกดู",
        maxSize: "สูงสุด {size} MB",
        required: "จำเป็น",
        uploading: "กำลังอัปโหลด {name}…",
        replace: "แทนที่",
        retry: "ลองอีกครั้ง",
        demoPreLoaded: "ไฟล์สาธิตโหลดไว้แล้ว",
        photoRefs: "ภาพอ้างอิง",
        photoRefsHint: "— ไม่บังคับ ช่วยปรับปรุงคุณภาพ AI",
        dragOrClickPhotos: "ลากหรือคลิกเพื่อเพิ่มภาพอ้างอิง",
        upToPhotos: "ได้สูงสุด {max} ภาพ",
        remove: "ลบ",
        inspirationNotes: "บันทึกแรงบันดาลใจ",
        inspirationPlaceholder: "ความทรงจำ บรรยากาศ สัญญาณทางอารมณ์ หรือจุดประกายเฉพาะ",
      },
    },
    collections: {
      overline: "Designer Studio",
      title: "คอลเลกชัน",
      subtitle: "จัดกลุ่มแบบที่เผยแพร่เป็นคอลเลกชันที่คัดสรรพร้อมเรื่องราวบรรณาธิการที่ AI สร้าง",
      newCollection: "คอลเลกชันใหม่",
      emptyTitle: "คอลเลกชันแรกรอคุณอยู่",
      emptySubtitle: "เลือกแบบที่เผยแพร่ตั้งแต่สองชิ้นขึ้นไปเพื่อสร้างคอลเลกชัน AI จะร้อยเรียงเรื่องราวเข้าด้วยกัน",
      emptyHint: "หรือเลือกคอลเลกชันที่มีอยู่จากแถบด้านข้าง",
      celebrationTitle: "สร้างคอลเลกชันแล้ว!",
      celebrationSubtitle: "คอลเลกชันของคุณพร้อมสำหรับเวิร์กโฟลว์เรื่องราว เริ่มด้วยการสร้างคีย์เวิร์ดด้านล่าง",
      sidebar: { collections: "คอลเลกชัน", noCollections: "ยังไม่มีคอลเลกชัน" },
      designPicker: {
        title: "ชิ้นงานในคอลเลกชัน",
        subtitle: "เลือกแบบที่เผยแพร่แล้วเพื่อรวมไว้ ต้องมีอย่างน้อย 2 แบบ",
        selected: "เลือก {count} รายการ",
        minRequired: "เลือกอย่างน้อย 2 แบบ",
        saveDesigns: "บันทึกชิ้นงาน",
        saving: "กำลังบันทึก…",
      },
      create: {
        title: "สร้างคอลเลกชัน",
        collectionTitle: "ชื่อคอลเลกชัน",
        titlePlaceholder: "เช่น ซีรีส์ Midnight Oceanic",
        description: "คำอธิบายสั้น",
        descriptionPlaceholder: "สองสามประโยคเกี่ยวกับธีมของคอลเลกชัน",
        selectDesigns: "เลือกแบบ",
        selectDesignsHint: "เลือกอย่างน้อย 2 แบบที่เผยแพร่แล้วของคุณ",
        inspirationNote: "บันทึกแรงบันดาลใจ",
        inspirationNotePlaceholder: "อะไรเชื่อมชิ้นงานเหล่านี้เข้าด้วยกัน?",
        submit: "สร้างคอลเลกชัน",
        submitting: "กำลังสร้าง…",
      },
      draftNotInitialized: "ร่างคอลเลกชันยังไม่ได้เริ่มต้น",
      draftNotInitializedCta: "กลับไปที่คอลเลกชัน",
      workflow: {
        step00: "ชิ้นงานในคอลเลกชัน",
        step00Sub: "จัดการแบบที่อยู่ในคอลเลกชันนี้",
        step01: "คีย์เวิร์ดคอลเลกชัน",
        step01Sub: "AI วิเคราะห์ชิ้นงานทั้งหมดร่วมกันเพื่อค้นหาธีม ลวดลาย และอารมณ์ที่เป็นหนึ่งเดียว",
        additionalContext: "บริบทเพิ่มเติม",
        contextPlaceholder: "เช่น ฤดูกาลสร้างสรรค์ร่วม จานวัสดุ สายใยทางอารมณ์…",
        generateKeywords: "สร้างคีย์เวิร์ด",
        regenerateKeywords: "สร้างคีย์เวิร์ดใหม่",
        analysingCollection: "กำลังวิเคราะห์คอลเลกชัน…",
        step02: "เลือกคีย์เวิร์ด",
        step02Sub: "เลือกคำที่จับจิตวิญญาณของคอลเลกชันได้ดีที่สุด",
        saveKeywords: "บันทึกคีย์เวิร์ดที่เลือก",
        saving: "กำลังบันทึก…",
        step03: "สร้างเรื่องราวคอลเลกชัน",
        step03Sub: "AI ร้อยเรียงเรื่องราวแบบแต่ละชิ้นเป็นเรื่องเล่าคอลเลกชันที่สอดคล้อง",
        generateStory: "สร้างเรื่องราว",
        regenerateStory: "สร้างเรื่องราวใหม่",
        writingStory: "กำลังเขียนเรื่องราวคอลเลกชัน…",
        step04: "ปรับปรุงเรื่องราว",
        step04Sub: "ตรวจสอบและแก้ไขเรื่องเล่าคอลเลกชันที่สร้าง",
        saveStory: "บันทึกเรื่องราว",
        step05: "สร้างโชว์เคส",
        step05Sub: "AI ออกแบบโชว์เคสบรรณาธิการหลายชิ้นพร้อมภาพสำหรับแต่ละส่วน",
        currentLayout: "เลย์เอาต์ปัจจุบัน:",
        sections: "ส่วน",
        generatedImages: "ภาพที่สร้าง",
        generatedImagesPlural: "ภาพที่สร้าง",
        regenerateWarning: "การสร้างใหม่จะแทนที่เลย์เอาต์ปัจจุบัน",
        generateShowcase: "สร้างโชว์เคส",
        regenerateShowcase: "สร้างโชว์เคสใหม่",
        buildingShowcase: "กำลังสร้างโชว์เคส…",
        step06: "ส่งเพื่ออนุมัติ",
        step06Sub: "ล็อกการแก้ไขจนกว่าผู้ดูแลจะตรวจสอบเรื่องราวและโชว์เคสคอลเลกชัน",
        awaitingReview: "คอลเลกชันของคุณอยู่กับทีมตรวจสอบ คุณจะได้รับการแจ้งเตือนเมื่อมีการตัดสินใจ",
        submitForApproval: "ส่งเพื่ออนุมัติ",
        awaitingAdmin: "รอการตรวจสอบจากผู้ดูแล…",
        published: "เผยแพร่แล้ว",
        submitting: "กำลังส่ง…",
        viewPublished: "ดูคอลเลกชันที่เผยแพร่",
        revisionRequired: "ต้องแก้ไข",
        revisionHint: "จัดการข้อเสนอแนะด้านบน จากนั้นส่งอีกครั้ง",
        noReason: "ไม่มีเหตุผลที่ระบุ",
        featured: "จัดแสดง",
      },
    },
    inbox: {
      title: "กล่องข้อความคำขอปรับแต่ง",
      subtitle: "เจรจาเงื่อนไข ตรวจสอบบรีฟ และอัปโหลดไฟล์ CAD แก้ไข",
      overline: "Designer Studio",
      openRequests: "คำขอที่เปิดอยู่",
      emptyTitle: "ยังไม่มีคำขอ",
      emptySubtitle: "เมื่อแบรนด์ส่งคำขอปรับแต่งสำหรับแบบของคุณ จะปรากฏที่นี่",
      selectRequest: "เลือกคำขอจากแถบด้านข้างเพื่อเริ่ม",
      thread: "เธรด",
      noMessages: "ยังไม่มีข้อความ",
      updateStatus: "อัปเดตสถานะ",
      uploadRevision: "อัปโหลด CAD แก้ไข",
      revisionHint: "เปลี่ยนสถานะเป็น In Progress เพื่อเปิดใช้งานการอัปโหลด CAD แก้ไข",
    },
    analytics: {
      overline: "Studio",
      title: "การวิเคราะห์แบบ",
      subtitle: "ติดตามประสิทธิภาพแบบของคุณ — ยอดดู การมีส่วนร่วม และการเข้าถึง",
      cards: {
        totalViews: "ยอดดูทั้งหมด",
        uniqueVisitors: "ผู้เข้าชมไม่ซ้ำ",
        avgTimeOnPage: "เวลาเฉลี่ยบนหน้า",
        quoteRequests: "คำขอใบเสนอราคา",
      },
      table: {
        design: "แบบ",
        views: "ยอดดู",
        uniqueViews: "ไม่ซ้ำ",
        clicks: "คลิก",
        avgTime: "เวลาเฉลี่ย",
        scrollDepth: "ความลึกการเลื่อน",
      },
      drillDown: {
        viewsTrend: "แนวโน้มยอดดู (30 วัน)",
        clickBreakdown: "การแยกคลิก",
        referrerBreakdown: "แหล่งผู้อ้างอิง",
      },
      empty: "ยังไม่มีข้อมูลการวิเคราะห์ เมื่อแบบของคุณเผยแพร่และมีผู้ดู ตัวชี้วัดจะปรากฏที่นี่",
      seconds: "วิ",
    },
  },

  catalog: {
    overline: "แคตตาล็อกค้าส่ง",
    resultCount: "{count} ผลลัพธ์",
    designCount: "{count} แบบ",
    emptyTitle: "กำลังคัดสรรแคตตาล็อก",
    emptySubtitle: "นักออกแบบกำลังเตรียมคอลเลกชันแรก กลับมาตรวจสอบเร็ว ๆ นี้",
    searchEmptyTitle: "ไม่พบผลลัพธ์ที่ตรงกัน",
    searchEmptySubtitle: "ลองค้นหาอื่นหรือเรียกดูแบบทั้งหมด",
    browseCta: "เรียกดูแบบทั้งหมด",
  },

  orders: {
    overline: "พื้นที่ทำงานค้าส่ง",
    title: "คำสั่งจัดหา",
    subtitle: "ติดตามการเจรจาที่กำลังดำเนินการ ตรวจสอบหลักฐาน 3D แก้ไขจากนักออกแบบ และอนุมัติเพื่อส่งต่อการผลิต",
    activeOrders: "คำสั่งที่ดำเนินอยู่",
    emptyTitle: "ยังไม่มีคำสั่งจัดหา",
    emptyCta: "เรียกดูแคตตาล็อกค้าส่ง →",
    selectOrder: "เลือกคำสั่งเพื่อดูเธรดการเจรจา",
    latestRevision: "CAD แก้ไขล่าสุด — ตัวอย่าง 3D",
    awaitingRevision: "รอ CAD แก้ไขครั้งแรกจากนักออกแบบ",
    respondToDesigner: "ตอบกลับนักออกแบบ",
  },

  admin: {
    brand: "ผู้ดูแล",
    nav: { workflows: "เวิร์กโฟลว์", publishing: "เผยแพร่", users: "ผู้ใช้", academy: "Academy", developer: "นักพัฒนา", queues: "ตรวจสอบคิว", catalog: "แคตตาล็อก", studio: "Studio", analytics: "การวิเคราะห์", catalogAdmin: "แคตตาล็อก", catalogListings: "รายการค้าส่ง", inspireAdmin: "Inspire", storyLab: "แบบของฉัน" },
    users: {
      overline: "ผู้ดูแล",
      title: "การจัดการผู้ใช้",
      subtitle: "สร้าง แก้ไข และจัดการบัญชีผู้ใช้ในทุกบทบาท",
      tabs: { users: "ผู้ใช้", createNew: "สร้างใหม่" },
      stats: { total: "ผู้ใช้ทั้งหมด", active: "ใช้งาน", suspended: "ถูกระงับ", designers: "นักออกแบบ" },
      search: "ค้นหาตามชื่อหรืออีเมล…",
      allRoles: "ทุกบทบาท",
      noMatch: "ไม่มีผู้ใช้ที่ตรงกับตัวกรอง",
      columns: { name: "ชื่อ", email: "อีเมล", role: "บทบาท", status: "สถานะ", actions: "การดำเนินการ" },
      statusActive: "ใช้งาน",
      statusSuspended: "ถูกระงับ",
      edit: "แก้ไข",
      suspend: "ระงับ",
      reactivate: "เปิดใช้งานอีกครั้ง",
      roles: {
        DESIGNER: "นักออกแบบ",
        B2B_BUYER: "แบรนด์ / ผู้ซื้อ",
        MANUFACTURER: "ผู้ผลิต",
        PRODUCTION_MANAGER: "ผู้จัดการฝ่ายผลิต",
        ADMIN: "ผู้ดูแล",
      },
      roleLabels: { DESIGNER: "นักออกแบบ", B2B_BUYER: "แบรนด์", MANUFACTURER: "โรงงาน", PRODUCTION_MANAGER: "PM", ADMIN: "ผู้ดูแล" },
      create: {
        title: "สร้างบัญชี",
        subtitle: "เพิ่มนักออกแบบ ผู้ซื้อ ผู้ผลิต หรือพนักงานใหม่",
        name: "ชื่อเต็ม",
        namePlaceholder: "เช่น Aria Atelier",
        email: "ที่อยู่อีเมล",
        emailPlaceholder: "designer@example.com",
        password: "รหัสผ่าน",
        passwordPlaceholder: "อย่างน้อย 8 ตัวอักษร",
        role: "บทบาท",
        submit: "สร้างบัญชี",
      },
      invite: {
        title: "ส่งลิงก์เชิญ",
        subtitle: "สร้างลิงก์ลงทะเบียนสำหรับอีเมลและบทบาทเฉพาะ ใช้ได้ 7 วัน",
        email: "อีเมล",
        emailPlaceholder: "new-designer@example.com",
        role: "บทบาท",
        submit: "สร้างลิงก์",
        copied: "คัดลอกแล้ว!",
        copy: "คัดลอก",
      },
      editDialog: {
        title: "แก้ไขผู้ใช้",
        subtitle: "อัปเดตรายละเอียดบัญชีและการกำหนดบทบาท",
        name: "ชื่อ",
        email: "อีเมล",
        role: "บทบาท",
        save: "บันทึกการเปลี่ยนแปลง",
        cancel: "ยกเลิก",
        stripe: "Stripe",
        accountActions: "การดำเนินการบัญชี",
        resetPassword: "รีเซ็ตรหัสผ่าน",
        deleteAccount: "ลบบัญชี",
      },
      confirm: {
        suspendTitle: "ระงับผู้ใช้",
        suspendDesc: "ระงับ {name}? พวกเขาจะสูญเสียการเข้าถึงแพลตฟอร์มทันที",
        suspendButton: "ระงับ",
        reactivateTitle: "เปิดใช้งานผู้ใช้อีกครั้ง",
        reactivateDesc: "เปิดใช้งาน {name} อีกครั้ง? พวกเขาจะได้รับสิทธิ์เข้าถึงเต็มรูปแบบ",
        reactivateButton: "เปิดใช้งานอีกครั้ง",
        deleteTitle: "ลบผู้ใช้",
        deleteDesc: "ลบ {name} อย่างถาวร? การดำเนินการนี้ย้อนกลับไม่ได้และข้อมูลที่เกี่ยวข้องทั้งหมดจะถูกลบ",
        deleteButton: "ลบถาวร",
        cancel: "ยกเลิก",
      },
      success: {
        created: "สร้างบัญชีผู้ใช้สำเร็จ",
        updated: "อัปเดตรายละเอียดผู้ใช้แล้ว",
        suspended: "ระงับบัญชีผู้ใช้แล้ว",
        reactivated: "เปิดใช้งานบัญชีผู้ใช้อีกครั้งแล้ว",
        deleted: "ลบบัญชีผู้ใช้แล้ว",
        reset: "สร้างรหัสผ่านชั่วคราวแล้ว",
        invited: "สร้างลิงก์เชิญแล้ว",
      },
      tempPasswordHint: "คัดลอกตอนนี้ — จะไม่แสดงอีกครั้ง",
      dismiss: "ปิด",
    },
    setup: {
      title: "ตั้งค่าแพลตฟอร์ม",
      subtitle: "สร้างบัญชีผู้ดูแลรายแรกเพื่อเริ่มต้น",
      steps: { authorize: "ยืนยัน", credentials: "ข้อมูลรับรอง", designer: "นักออกแบบ", confirm: "ยืนยัน" },
      setupPasswordLabel: "รหัสผ่านการตั้งค่า",
      setupPasswordPlaceholder: "กรอกรหัสผ่านการตั้งค่า",
      setupPasswordHint: "อินสแตนซ์นี้ต้องใช้รหัสผ่านการตั้งค่าเพื่อสร้างบัญชีผู้ดูแลรายแรก",
      setupPasswordInvalid: "รหัสผ่านการตั้งค่าไม่ถูกต้อง",
      emailLabel: "ที่อยู่อีเมล",
      emailPlaceholder: "admin@company.com",
      nameLabel: "ชื่อเต็ม",
      namePlaceholder: "Jane Smith",
      passwordLabel: "รหัสผ่าน",
      passwordPlaceholder: "อย่างน้อย 8 ตัวอักษร",
      confirmPasswordLabel: "ยืนยันรหัสผ่าน",
      confirmPasswordPlaceholder: "กรอกรหัสผ่านอีกครั้ง",
      designerTitle: "บัญชีนักออกแบบ",
      designerSubtitle: "สร้างบัญชีนักออกแบบรายแรกเพื่อให้เริ่มอัปโหลดแบบได้",
      designerNameLabel: "ชื่อนักออกแบบ",
      designerNamePlaceholder: "Aria Atelier",
      designerEmailLabel: "อีเมลนักออกแบบ",
      designerEmailPlaceholder: "designer@company.com",
      designerPasswordLabel: "รหัสผ่านนักออกแบบ",
      designerPasswordPlaceholder: "อย่างน้อย 8 ตัวอักษร",
      reviewTitle: "ตรวจสอบ",
      reviewSubtitle: "ยืนยันบัญชีที่จะถูกสร้าง",
      createAccount: "สร้างบัญชี",
      back: "ย้อนกลับ",
      next: "ถัดไป",
      passwordMismatch: "รหัสผ่านไม่ตรงกัน",
      passwordTooShort: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
    },
    analytics: {
      overline: "ผู้ดูแล",
      title: "การวิเคราะห์แพลตฟอร์ม",
      subtitle: "ตัวชี้วัดการมีส่วนร่วมแบบทั้งแพลตฟอร์มและข้อมูลเชิงลึกด้านประสิทธิภาพ",
      cards: {
        totalViews: "ยอดดูทั้งหมด",
        uniqueVisitors: "ผู้เข้าชมไม่ซ้ำ",
        avgTimeOnPage: "เวลาเฉลี่ยบนหน้า",
        totalClicks: "คลิกทั้งหมด",
      },
      filters: {
        designer: "กรองตามนักออกแบบ",
        dateRange: "ช่วงวันที่",
        allDesigners: "นักออกแบบทั้งหมด",
      },
      leaderboard: "แบบที่มีผลงานดีที่สุด",
      zeroEngagement: "ต้องดูแล (ไม่มีการมีส่วนร่วม)",
      table: {
        design: "แบบ",
        designer: "นักออกแบบ",
        views: "ยอดดู",
        uniqueViews: "ไม่ซ้ำ",
        clicks: "คลิก",
        avgTime: "เวลาเฉลี่ย",
        scrollDepth: "ความลึกการเลื่อน",
      },
      drillDown: {
        viewsTrend: "แนวโน้มยอดดู",
        clickBreakdown: "การแยกคลิก",
        referrerBreakdown: "แหล่งผู้อ้างอิง",
      },
      empty: "ยังไม่มีข้อมูลการวิเคราะห์ เมื่อแบบเผยแพร่และมีผู้ดู ตัวชี้วัดจะปรากฏที่นี่",
      seconds: "วิ",
    },
  },

  messages: {
    overline: "การสื่อสาร",
    title: "ข้อความ",
    subtitle: "บทสนทนากับนักออกแบบ ผู้จัดการฝ่ายผลิต และพันธมิตรผู้ผลิต",
    emptyTitle: "ยังไม่มีบทสนทนา",
    emptyCta: "เรียกดูแคตตาล็อกเพื่อเริ่ม",
    typeMessage: "พิมพ์ข้อความ...",
    send: "ส่ง",
    translate: "แปล",
    translating: "กำลังแปล...",
    loadMore: "โหลดข้อความก่อนหน้า",
    typing: "กำลังพิมพ์...",
    typingMultiple: "กำลังพิมพ์...",
    today: "วันนี้",
    yesterday: "เมื่อวาน",
    unread: "ยังไม่อ่าน",
    newConversation: "บทสนทนาใหม่",
    participants: "ผู้เข้าร่วม",
    quoteProposal: "ข้อเสนอราคา",
    statusUpdate: "อัปเดตสถานะ",
    attachFile: "แนบไฟล์",
    accept: "ยอมรับ",
    counter: "เสนอราคาตอบ",
    connecting: "กำลังเชื่อมต่อแชท...",
    estimatedDays: "ประมาณการจัดส่ง",
    days: "วัน",
    messageDesigner: "ส่งข้อความถึงนักออกแบบ",
  },

  academy: {
    meta: {
      title: "Academy — Caratzon",
      description: "คู่มือผู้เชี่ยวชาญด้านการผลิตเครื่องประดับ การสร้างแบรนด์ และแนวโน้มอุตสาหกรรมสำหรับนักออกแบบและแบรนด์ขนาดเล็ก",
    },
    hero: {
      title: "Caratzon Academy",
      subtitle: "ความรู้จากผู้เชี่ยวชาญสำหรับนักออกแบบเครื่องประดับและแบรนด์เกิดใหม่ — จาก CAD สู่การค้า",
    },
    categories: {
      all: "ทั้งหมด",
      manufacturing: "การผลิต",
      business: "ธุรกิจ",
      trends: "แนวโน้ม",
      wholesale: "ค้าส่ง",
      brand: "แบรนด์",
      tech: "เทคโนโลยี",
      operations: "ปฏิบัติการ",
    },
    readingTime: "นาทีที่อ่าน",
    featured: "จัดแสดง",
    relatedArticles: "บทความที่เกี่ยวข้อง",
    backToAcademy: "← กลับ Academy",
    cta: {
      title: "พร้อมนำแบบของคุณมาสู่ชีวิต?",
      description: "Caratzon เชื่อมนักออกแบบอิสระกับผู้ผลิตที่ได้รับการรับรองเพื่อการผลิตที่ราบรื่น",
      button: "เริ่มต้นบน Caratzon →",
    },
    rss: "ฟีด RSS",
    noArticles: "ยังไม่มีบทความ กลับมาตรวจสอบเร็ว ๆ นี้!",
  },

  newsroom: {
    meta: {
      title: "ห้องข่าว — Caratzon",
      description:
        "ข่าวล่าสุด ข่าวประชาสัมพันธ์ และอัปเดตจาก Caratzon ประกาศบริษัท เปิดตัวผลิตภัณฑ์ พันธมิตร และข้อมูลเชิงลึกอุตสาหกรรม",
    },
    hero: {
      issueLabel: "ห้องข่าว",
      title: "ล่าสุดจาก Caratzon",
      subtitle: "ข่าวบริษัท ข่าวประชาสัมพันธ์ อัปเดตผลิตภัณฑ์ และข้อมูลเชิงลึกอุตสาหกรรม",
    },
    categories: {
      all: "ทั้งหมด",
      company: "บริษัท",
      product: "ผลิตภัณฑ์",
      partnership: "พันธมิตร",
      industry: "อุตสาหกรรม",
      press_release: "ข่าวประชาสัมพันธ์",
    },
    readingTime: "นาทีที่อ่าน",
    featured: "จัดแสดง",
    relatedArticles: "บทความที่เกี่ยวข้อง",
    backToNewsroom: "← กลับห้องข่าว",
    cta: {
      title: "พร้อมนำแบบของคุณมาสู่ชีวิต?",
      description:
        "Caratzon เชื่อมนักออกแบบอิสระกับผู้ผลิตที่ได้รับการรับรองเพื่อการผลิตที่ราบรื่น",
      button: "เริ่มต้นบน Caratzon →",
    },
    noArticles: "ยังไม่มีบทความ กลับมาตรวจสอบเร็ว ๆ นี้!",
    pressAssets: {
      meta: {
        title: "สื่อสำหรับสื่อมวลชน — ห้องข่าว Caratzon",
        description:
          "โลโก้แบรนด์ แนวทาง และทรัพยากรสื่อสำหรับสื่อมวลชนและพันธมิตร ดาวน์โหลดสื่อแบรนด์ Caratzon สำหรับการใช้งานบรรณาธิการ",
      },
      hero: {
        issueLabel: "สื่อสำหรับสื่อมวลชน",
        title: "สื่อสำหรับสื่อมวลชน",
        subtitle:
          "ทรัพยากรแบรนด์สำหรับสื่อมวลชน พันธมิตร และการใช้งานบรรณาธิการ ดาวน์โหลดโลโก้และแนวทางด้านล่าง",
      },
      logos: {
        heading: "โลโก้แบรนด์",
        primary: "โลโก้หลัก (สว่าง)",
        dark: "โลโก้หลัก (มืด)",
        icon: "ไอคอนเท่านั้น",
        stacked: "แบบซ้อน",
      },
      guidelines: {
        heading: "แนวทางแบรนด์",
        colorPalette: "จานสี",
        colorNotes:
          "สีเน้นแบรนด์หลัก: Teal Sapphire (#005F6B) สีหมึกอินเดียเข้มสำหรับข้อความ สีครีมอบอุ่นสำหรับพื้นหลัง สีทองใบสำหรับการตกแต่งเท่านั้น",
        typography: "แบบอักษร",
        typographyNotes:
          "Display: Cormorant Garamond, Cormorant SC Body: Inter ใช้แบบอักษร display สำหรับหัวข้อและสำเนียงบรรณาธิการ Inter สำหรับ UI และเนื้อหาหลัก",
      },
      contact: {
        heading: "ติดต่อสื่อ",
        description: "สำหรับคำถามจากสื่อ ชุดสื่อ และคำขอสัมภาษณ์:",
        contactLink: "คำถามทั่วไป →",
      },
    },
  },

  contentKit: {
    nav: "Caratzon Kit",
    meta: {
      title: "Caratzon Kit — Caratzon",
      description: "สร้าง Caratzon Kit ครบชุดสำหรับแบบเครื่องประดับ — ภาพถ่ายนางแบบ ลุคบุ๊ก ภาพแคตตาล็อก แคปชันโซเชียล และเรื่องราวบรรณาธิการ",
    },
    list: {
      title: "Caratzon Kit ของคุณ",
      subtitle: "สร้างภาพถ่ายนางแบบ ภาพ สำเนา และลุคบุ๊กพร้อมการตลาดจากแบบของคุณ",
      createNew: "Caratzon Kit ใหม่",
      empty: "ยังไม่มี Caratzon Kit สร้างชุดแรกเพื่อเริ่ม",
      status: {
        draft: "ร่าง",
        generating: "กำลังสร้าง",
        ready: "พร้อม",
        failed: "ล้มเหลว",
      },
    },
    wizard: {
      step1: "เลือกแหล่ง",
      step2: "สร้างภาพ",
      step3: "สร้างสำเนา",
      step4: "สร้างลุคบุ๊ก",
      step5: "เผยแพร่และแชร์",
      source: {
        title: "เลือกแหล่งแบบของคุณ",
        fromCatalog: "จากแคตตาล็อก",
        fromCatalogDesc: "เลือกแบบที่คุณไลเซนส์จากตลาด",
        uploadNew: "อัปโหลดภาพ",
        uploadNewDesc: "อัปโหลดภาพถ่ายเครื่องประดับของคุณเอง",
        titleLabel: "ชื่อชิ้นงาน",
        descriptionLabel: "คำอธิบาย",
        next: "สร้างภาพ",
      },
      visuals: {
        title: "ภาพที่สร้าง",
        subtitle: "ภาพถ่ายสินค้าที่ AI ปรับปรุงและภาพไลฟ์สไตล์ลุคบุ๊ก",
        generating: "กำลังสร้างภาพ...",
        regenerate: "สร้างใหม่",
        acceptAll: "ยอมรับและดำเนินการต่อ",
        catalogShot: "ภาพสินค้า",
        lookbookShot: "ไลฟ์สไตล์",
      },
      copy: {
        title: "สำเนาการตลาด",
        subtitle: "คำอธิบายสินค้าและแคปชันโซเชียลที่ AI สร้าง",
        generating: "กำลังเขียนสำเนา...",
        productDescription: "คำอธิบายสินค้า",
        brandStory: "เรื่องราวแบรนด์",
        socialCaptions: "แคปชันโซเชียล",
        regenerate: "สร้างสำเนาใหม่",
        next: "สร้างลุคบุ๊ก",
      },
      lookbook: {
        title: "ตัวอย่างลุคบุ๊ก",
        subtitle: "ลุคบุ๊กที่ AI ประกอบพร้อมดาวน์โหลด",
        generating: "กำลังประกอบลุคบุ๊ก...",
        template: "สไตล์เทมเพลต",
        regenerate: "สร้างใหม่ด้วยสไตล์อื่น",
        templates: {
          minimal: "มินิมอล",
          editorial: "บรรณาธิการ",
          bold: "โดดเด่น",
          organic: "ออร์แกนิก",
        },
        next: "เผยแพร่และแชร์",
      },
      publish: {
        title: "เผยแพร่และแชร์",
        subtitle: "ดาวน์โหลด Caratzon Kit ของคุณหรือเผยแพร่ไปยัง Discovery",
        download: "ดาวน์โหลด",
        downloadAll: "ดาวน์โหลดชุดครบถ้วน",
        downloadImages: "ดาวน์โหลดภาพ (ZIP)",
        downloadCopy: "ดาวน์โหลดสำเนา (TXT)",
        downloadPdf: "ดาวน์โหลดลุคบุ๊ก (PDF)",
        publish: "เผยแพร่ไปยัง Discovery",
        publishDesc: "เปิดหน้า Discovery ของคุณให้เป็นสาธารณะบน Caratzon",
        slugLabel: "URL Discovery",
        categoryLabel: "หมวดหมู่",
        materialsLabel: "วัสดุ",
        keywordsLabel: "คีย์เวิร์ดสไตล์",
        heroLabel: "ภาพหลัก",
        published: "เผยแพร่แล้ว!",
        viewDiscovery: "ดูหน้า Discovery",
      },
    },
    upsell: {
      title: "เครดิต Studio ของคุณหมดแล้ว",
      body: "อัปเกรดเป็น Source เพื่อรับ 1,500 Studio Credits ทุกเดือน — เพียงพอสำหรับ 15 Caratzon Kit หรือเติมเครดิตทันทีด้วยแพ็ก",
      cta: "ดูแพลน",
    },
  },

  concierge: {
    title: "Caratzon Concierge",
    subtitle: "ผู้ช่วยจัดหาเครื่องประดับ B2B ของคุณ",
    welcome: "ยินดีต้อนรับ! ถามเราเกี่ยวกับแบบ ระดับไลเซนส์ การผลิต หรือทุกเรื่องเกี่ยวกับ Caratzon",
    inputPlaceholder: "ถามเกี่ยวกับแบบ ไลเซนส์ ราคา...",
    disclaimer: "ขับเคลื่อนด้วย AI คำตอบอาจไม่ถูกต้องทั้งหมด",
    quickActions: [
      "ไลเซนส์ทำงานอย่างไร?",
      "ฉันเป็นนักออกแบบ — จะเข้าร่วมได้อย่างไร?",
      "แพลนราคาเท่าไร?",
      "ฉันอยากพูดคุยกับทีม",
    ],
    leadForm: {
      title: "เชื่อมต่อกับทีมของเรา",
      description: "แชร์รายละเอียดของคุณ ทีมจะติดต่อกลับภายใน 24 ชั่วโมง",
      name: "ชื่อของคุณ",
      email: "อีเมลธุรกิจ",
      company: "บริษัท (ไม่บังคับ)",
      message: "อธิบายสั้น ๆ ว่าต้องการความช่วยเหลือเรื่องอะไร...",
      submit: "เชื่อมต่อกับทีม",
      successTitle: "เชื่อมต่อแล้ว",
      success: "ทีมจะติดต่อภายใน 24 ชั่วโมง คุณสามารถแชทต่อที่นี่ได้ในระหว่างนี้",
    },
    handoffConfirm: {
      title: "ส่งต่อคำขอแล้ว",
      description: "เราแจ้งทีมพร้อมรายละเอียดคำขอของคุณ สมาชิกทีมจะติดต่อเร็ว ๆ นี้ คุณสามารถแชทต่อที่นี่หรือติดต่อเราโดยตรงที่ trade@caratzon.com",
    },
  },

  inspire: {
    meta: {
      title: "Inspire — Caratzon",
      description: "สำรวจแบบเครื่องประดับสวยงามจากนักออกแบบและแบรนด์ทั่วโลก",
    },
    explore: {
      title: "Inspire",
      subtitle: "สำรวจแบบเครื่องประดับจากนักสร้างสรรค์ทั่วโลก",
      allCategories: "ทั้งหมด",
      noResults: "ไม่พบชิ้นงานในหมวดนี้",
    },
    profile: {
      pieces: "ชิ้นงาน",
      totalViews: "ยอดดูทั้งหมด",
    },
    detail: {
      by: "โดย",
      views: "ยอดดู",
      materials: "วัสดุ",
      share: "แชร์",
      viewProfile: "ดูโปรไฟล์",
      cta: {
        title: "สร้างหน้า Inspire ของคุณเอง",
        body: "เข้าร่วมเป็นนักออกแบบเพื่อแสดงผลงานด้วยลุคบุ๊ก AI เรื่องราวบรรณาธิการ และโปรไฟล์เฉพาะ — ทั้งหมดจาก Studio ของคุณ",
        button: "เริ่มสร้าง",
      },
    },
    saved: {
      title: "ชิ้นงานที่บันทึก",
      empty: "ยังไม่มีชิ้นงานที่บันทึก",
      emptySubtitle: "เรียกดู Inspire เพื่อหาชิ้นโปรด",
      backToInspire: "กลับ Inspire",
    },
    creatorOnboarding: {
      meta: {
        title: "เข้าร่วม Inspire ในฐานะนักสร้างสรรค์ · Caratzon",
        description: "บอกเราเกี่ยวกับงานฝีมือ เรื่องราว และวิสัยทัศน์ของคุณ — เพื่อให้เราแสดงผลงานคุณต่อโลก",
      },
      header: "Inspire · การออนบอร์ดนักสร้างสรรค์",
      stepOf: "ขั้นตอน {step} จาก {total}",
      back: "← ย้อนกลับ",
      continue: "ดำเนินการต่อ →",
      steps: {
        profile: "โปรไฟล์",
        styleTools: "สไตล์และเครื่องมือ",
        creativeDna: "DNA สร้างสรรค์",
        philosophy: "ปรัชญา",
        innerWorld: "โลกภายใน",
        production: "การผลิต",
        review: "ตรวจสอบ",
      },
      profile: {
        title: "โปรไฟล์นักออกแบบของคุณ",
        subtitle: "ผู้ซื้อและ PM จะเห็นข้อมูลนี้บนแพลตฟอร์ม",
        firstName: "ชื่อ *",
        lastName: "นามสกุล *",
        studioName: "ชื่อสตูดิโอ / แบรนด์",
        studioPlaceholder: "เช่น Studio Noir, Aria Atelier",
        location: "สถานที่ / เมือง",
        locationPlaceholder: "เช่น กรุงเทพ, ไทย",
        photo: "ภาพโปรไฟล์",
        photoOptional: "(ไม่บังคับ — AI ปรับปรุง)",
        photoHint: "อัปโหลดภาพถ่ายหน้าตรงหรือภาพธรรมดา AI จะปรับปรุงด้วยแสงสตูดิโออบอุ่นและพื้นหลังสะอาด",
        photoEnhancing: "กำลังปรับปรุงภาพด้วย AI…",
        photoSaved: "ปรับปรุงและบันทึกภาพแล้ว",
        photoChange: "เปลี่ยน",
        photoUpload: "อัปโหลด",
      },
      style: {
        title: "สุนทรียภาพและเครื่องมือของคุณ",
        subtitle: "เราใช้ข้อมูลนี้เพื่อจับคู่ผลงานกับกลุ่มผู้ซื้อที่เหมาะสม",
        aestheticLabel: "คุณจะอธิบายสุนทรียภาพการออกแบบอย่างไร? *",
        aestheticHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
        designStyleLabels: {
          "Minimalist": "มินิมอล",
          "Vintage-inspired": "แรงบันดาลใจวินเทจ",
          "Bridal/Engagement": "เจ้าสาว / หมั้น",
          "Men's": "ผู้ชาย",
          "Bold/Chunky": "โดดเด่น / หนา",
          "Trend-driven Fashion": "แฟชั่นตามเทรนด์",
          "Everyday Fine": "เครื่องประดับชั้นสูงสำหรับทุกวัน",
          "Maximalist": "แม็กซิมอล",
        } as Record<string, string>,
        cadLabel: "คุณใช้ซอฟต์แวร์ CAD อะไรเป็นหลัก? *",
        cadHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
        formatsLabel: "คุณสามารถให้ไฟล์รูปแบบใด?",
        formatsHint: "เลือกทั้งหมดที่เกี่ยวข้อง",
      },
      creative: {
        title: "DNA สร้างสรรค์ของคุณ",
        subtitle: "ช่วยเราเข้าใจรากเหง้าของงานฝีมือ คำตอบเหล่านี้กำหนดวิธีที่ AI เล่าเรื่องราวของคุณต่อผู้ซื้อ",
        originLabel: "คุณมาเป็นนักออกแบบเครื่องประดับได้อย่างไร? *",
        originHint: "เรื่องราวจุดเริ่มต้น — อะไรดึงดูดคุณสู่งานฝีมือนี้? ความทรงจำวัยเด็ก ครูบาอาจารย์ จุดเปลี่ยน?",
        originPlaceholder: "ฉันเติบโตมาเห็นย่าร้อมุกเมล็ดลงบนไหมในโรงงานที่ชัยปุระ แสงที่ตกกระทบเม็ดมุกแต่ละเม็ดรู้สึกเหมือนเวทมนตร์…",
        materialsLabel: "คุณรู้สึกเชื่อมโยงกับวัสดุอะไรมากที่สุด?",
        materialsHint: "เลือกทั้งหมดที่สอดคล้อง",
        signatureMaterialLabels: {
          "Gold (yellow, rose, white)": "ทองคำ (เหลือง โรส ขาว)",
          "Platinum": "แพลทินัม",
          "Silver / Sterling": "เงิน / สเตอร์ลิง",
          "Titanium": "ไทเทเนียม",
          "Enamel": "เคลือบอีนาเมล",
          "Precious gemstones": "อัญมณีมีค่า",
          "Semi-precious stones": "อัญมณีกึ่งมีค่า",
          "Pearls": "ไข่มุก",
          "Diamonds": "เพชร",
          "Wood / organic materials": "ไม้ / วัสดุอินทรีย์",
          "Recycled metals": "โลหะรีไซเคิล",
          "Lab-grown stones": "อัญมณีสังเคราะห์",
          "Mixed media": "สื่อผสม",
        } as Record<string, string>,
        ritualsLabel: "อธิบายกระบวนการสร้างสรรค์ของคุณ",
        ritualsHint: "กระบวนการของคุณเป็นอย่างไร? ร่างก่อน ไป CAD เลย ทำจากแว็กซ์? ทำงานที่ไหน?",
        ritualsPlaceholder: "ฉันเริ่มจากภาพร่างสีน้ำบนกระดาษเนื้อหยาบเสมอ ต้องรู้สึกถึงน้ำหนักและการไหลก่อนจะสัมผัสหน้าจอ…",
        culturalLabel: "อิทธิพลทางวัฒนธรรมหรือประวัติศาสตร์ใดที่หล่อหลอมผลงานของคุณ?",
        culturalHint: "ประเพณี ภูมิภาค ยุคสมัย ศิลปะ — ทุกอย่างที่หล่อเลี้ยงภาษาภาพของคุณ",
        culturalPlaceholder: "รูปทรงเรขาคณิต Art Deco ลวดลายดอกไม้โมกุล ความไม่สมบูรณ์แบบของวาบิ-ซาบิญี่ปุ่น…",
      },
      philosophy: {
        title: "ปรัชญาการออกแบบของคุณ",
        subtitle: "คำถามเหล่านี้เผยให้เห็นวิธีที่คุณคิดเกี่ยวกับงานฝีมือ — ความตึง ความเชื่อมั่น และทางเลือกที่ทำให้ผลงานเป็นของคุณ",
        oneWordLabel: "ถ้าอธิบายปรัชญาการออกแบบเป็นคำเดียว คำนั้นคืออะไร? *",
        oneWordPlaceholder: "เช่น ความตึง ความเคารพ ความท้าทาย ความลื่นไหล",
        feelingLabel: "เมื่อใครสวมเครื่องประดับของคุณ พวกเขาควรรู้สึกอย่างไร? *",
        feelingHint: "ไม่ใช่ว่าควรดูเป็นอย่างไร — แต่ชิ้นงานควรกระตุ้นสภาวะอารมณ์อะไร?",
        feelingPlaceholder: "เหมือนพวกเขาแบกความลับ — สิ่งที่มีค่าและเป็นของตัวเองทั้งหมด ความมั่นใจที่เงียบซึ่งไม่ต้องประกาศ",
        tensionLabel: "ความตึงเครียดสร้างสรรค์ใดที่กำหนดผลงานของคุณ?",
        tensionHint: "นักออกแบบทุกคนเผชิญกับข้อแลกเปลี่ยน การตกแต่งกับความยับยั้ง? ประเพณีกับการพลิกโฉม? ความสมบูรณ์กับความดิบ?",
        tensionPlaceholder: "ฉันถูกดึงระหว่างความแม่นยำและความไม่สมบูรณ์เสมอ ต้องการให้ทุกเส้นมีเจตนา แต่ปล่อยให้โลหะสร้างเซอร์ไพรส์…",
        opinionLabel: "ความเห็นที่ไม่เป็นที่นิยมเกี่ยวกับการออกแบบเครื่องประดับของคุณคืออะไร?",
        opinionHint: "สิ่งที่คุณเชื่อซึ่งคนส่วนใหญ่ในอุตสาหกรรมจะไม่เห็นด้วย",
        opinionPlaceholder: "ฉันคิดว่าความสมมาตรถูกให้คุณค่ามากเกินไป ชิ้นงานที่สวยที่สุดมีความไม่สมมาตรอย่างจงใจที่ทำให้รู้สึกมีชีวิต…",
      },
      innerWorld: {
        title: "โลกภายในของคุณ",
        subtitle: "คำถามที่ลึกกว่าเหล่านี้ช่วย AI เข้าใจว่าคุณเป็นใครนอกเหนือจากโต๊ะทำงาน — เพื่อให้เรื่องราวนักออกแบบรู้สึกเป็นตัวคุณอย่างแท้จริง",
        inspirationLabel: "อะไรนอกเหนือเครื่องประดับที่สร้างแรงบันดาลใจให้แบบของคุณ? *",
        inspirationHint: "สถาปัตยกรรม ดนตรี ธรรมชาติ อาหาร ภาพยนตร์ คณิตศาสตร์ เมือง ความรู้สึก — อะไรก็ได้",
        inspirationPlaceholder: "วิธีที่คอนกรีตบรูทัลลิสต์จับแสงบ่าย เกลียวคณิตศาสตร์ในเปลือกหอยนอติลุส ความเงียบของสวนหินญี่ปุ่น…",
        emotionalLabel: "การออกแบบเติมเต็มความต้องการทางอารมณ์อะไรให้คุณ?",
        emotionalHint: "ทำไมคุณยังสร้างสรรค์ต่อ? อะไรจะหายไปจากชีวิตถ้าไม่มีมัน?",
        emotionalPlaceholder: "เป็นช่วงเวลาเดียวที่จิตใจสงบ เมื่อจมลึกในการออกแบบ เสียงรบกวนหยุดลงและเหลือแค่ชิ้นงานกับฉัน…",
        legacyLabel: "คุณต้องการให้ผลงานทั้งหมดบอกอะไรเกี่ยวกับคุณใน 20 ปี?",
        legacyHint: "วิสัยทัศน์มรดก — สายใยอะไรควรเชื่อมทุกสิ่งที่คุณสร้าง?",
        legacyPlaceholder: "ว่าฉันสร้างชิ้นงานที่คนไม่ได้แค่สวม แต่เก็บรักษา วัตถุที่กลายเป็นส่วนหนึ่งของเรื่องราวใครบางคน ส่งต่อไม่ใช่เพราะมูลค่า แต่เพราะความหมาย…",
        metaphorLabel: "ถ้าการทำงานออกแบบของคุณเป็นสถานที่ จะเป็นอย่างไร?",
        metaphorHint: "คำอุปมาสำหรับพื้นที่สร้างสรรค์ — จริงหรือจินตนาการ",
        metaphorPlaceholder: "โรงงานกระจกบนขอบผา เครื่องมือที่แม่นยำ ทิวทัศน์ที่เถื่อน ข้างในทุกอย่างเป็นระเบียบ ข้างนอกทุกอย่างเป็นธรรมชาติ…",
      },
      production: {
        title: "ความพร้อมสำหรับการผลิต",
        subtitle: "ผู้ผลิตต้องการไฟล์ CAD ที่ปรับปรุงสำหรับการผลิตจริง — ความหนาเขี้ยว น้ำหนักโลหะ ค่าเผื่อการหดตัว",
        cadOptimisedLabel: "ไฟล์ CAD ของคุณได้รับการปรับปรุงเต็มที่สำหรับการผลิตจริงหรือไม่?",
        optionYes: "ใช่ — ไฟล์ได้รับการปรับปรุงเต็มที่สำหรับการผลิต",
        optionMostly: "ส่วนใหญ่ — อาจต้องปรับเล็กน้อย",
        optionNo: "ไม่ — ฉันออกแบบสำหรับเรนเดอร์/แสดงภาพเท่านั้น",
        optionHelp: "ฉันต้องการความช่วยเหลือในการปรับปรุงไฟล์",
        portfolioLabel: "พอร์ตโฟลิโอ / เว็บไซต์",
        portfolioPlaceholder: "https://yourportfolio.com",
        socialLabel: "โปรไฟล์โซเชียล",
        socialOptional: "(ไม่บังคับ — แสดงบนหน้า Inspire ของคุณ)",
        instagramPlaceholder: "@yourstudio หรือ https://instagram.com/yourstudio",
        pinterestPlaceholder: "@yourstudio หรือ https://pinterest.com/yourstudio",
        tiktokPlaceholder: "@yourstudio หรือ https://tiktok.com/@yourstudio",
        sampleUploadsTitle: "ตัวอย่างอัปโหลด",
        sampleUploadsBody: "คุณจะสามารถอัปโหลดเรนเดอร์ CAD และภาพถ่ายชิ้นงานสำเร็จจากแดชบอร์ด Studio โดยตรงหลังจากทำโปรไฟล์เสร็จ",
      },
      review: {
        title: "ตรวจสอบโปรไฟล์ของคุณ",
        subtitle: "ทุกอย่างถูกต้องหรือไม่? เมื่อได้รับอนุมัติ คุณจะสามารถอัปเดตจากการตั้งค่า Studio",
        aiEnhanced: "ภาพถ่ายที่ AI ปรับปรุง",
        labels: {
          name: "ชื่อ",
          studio: "สตูดิโอ",
          location: "สถานที่",
          aesthetic: "สุนทรียภาพ",
          cadSoftware: "ซอฟต์แวร์ CAD",
          fileFormats: "รูปแบบไฟล์",
          productionReady: "พร้อมผลิต",
          portfolio: "พอร์ตโฟลิโอ",
          instagram: "Instagram",
          pinterest: "Pinterest",
          tiktok: "TikTok",
        },
        creativeProfile: "โปรไฟล์สร้างสรรค์ของคุณ",
        creativeLabels: {
          originStory: "เรื่องราวจุดเริ่มต้น",
          materials: "วัสดุ",
          philosophy: "ปรัชญา",
          wearerFeels: "ผู้สวมใส่รู้สึก",
          inspiration: "แรงบันดาลใจ",
          legacy: "มรดก",
        },
        storyGeneration: {
          title: "สร้างเรื่องราวนักออกแบบ",
          subtitle: "AI จะสร้างเรื่องเล่าที่น่าสนใจจากคำตอบแบบสอบถามของคุณ — พร้อมเผยแพร่บนหน้า Inspire",
          button: "สร้างเรื่องราวของฉัน",
          loading: "กำลังสร้างเรื่องเล่า…",
          error: "การสร้างเรื่องราวล้มเหลว",
          tryAgain: "ลองอีกครั้ง",
          refineLater: "เมื่อได้รับอนุมัติ คุณสามารถปรับปรุงเรื่องราวจากแดชบอร์ด Studio",
        },
        terms: {
          prefix: "ฉันยืนยันว่าข้อมูลข้างต้นถูกต้องและยอมรับ",
          termsLink: "ข้อกำหนดการใช้บริการสำหรับนักออกแบบ",
          and: "และ",
          privacyLink: "นโยบายความเป็นส่วนตัว",
        },
        submit: "ส่งใบสมัคร →",
        submitting: "กำลังส่ง…",
      },
      errors: {
        nameRequired: "กรุณากรอกชื่อและนามสกุล",
        agreeRequired: "คุณต้องยอมรับข้อกำหนดสำหรับนักออกแบบเพื่อดำเนินการต่อ",
        submissionFailed: "เกิดข้อผิดพลาดในการส่งใบสมัคร กรุณาลองอีกครั้ง",
      },
      pending: {
        meta: {
          title: "ใบสมัครอยู่ระหว่างตรวจสอบ · Caratzon",
          description: "ใบสมัครนักออกแบบของคุณกำลังได้รับการตรวจสอบจากทีมของเรา",
        },
        overline: "Private Beta",
        thankYou: "ขอบคุณ {name}",
        thankYouGeneric: "ขอบคุณ",
        submitted: "ใบสมัครของคุณถูกส่งเรียบร้อยแล้ว Caratzon อยู่ใน",
        privateBeta: "private beta",
        submittedSuffix: " ขณะนี้ ทีมของเราตรวจสอบใบสมัครนักออกแบบทุกรายด้วยตนเอง",
        emailNotice: "เราจะแจ้งทางอีเมลเมื่อบัญชีได้รับอนุมัติ โดยปกติใช้เวลา 1–2 วันทำการ",
        backToHome: "กลับหน้าแรก",
        exploreAcademy: "สำรวจ Academy →",
        rejected: {
          overline: "อัปเดตใบสมัคร",
          heading: "เราไม่สามารถอนุมัติใบสมัครของคุณได้ในขณะนี้",
          body: "ขอบคุณที่สนใจ Caratzon น่าเสียดายที่เราไม่สามารถอนุมัติใบสมัครตอนนี้ได้ หากคุณเชื่อว่าเป็นข้อผิดพลาดหรือต้องการให้ข้อมูลเพิ่มเติม กรุณาติดต่อทีม",
          feedbackLabel: "ข้อเสนอแนะจากทีม",
          contactUs: "ติดต่อเรา",
          reapply: "สมัครอีกครั้ง",
          reapplying: "กำลังส่ง…",
        },
      },
    },
  },

  caraChat: {
    empty: {
      title: "พบกับ Cara",
      description: "ผู้ช่วยออกแบบ AI ของคุณ — ทั้งช่างเครื่องประดับผู้เชี่ยวชาญและวิศวกรเครื่องกล อธิบายวิสัยทัศน์ อัปโหลดภาพร่าง หรือวางภาพแรงบันดาลใจเพื่อเริ่ม",
      sketchToConcept: "ภาพร่าง → แนวคิด",
      photoToDesign: "ภาพถ่าย → แบบ",
      ideaToRender: "ไอเดีย → เรนเดอร์",
    },
    placeholder: {
      initial: "อธิบายวิสัยทัศน์ อัปโหลดภาพร่าง หรือวางภาพแรงบันดาลใจ…",
      direction: "บอก Cara ทิศทาง — วัสดุ สไตล์ ยุคสมัย…",
      adjust: "ขอให้ Cara ปรับแบบ หรือขอการวิเคราะห์โครงสร้าง…",
      finalize: "พร้อมสรุป? ขอให้ Cara สร้างเรนเดอร์แคตตาล็อกและ BOM",
    },
    dragOverlay: "วางภาพร่างหรือภาพอ้างอิง",
    scrollPill: "↓ ข้อความใหม่",
    sketchFallback: "นี่คือภาพร่าง / ภาพอ้างอิงของฉัน กรุณาวิเคราะห์",
    error: "เกิดข้อผิดพลาด กรุณาลองอีกครั้ง",
    regenerate: "สร้างใหม่",
    suggestions: {
      custom: "อื่น ๆ…",
      customPlaceholder: "พิมพ์คำตอบของคุณ…",
      send: "ส่ง",
    },
    editMessage: "แก้ไขข้อความ",
    editSend: "ส่ง",
    editCancel: "ยกเลิก",
    download: "ดาวน์โหลด",
    copyMessage: "คัดลอกข้อความ",
    justNow: "เมื่อกี้",
    minutesAgo: "{n} นาทีที่แล้ว",
    toolLabels: {
      generate_mood_board: "มูดบอร์ด",
      generate_concept_sketch: "ภาพร่างแนวคิด",
      generate_design_render: "เรนเดอร์แบบ",
      adjust_design: "เรนเดอร์ที่ปรับแล้ว",
      generate_catalog_render: "เรนเดอร์แคตตาล็อก",
      render_from_sketch: "แนวคิดจากภาพร่าง",
      analyze_sketch: "การวิเคราะห์ภาพร่าง",
      analyze_inspiration: "การวิเคราะห์แรงบันดาลใจ",
      reference_lookup: "ค้นหาข้อมูลอ้างอิง",
      structural_analysis: "การวิเคราะห์โครงสร้าง",
      calculate_bom: "รายการวัสดุ",
      material_recommendation: "การวิเคราะห์วัสดุ",
      generate_turntable_video: "วิดีโอหมุนรอบ",
      generate_lookbook_image: "ภาพลุคบุ๊ก",
      present_design_specs: "สเปคแบบ",
      finalize_design: "แบบสุดท้าย",
      share_to_gallery: "แชร์ไปแกลเลอรี",
    },
    toolLoading: {
      rendering: "กำลังเรนเดอร์…",
      sketchingConcept: "กำลังร่างแนวคิด…",
      analyzingSketch: "กำลังวิเคราะห์ภาพร่าง…",
      analyzingInspiration: "กำลังวิเคราะห์แรงบันดาลใจ…",
      lookingUpReference: "กำลังค้นหาข้อมูลอ้างอิง…",
      generatingVideo: "กำลังสร้างวิดีโอ — อาจใช้เวลาถึงหนึ่งนาที…",
      stylingLookbook: "กำลังจัดสไตล์ลุคบุ๊ก…",
      structuralAnalysis: "กำลังจำลองความสามารถในการผลิต…",
      materialCheck: "กำลังตรวจสอบความเข้ากันได้ของวัสดุ…",
      calculatingBom: "กำลังคำนวณรายการวัสดุ…",
      sharingToGallery: "กำลังแชร์ไปแกลเลอรี…",
      preparingSpecs: "กำลังเตรียมสเปค…",
      finalizingDesign: "กำลังสรุปแบบ…",
      processing: "กำลังประมวลผล…",
    },
    toolCards: {
      moodBoard: "มูดบอร์ด",
      conceptSketch: "ภาพร่างแนวคิด",
      refinedSketch: "ภาพร่างที่ปรับปรุง",
      turntablePreview: "ตัวอย่างหมุนรอบ",
      sketchAnalysis: "การวิเคราะห์ภาพร่าง",
      inspirationAnalysis: "การวิเคราะห์แรงบันดาลใจ",
      structuralAnalysis: "การวิเคราะห์โครงสร้าง",
      billOfMaterials: "รายการวัสดุ",
      materialAnalysis: "การวิเคราะห์วัสดุ",
      designFinalized: "แบบสุดท้ายแล้ว",
      sharedToGallery: "แชร์ไปแกลเลอรีแล้ว",
      errorFallback: "เกิดข้อผิดพลาด",
      designRender: "เรนเดอร์แบบ",
      updatedRender: "เรนเดอร์ที่อัปเดต",
      catalogRender: "เรนเดอร์แคตตาล็อก",
      conceptFromSketch: "แนวคิดจากภาพร่าง",
      lookbookLabel: "ลุคบุ๊ก",
      saveToStudio: "บันทึกลง Studio",
      savedOpenStudio: "บันทึกแล้ว — เปิดใน Studio",
      submitBrief: "ส่งบรีฟแบบ",
      briefSubmitted: "ส่งบรีฟแล้ว — ดูคำสั่ง",
      designTitlePlaceholder: "ชื่อแบบ…",
      saving: "กำลังบันทึก…",
      save: "บันทึก",
      cancel: "ยกเลิก",
      structural: {
        manufacturabilityReport: "รายงานความสามารถในการผลิต",
        areasAnalyzed: "วิเคราะห์ {n} พื้นที่",
        areasAnalyzedPlural: "วิเคราะห์ {n} พื้นที่",
        issuesFound: "พบปัญหา",
        warnings: "คำเตือน",
        allClear: "ผ่านทั้งหมด",
        pass: "ผ่าน",
        warning: "คำเตือน",
        warningPlural: "คำเตือน",
        critical: "วิกฤต",
        recommendationLabel: "คำแนะนำ:",
        addressCritical: "แก้ไขปัญหาวิกฤตก่อนดำเนินการหล่อ",
        reviewWarnings: "ตรวจสอบคำเตือนด้านบน — แบบสามารถสร้างได้ด้วยการปรับปรุงที่ระบุ",
      },
      bom: {
        costBreakdown: "รายละเอียดต้นทุน",
        lineItems: "{n} รายการ",
        lineItemsPlural: "{n} รายการ",
        item: "รายการ",
        qty: "จำนวน",
        estCost: "ต้นทุนประมาณ",
        laborSetting: "ค่าแรงและการฝัง",
        totalEstimate: "ประมาณการรวม",
      },
      material: {
        compatibilityCheck: "ตรวจสอบความเข้ากันได้",
        compatible: "เข้ากันได้",
        concerns: "ข้อกังวล",
        concernsLabel: "ข้อกังวล",
        recommendationsLabel: "คำแนะนำ",
        allCompatible: "วัสดุทั้งหมดเข้ากันได้สำหรับการผลิต",
      },
      sketch: {
        sketchInterpretation: "การตีความภาพร่าง",
        needsInput: "ต้องการข้อมูลเพิ่ม",
        stones: "อัญมณี",
        filigree: "ฟิลิกรี",
        engraving: "การแกะสลัก",
        designNotes: "บันทึกแบบ",
        needsClarification: "ต้องการคำชี้แจง",
      },
      inspiration: {
        inspirationBreakdown: "การวิเคราะห์แรงบันดาลใจ",
        colorPalette: "จานสี",
        motifs: "ลวดลาย",
        textures: "เนื้อผิว",
        suggestedFinishes: "ฟินิชที่แนะนำ",
        suggestedForms: "รูปทรงที่แนะนำ",
      },
      designSpecs: {
        weight: "น้ำหนัก",
        stones: "อัญมณี",
        stoneSingular: "อัญมณี",
        finish: "ฟินิช",
        stonesLabel: "อัญมณี",
        dimensions: "ขนาด",
        manufacturable: "ผลิตได้",
        manufacturabilityConcerns: "ข้อกังวลด้านความสามารถในการผลิต",
      },
      finalize: {
        productionReady: "พร้อมผลิต",
        metal: "โลหะ",
        stones: "อัญมณี",
        stoneSingular: "อัญมณี",
        estRetail: "ราคาปลีกประมาณ",
        cadHandoff: "พร้อมสำหรับการส่งต่อ CAD การหล่อ หรือใบเสนอราคาจากผู้ผลิต",
      },
      gallery: {
        nowInGallery: "อยู่ในแกลเลอรีแล้ว",
        storyGenerating: "กำลังสร้างเรื่องราวแบบ — ตรวจสอบแท็บแกลเลอรีเพื่อดู",
      },
      reference: {
        title: "ข้อมูลอ้างอิง",
        casting: "สเปคการหล่อ",
        metals: "คุณสมบัติโลหะ",
        stones: "ความทนทานของอัญมณี",
        settings: "ความเข้ากันได้ของการฝัง",
      },
    },
    starters: [
      { label: "ออกแบบแหวนเพชรเม็ดเดี่ยว", text: "ออกแบบแหวนหมั้นเพชรเม็ดเดี่ยวสมัยใหม่ เพชรทรงโอวัล 1 กะรัต ทองคำโรส 18K" },
      { label: "แหวนค็อกเทล Art Deco", text: "สร้างแหวนค็อกเทลที่โดดเด่นแรงบันดาลใจจากเรขาคณิต Art Deco กับมรกตและออนิกซ์" },
      { label: "สร้อยข้อมือเทนนิสมินิมอล", text: "ออกแบบสร้อยข้อมือเทนนิสมินิมอลกับแซฟไฟร์และเพชรสลับในแพลทินัม" },
    ],
    buyerOverrides: {
      empty: {
        title: "ออกแบบกับ Cara",
        description: "อธิบายเครื่องประดับที่คุณกำลังมองหา — สไตล์ วัสดุ โอกาส — แล้ว Cara จะนำวิสัยทัศน์มาสู่ชีวิตด้วยเรนเดอร์พร้อมผลิต",
      },
      placeholder: {
        initial: "อธิบายเครื่องประดับที่คุณกำลังมองหา — สไตล์ วัสดุ โอกาส…",
        direction: "บอก Cara เพิ่มเติมเกี่ยวกับความชอบ — วัสดุ งบประมาณ จำนวน…",
        adjust: "ขอให้ Cara ปรับแบบ หรือสำรวจรูปแบบที่แตกต่าง…",
        finalize: "พอใจกับแบบ? ส่งเป็นบรีฟแบบเพื่อผลิต",
      },
      starters: [
        { label: "แหวนหมั้นสั่งทำ", text: "ฉันกำลังมองหาแหวนหมั้นสั่งทำ — เพชรทรงโอวัล การฝังสมัยใหม่ ทองคำโรส" },
        { label: "จี้เอกลักษณ์แบรนด์", text: "ฉันต้องการจี้เอกลักษณ์สำหรับแบรนด์ — มินิมอล ทอง 14K ราคาปลีกต่ำกว่า $200" },
        { label: "ชุดแหวนแต่งงาน", text: "ออกแบบชุดแหวนแต่งงานคู่ชายหญิงในแพลทินัมพร้อมรายละเอียดละเอียดอ่อน" },
      ],
    },
  },

  pricing: {
    meta: {
      title: "ราคา · Caratzon",
      description: "ราคาโปร่งใสสำหรับแบรนด์บน Caratzon — จัดหาแบบเครื่องประดับพร้อมวิศวกรรม สร้าง AI marketing kit และผลิตอย่างยั่งยืน",
    },
    hero: {
      overline: "สำหรับแบรนด์ · สมาชิกค้าส่ง",
      heading: "หยุดจ่าย $2,500 ต่อแบบ",
      headingEm: "เริ่มต้นที่ $0",
      body: "สมาชิกของคุณปลดล็อกแคตตาล็อกทั้งหมด เครื่องมือการตลาด AI และการจัดหาตรงจากนักออกแบบอิสระ ไลเซนส์แบบแยกต่างหาก — คุณจ่ายเฉพาะสิ่งที่เลือกผลิต",
    },
    socialProof: [
      "แบบพร้อมวิศวกรรม 48+ ชิ้น",
      "นักออกแบบจาก 6 ประเทศ",
      "AI kit สร้างในไม่ถึง 3 นาที",
      "กำไรตั้งแต่ชิ้นที่ 1",
    ],
    billing: {
      monthly: "รายเดือน",
      annual: "รายปี",
      savingActive: "ประหยัด ~17%",
      savingPrompt: "ประหยัด ~17% ต่อปี",
    },
    tiers: {
      explorer: {
        name: "Discover",
        tagline: "ดูสิ่งที่เป็นไปได้",
        description: "เรียกดูแคตตาล็อก บันทึกรายการโปรด และรับ 200 เครดิตต้อนรับเพื่อสร้าง AI marketing kit แรกของคุณ — ฟรี ไม่ต้องใช้บัตรเครดิต",
        features: [
          "เรียกดูแคตตาล็อกทั้งหมด — ทุกนักออกแบบ ทุกชิ้น",
          "บันทึกแบบในรายการโปรด",
          "200 Studio Credits ต้อนรับ (ครั้งเดียว)",
          "สร้าง Essentials Kit 2 ชุดเพื่อดูคุณภาพด้วยตัวเอง",
          "เลือกจำนวน — เราจัดการที่เหลือตั้งแต่ CAD ถึงจัดส่ง",
        ],
        cta: "เริ่มต้นฟรี",
      },
      professional: {
        name: "Source",
        tagline: "เข้าถึงนักออกแบบโดยตรง",
        description: "เข้าถึงการจัดหาเต็มรูปแบบ ความสัมพันธ์โดยตรงกับนักออกแบบ 1,500 เครดิต/เดือน — เพียงพอสำหรับ 15 marketing kit หรือ 150 ภาพแคตตาล็อกด่วน",
        mostPopular: "นิยมที่สุด",
        features: [
          "ทุกอย่างใน Discover บวก:",
          "1,500 Studio Credits ทุกเดือน",
          "จัดหาตรงจากนักออกแบบ — ไม่มีตัวกลาง",
          "เจรจาเงื่อนไขไลเซนส์ผ่านข้อความส่วนตัว",
          "AI marketing kit: ภาพไลฟ์สไตล์ ลุคบุ๊ก สื่อโซเชียล — พร้อมในไม่กี่นาที",
          "ระดับไลเซนส์ Standard + Exclusive",
          "กรองตามโลหะ อัญมณี สไตล์ ราคา และความพร้อม",
        ],
        cta: "เริ่ม Source",
      },
      atelier: {
        name: "Atelier",
        tagline: "เวิร์กช็อปออกแบบส่วนตัว",
        description: "โอน IP เต็มรูปแบบผ่าน Vault licensing ผู้จัดการฝ่ายผลิตเฉพาะจัดการทุกอย่างจาก CAD ถึงจัดส่ง 5,000 เครดิต/เดือน",
        features: [
          "ทุกอย่างใน Source บวก:",
          "Vault licensing — โอน IP + ไฟล์ CAD ทั้งหมด",
          "5,000 Studio Credits ทุกเดือน",
          "ผู้จัดการฝ่ายผลิตเฉพาะ — จุดติดต่อเดียว",
          "การสนับสนุนลำดับต้น — สายตรง ตอบกลับวันเดียว",
          "เข้าถึงนักออกแบบใหม่ก่อนลงรายการสาธารณะ",
          "บรีฟจัดหาสั่งทำ — บอกเราสิ่งที่ต้องการ เราหาให้",
          "เงื่อนไขไลเซนส์จำนวนมากสำหรับคำสั่งหลาย SKU",
          "Cara AI — ออกแบบเครื่องประดับต้นฉบับด้วยความช่วยเหลือ AI",
        ],
        cta: "เริ่ม Atelier",
      },
      enterprise: {
        name: "Enterprise",
        tagline: "ขยายไม่จำกัด",
        description: "สำหรับเครือข่ายค้าปลีกและผู้จัดจำหน่ายขนาดใหญ่ เครดิตสั่งทำ การเชื่อมต่อ API การจัดการการผลิตแบบ white-glove และทีมบัญชีเฉพาะ",
        customLabel: "สั่งทำ",
        customSublabel: "ปรับตามปริมาณและความต้องการของคุณ",
        features: [
          "ทุกอย่างใน Atelier บวก:",
          "Studio Credits สั่งทำ — ตรงกับความเร็วแคตตาล็อกของคุณ",
          "เข้าถึง API — แคตตาล็อก kit และจัดการคำสั่ง",
          "การจัดการการผลิตแบบ white-glove ข้ามหลายโรงงาน",
          "ทีมบัญชีเฉพาะพร้อมรีวิวธุรกิจรายไตรมาส",
          "SLA การออนบอร์ด และการฝึกอบรมแบบสั่งทำ",
          "เข้าถึงหลายที่นั่งพร้อมสิทธิ์ตามบทบาท",
          "เงื่อนไขไลเซนส์ที่เจรจาแล้วและส่วนลดจำนวน",
          "คิวการผลิตลำดับต้น — คำสั่งของคุณส่งก่อน",
        ],
        cta: "พูดคุยกับทีม",
      },
    },
    priceDisplay: {
      free: "ฟรี",
      freeSublabel: "ไม่ต้องใช้บัตรเครดิต",
      perMonth: "/เดือน",
      saveBadge: "(ประหยัด ~17%)",
      orAnnualOption: "หรือ {amount}/ปี",
      billedAnnually: "เรียกเก็บ {amount} ต่อปี",
      licensesSeparate: "ค่าไลเซนส์แบบเรียกเก็บแยก",
    },
    getStarted: "เริ่มต้น",
    studioCredits: {
      overline: "Studio Credits",
      heading: "ต้นทุนคงที่ต่อการดำเนินการ ไม่มีเซอร์ไพรส์",
      body: "ทุกการดำเนินการ AI — ตั้งแต่ภาพถ่ายแคตตาล็อกไปจนถึงการปรึกษาออกแบบกับ Cara — ใช้จำนวนเครดิตคงที่จากเงินเดือนรายเดือน ต้องการเพิ่ม? แพ็กเติมเครดิตพร้อมใช้ทันทีและไม่มีวันหมดอายุ",
      link: "ดูต้นทุนเครดิตและแพ็กเติม →",
    },
    roi: {
      overline: "ตัวเลข",
      heading: "ต้นทุนจริงในการเปิดตัว SKU ใหม่",
      body: "การจัดหาแบบดั้งเดิมฝังมาร์จินในต้นทุนแอบแฝงและระยะเวลาหลายเดือน Caratzon ย่อไลน์ทั้งหมด",
      traditionalLabel: "การจัดหาแบบดั้งเดิม",
      caratzonLabel: "Caratzon",
      rows: [
        { metric: "ระยะเวลาสู่ตลาด", traditional: "4–6 เดือน", caratzon: "3 สัปดาห์" },
        { metric: "R&D และการสร้างโมเดล CAD", traditional: "$800 – $2,500+", caratzon: "$0 — พร้อมวิศวกรรม" },
        { metric: "ตัวอย่างจริง", traditional: "$500+ ต่อรอบ", caratzon: "$0 — ตัวอย่าง AI" },
        { metric: "ภาพถ่ายการตลาด", traditional: "$2,000+ ต่อแคมเปญ", caratzon: "~$7 ผ่าน Studio Credits" },
        { metric: "จุดคุ้มทุน", traditional: "~50 ชิ้นที่ขาย", caratzon: "ชิ้นที่ 1" },
      ],
      note: "ไฟล์ CAD พร้อมวิศวกรรม ตัวอย่าง digital twin ภาพถ่าย AI ทุกแบบบน Caratzon มีกำไรตั้งแต่หน่วยแรก",
    },
    faq: {
      overline: "คำถามที่พบบ่อย",
      heading: "ทุกสิ่งที่คุณต้องการรู้",
      items: [
        {
          q: "ค่าสมาชิกรวมอะไร เทียบกับค่าไลเซนส์แบบ?",
          a: "สมาชิกให้คุณเข้าถึงแคตตาล็อก เครื่องมือการตลาด AI (Studio Credits) และความสามารถในการจัดหาโดยตรง ค่าไลเซนส์แบบแยกต่างหาก — คุณจ่ายเฉพาะแบบที่เลือกผลิต ให้คิดว่าสมาชิกเป็นกล่องเครื่องมือ ไลเซนส์คือวัสดุ",
        },
        {
          q: "Studio Credits ที่ไม่ใช้จะเป็นอย่างไร?",
          a: "เครดิตรายเดือนหมดอายุตอนสิ้นรอบบิล ทำให้ราคาเป็นธรรมสำหรับทุกคน หากต้องการเพิ่มเป็นประจำ อัปเกรดแพลนหรือซื้อแพ็กเติม — เครดิตเติมไม่มีวันหมดอายุ",
        },
        {
          q: "เปลี่ยนแพลนหรือยกเลิกได้ตลอดเวลาไหม?",
          a: "ได้ อัปเกรดทันที ลดระดับเมื่อสิ้นรอบบิล ไม่มีสัญญาผูกมัด ไม่มีค่ายกเลิก แพลนรายปียกเลิกได้พร้อมคืนเงินตามสัดส่วนเดือนที่ไม่ใช้",
        },
        {
          q: "ไลเซนส์แบบรวมอะไรจริง ๆ?",
          a: "ทุกไลเซนส์รวมไฟล์ CAD พร้อมวิศวกรรม (ส่งตรงสู่การผลิต — คุณไม่ต้องจัดการไฟล์) สิทธิ์เชิงพาณิชย์เต็มรูปแบบในระดับที่เลือก (Standard, Exclusive หรือ Vault) และ Essentials Kit (ภาพถ่ายแคตตาล็อก สเปค SEO copy) Caratzon Kit กับภาพถ่ายไลฟ์สไตล์สร้างจาก Studio Credits ของคุณ",
        },
        {
          q: "Vault licensing (โอน IP) ทำงานอย่างไร?",
          a: "มีในแพลน Atelier และ Enterprise Vault ให้คุณเป็นเจ้าของแบบอย่างถาวร — รวมไฟล์ CAD ต้นฉบับ นักออกแบบรับค่าซื้อขาดครั้งเดียว เมื่อ vault แล้ว แบบจะถูกลบออกจากแคตตาล็อกสาธารณะ เป็นของคุณ",
        },
        {
          q: "ฉันต้องจัดการการผลิตเองไหม?",
          a: "ไม่ ทุกคำสั่งผลิตผ่านเครือข่ายผู้ผลิต EPH ที่ผ่านการตรวจสอบ การหล่อ การฝัง QC และโลจิสติกส์จัดการครบวงจร คุณอนุมัติความคืบหน้าจากแดชบอร์ด — เราจัดการที่เหลือ",
        },
      ],
    },
    bottomCta: {
      heading: "พร้อมจัดหาแบบใหม่?",
      body: "เริ่มฟรีกับ Discover อัปเกรดเมื่อพร้อม — ไม่มีข้อผูกมัด",
      button: "เรียกดูแคตตาล็อก",
      link: "ต้องการแพลนสั่งทำ? มาคุยกัน",
    },
  },

  ai: {
    meta: {
      title: "Cara AI — วิศวกรรมอัจฉริยะเครื่องประดับ · Caratzon",
      description: "Cara คือ AI วิศวกรรมเครื่องประดับที่ออกแบบเพื่อพื้นโรงงาน การชดเชยการหดตัว การวิเคราะห์โครงสร้าง รายการวัสดุ และแนวคิดพร้อมผลิต — ไม่ใช่ภาพจินตนาการ",
      socialDescription: "AI ที่วิศวกรรมเครื่องประดับเพื่อการผลิตจริง การหดตัว ค่าเผื่อ กลศาสตร์การหล่อ การสวมใส่ — ทุกแนวคิดพร้อมผลิต",
    },
    hero: {
      headingLine1: "ไม่ใช่เครื่องมือสร้างภาพ",
      headingLine2: "แต่เป็น AI วิศวกรรมเครื่องประดับ",
      ctaDemo: "ลอง Cara AI — สาธิตสด",
      ctaCredits: "ดูต้นทุนเครดิต",
    },
    pillars: {
      label: "ข้อจำกัดด้านวิศวกรรม",
      headingLine1: "ทุกแนวคิดถูกทดสอบความเครียด",
      headingLine2: "ก่อนออกจากหน้าจอ",
    },
    capabilities: {
      label: "ความสามารถ",
      headingLine1: "จากภาพร่างบนกระดาษ",
      headingLine2: "สู่พิมพ์เขียวพร้อมผลิต",
    },
    whatYouCanAsk: {
      label: "สิ่งที่ถามได้",
      heading: "บทสนทนา ไม่ใช่กล่องพรอมต์",
      groups: [
        {
          title: "ปรึกษาการออกแบบ",
          prompts: [
            "\"วิเคราะห์ภาพร่างนี้สำหรับความสามารถในการผลิต\"",
            "\"ความหนาผนังขั้นต่ำสำหรับทองคำขาว 18K คือเท่าไร?\"",
            "\"การฝังแบบ halo นี้จะทนต่อการสวมใส่ประจำวันไหม?\"",
          ],
        },
        {
          title: "วิทยาศาสตร์วัสดุ",
          prompts: [
            "\"เปรียบเทียบแพลทินัม 950 กับ 18K สำหรับโปรไฟล์วงนี้\"",
            "\"ควรใช้โลหะผสมใดสำหรับเขี้ยว 0.8mm?\"",
            "\"ค่าการหดตัวสำหรับการหล่อ lost-wax ในทอง 14K เหลือง?\"",
          ],
        },
        {
          title: "การสร้างภาพ",
          prompts: [
            "\"เรนเดอร์แนวคิดนี้ในทองโรสกับวง pavé\"",
            "\"สร้างมูดบอร์ดสำหรับแหวนหมั้น Art Deco\"",
            "\"สร้างวิดีโอหมุน 360° ของแบบนี้\"",
          ],
        },
        {
          title: "การวางแผนการผลิต",
          prompts: [
            "\"สร้างรายการวัสดุสำหรับแหวนนี้\"",
            "\"ประมาณต้นทุนการผลิตใน 18K กับเพชร VS1\"",
            "\"ไทม์ไลน์การผลิตสำหรับ 50 ชิ้นคือเท่าไร?\"",
          ],
        },
      ],
    },
    creditsTeaser: {
      label: "Studio Credits",
      heading: "AI ต้นทุนคงที่ โปร่งใส",
      body: "ทุกการดำเนินการ Cara มีต้นทุนเครดิตคงที่ — 5 เครดิตต่อข้อความ 15 ต่อเรนเดอร์ภาพ 25 ต่อวิดีโอ 360° ไม่มีการวัดโทเค็น ไม่มีเซอร์ไพรส์",
      link: "ดูต้นทุนเครดิตทั้งหมดและแพ็กเติม →",
    },
    finalCta: {
      heading: "ดูด้วยตัวเอง",
      body: "ลองสาธิตสด — ไม่ต้องสร้างบัญชี อัปโหลดภาพร่าง ถามคำถาม และดู Cara วิศวกรรมแนวคิดพร้อมผลิต",
      ctaDemo: "ลอง Cara AI — สาธิตสด",
      ctaPricing: "ดูราคา",
    },
  },

  designerAi: {
    meta: {
      title: "Cara AI สำหรับนักออกแบบ — Caratzon",
      description: "ตรวจสอบ CAD สำหรับความสามารถในการผลิต สร้างเรนเดอร์พอร์ตโฟลิโอ วิดีโอ 360° และภาพถ่ายลุคบุ๊ก — ทั้งหมดขับเคลื่อนด้วย Cara AI มุ่งเน้นการออกแบบ ให้ Cara จัดการวิศวกรรม",
      socialDescription: "ผู้ช่วย AI สำหรับนักออกแบบเครื่องประดับ ตรวจสอบ CAD สร้างเรนเดอร์ สร้างพอร์ตโฟลิโอ — พร้อมผลิตตั้งแต่วันแรก",
    },
    hero: {
      overline: "Cara AI · สำหรับนักออกแบบ",
      headingLine1: "ออกแบบอย่างกล้าหาญ",
      headingLine2: "Cara จัดการวิศวกรรม",
      body: "Cara คือผู้ช่วย AI ของคุณ — ทั้งช่างเครื่องประดับผู้เชี่ยวชาญและวิศวกรเครื่องกล ตรวจสอบ CAD สำหรับความสามารถในการผลิต สร้างเรนเดอร์ระดับสตูดิโอ และสร้างพอร์ตโฟลิโอที่ทำให้ผู้ซื้อติดต่อ คุณมุ่งเน้นงานสร้างสรรค์",
      ctaDemo: "ลอง Cara AI — สาธิตสด",
      ctaStudio: "เปิด Studio",
    },
    pillars: {
      label: "Cara ทำอะไรให้คุณ",
      headingLine1: "จากไฟล์ CAD",
      headingLine2: "สู่พอร์ตโฟลิโอพร้อมผลิต",
      items: [
        { stat: "CAD → Render", label: "การสร้างพอร์ตโฟลิโอ", body: "อัปโหลด .3DM หรือ .STL แล้ว Cara สร้างภาพสินค้าระดับสตูดิโอ เรนเดอร์ไลฟ์สไตล์ และวิดีโอหมุน 360° — ภาพที่เคยต้องใช้เงินหลายพันต่อชิ้น" },
        { stat: "±0.15mm", label: "ตรวจสอบความสามารถผลิต", body: "Cara วิเคราะห์แบบเทียบกับค่าเผื่อหล่อจริง — ความหนาผนัง การชดเชยการหดตัว ความแข็งแรงเขี้ยว รัศมีขอบ — และระบุปัญหาก่อนผู้ซื้อเห็น" },
        { stat: "Auto BOM", label: "รายการวัสดุ", body: "รับรายการวัสดุที่แม่นยำทันที — น้ำหนักโลหะ จำนวนอัญมณี ต้นทุนเฉพาะโลหะผสม — เพื่อกำหนดราคาอย่างมั่นใจ" },
        { stat: "เรื่องราว", label: "AI Storytelling", body: "Cara เขียนเรื่องเล่าบรรณาธิการสำหรับแต่ละชิ้นและคอลเลกชัน ไม่ใช่สำเนาทั่วไป — เรื่องราวที่ดึงจากปรัชญาการออกแบบ วัสดุ และเจตนาสร้างสรรค์ของคุณ" },
      ],
    },
    capabilities: {
      label: "ความสามารถสำหรับนักออกแบบ",
      headingLine1: "ทุกสิ่งที่คุณต้องการ",
      headingLine2: "เพื่อไปจากไฟล์สู่การจัดแสดง",
      items: [
        { label: "ตรวจสอบ CAD", detail: "การวิเคราะห์โครงสร้างเทียบกับค่าเผื่อการผลิต EPH — ความหนาผนัง อันเดอร์คัต มุมดราฟต์" },
        { label: "เรนเดอร์สินค้า", detail: "ภาพสินค้าระดับสตูดิโอหลายมุม โลหะ และการจัดวางอัญมณี" },
        { label: "วิดีโอหมุน 360°", detail: "ตัวอย่างหมุนแบบแอนิเมชันที่ผู้ซื้อฝังในงานนำเสนอได้" },
        { label: "ภาพถ่ายลุคบุ๊ก", detail: "ภาพถ่ายไลฟ์สไตล์และนางแบบ AI ที่จัดสไตล์ตามสุนทรียภาพแบรนด์ของคุณ" },
        { label: "เรื่องเล่าคอลเลกชัน", detail: "จัดกลุ่มแบบเป็นคอลเลกชัน Cara เขียนเรื่องราวบรรณาธิการรวมทั้งชุด" },
        { label: "ความรู้วัสดุ", detail: "คำแนะนำเฉพาะโลหะผสมสำหรับทอง 10K–24K เงิน 925 แพลทินัม 950 — การหดตัว ความแข็ง ฟินิช" },
      ],
    },
    workflow: {
      label: "เวิร์กโฟลว์กับ Cara",
      heading: "อัปโหลด ตรวจสอบ เผยแพร่",
      steps: [
        { title: "อัปโหลด CAD", body: "วางไฟล์ .3DM, .STL หรือ .STEP ลง Studio Cara อ่านรูปทรงและเริ่มวิเคราะห์ทันที" },
        { title: "ตรวจสอบและปรับปรุง", body: "Cara ระบุปัญหาความสามารถผลิต แนะนำการแก้ไข และสร้างรายการวัสดุครบถ้วน แชทกับ Cara เพื่อปรับ — ถามเกี่ยวกับโลหะผสม ค่าเผื่อ หรือการฝังทางเลือก" },
        { title: "สร้างพอร์ตโฟลิโอ", body: "คลิกเดียวสร้างเรนเดอร์สินค้า ภาพไลฟ์สไตล์ วิดีโอ 360° และเรื่องราวบรรณาธิการ แบบของคุณเปลี่ยนจากไฟล์ดิบเป็นโชว์เคสพร้อมรับผู้ซื้อ" },
        { title: "เผยแพร่ไปยัง Inspire และแคตตาล็อก", body: "ผลักแบบที่ตรวจสอบแล้วและเรนเดอร์แล้วไปยังหน้า Inspire และแคตตาล็อกค้าส่งในขั้นตอนเดียว ผู้ซื้อค้นพบผลงานพร้อมภาพและเรื่องเล่า — พร้อมไลเซนส์" },
      ],
    },
    closing: "Cara ไม่ได้แทนที่ความคิดสร้างสรรค์ของคุณ — แต่ขจัดทุกอย่างที่ขวางระหว่างแบบของคุณกับผู้ซื้อที่ต้องเห็น ไม่ต้องมีช่างภาพ ไม่ต้องมีนักเขียน ไม่ต้องมีผู้ประสานงานโรงงาน แค่วิสัยทัศน์ของคุณที่ผ่านการตรวจสอบการผลิตและนำเสนออย่างสวยงาม",
    creditsTeaser: {
      label: "Studio Credits",
      heading: "AI ต้นทุนคงที่ ไม่มีเซอร์ไพรส์",
      body: "ทุกการดำเนินการ Cara มีต้นทุนเครดิตโปร่งใส — 5 เครดิตต่อข้อความ 15 ต่อเรนเดอร์ 25 ต่อวิดีโอ 360° เครดิตรวมในแพลนพร้อมเติมได้ตลอด",
      link: "ดูต้นทุนเครดิต →",
    },
    finalCta: {
      heading: "แบบของคุณสมควรได้รับการเห็น",
      body: "อัปโหลด CAD แรก ให้ Cara ตรวจสอบและเรนเดอร์ และเผยแพร่ไปยัง Inspire — ทั้งหมดในไม่ถึง 5 นาที",
      ctaDemo: "ลอง Cara AI — สาธิตสด",
      ctaStudio: "เปิด Studio",
    },
  },

  aiCredits: {
    meta: {
      title: "Studio Credits — Caratzon",
      description: "เรียนรู้วิธีการทำงานของ Studio Credits บน Caratzon — การดำเนินการ AI ต้นทุนคงที่สำหรับ photo kit ปรึกษาการออกแบบ และอื่น ๆ ไม่มีค่าธรรมเนียมต่อภาพ",
      socialDescription: "การดำเนินการ AI ต้นทุนคงที่สำหรับ photo kit ปรึกษาการออกแบบ และอื่น ๆ",
    },
    hero: {
      label: "Studio Credits",
      heading: "AI ต้นทุนคงที่ โปร่งใส",
      body: "ทุกการดำเนินการ AI บน Caratzon ใช้จำนวน Studio Credits คงที่ ไม่มีค่าธรรมเนียมต่อภาพ ไม่มีการวัดโทเค็น ไม่มีเซอร์ไพรส์",
    },
    howItWorks: {
      label: "วิธีการทำงาน",
      heading: "รับ ใช้ เติม",
      steps: [
        { step: "01", title: "รับเครดิต", body: "แพลนที่ชำระเงินรวมเงินเดือนเครดิตรายเดือน บัญชี Explorer ได้รับ 200 เครดิตต้อนรับเพื่อทดลอง" },
        { step: "02", title: "ใช้กับทุกการดำเนินการ", body: "Photo kit ลุคบุ๊ก ปรึกษา Cara AI — แต่ละการดำเนินการมีต้นทุนเครดิตคงที่แสดงล่วงหน้า" },
        { step: "03", title: "เติมเมื่อต้องการเพิ่ม", body: "ซื้อแพ็กเครดิตทันที เครดิตเติมไม่มีวันหมดอายุ — เครดิตสมาชิกรีเซ็ตทุกรอบบิล" },
      ],
    },
    photoStudio: {
      label: "Photo Studio",
      heading: "สื่อพร้อมผลิต",
      body: "อัปโหลดแบบและรับภาพถ่ายพร้อมลงแคตตาล็อก line sheet และสำเนาการตลาด — ทั้งหมด AI สร้างในไม่กี่นาที",
    },
    caraAi: {
      label: "Cara AI",
      heading: "คู่คิดวิศวกรรมออกแบบ",
      body: "Cara เป็น AI วิศวกรเครื่องประดับที่เข้าใจโลหะวิทยา การฝังอัญมณี ความสมบูรณ์ของโครงสร้าง และข้อจำกัดในการผลิต ถามได้ทุกเรื่อง — ตั้งแต่วิทยาศาสตร์วัสดุถึงประมาณ BOM",
      note: "ข้อความ (5 เครดิต) เรียกเก็บเมื่อส่ง เครื่องมือภาพและวิดีโอเรียกเก็บเมื่อ AI เรียกใช้ — คุณจะเห็นต้นทุนก่อนดำเนินการ เซสชัน 10 ข้อความพร้อมเรนเดอร์สองสามรายการใช้ประมาณ 100–150 เครดิต",
    },
    monthlyAllowances: {
      label: "เงินเดือนรายเดือน",
      heading: "เครดิตรวมในแพลนของคุณ",
      tableHeaders: ["แพลน", "เครดิตรายเดือน", "เครดิตต้อนรับ", "ราคา"],
      rows: [
        { plan: "Discover", monthly: "—", welcome: "200", price: "ฟรี" },
        { plan: "Source", monthly: "1,500", welcome: "—", price: "$149/เดือน" },
        { plan: "Atelier", monthly: "5,000", welcome: "—", price: "$399/เดือน" },
        { plan: "Enterprise", monthly: "สั่งทำ", welcome: "—", price: "สั่งทำ" },
      ],
      note: "เครดิตสมาชิกรีเซ็ตทุกรอบบิล — เครดิตที่ไม่ใช้ไม่สะสม เครดิตเติมไม่มีวันหมดอายุ",
    },
    topUpPacks: {
      label: "แพ็กเติม",
      heading: "ซื้อเพิ่ม เก็บได้ตลอด",
      body: "กำลังเปิดตัวคอลเลกชันใหญ่? ซื้อเครดิตทันที — ไม่มีวันหมดอายุ",
      bestValue: "คุ้มค่าที่สุด",
      creditsLabel: "เครดิต",
      perCredit: "เซ็นต์ต่อเครดิต",
      buyPrefix: "ซื้อ",
      buySuffix: "เครดิต",
      note: "การสมัครสมาชิกคุ้มค่าที่สุดเสมอ — เครดิตสมาชิกต้นทุนต่ำกว่าเครดิตเติมต่อหน่วย",
      compareLink: "เปรียบเทียบแพลน",
    },
    faq: {
      label: "คำถามที่พบบ่อย",
      heading: "เครดิต อธิบาย",
      items: [
        { q: "จะเกิดอะไรขึ้นถ้าเครดิตหมดกลางบทสนทนากับ Cara?", a: "ข้อความถูกตรวจสอบก่อนส่ง — คุณจะเห็นข้อความให้เติมเครดิต เครื่องมือภาพและวิดีโอตรวจสอบก่อนสร้าง AI จะแจ้งให้คุณทราบหากต้องการเครดิตเพิ่มก่อนดำเนินการแพง" },
        { q: "เครดิตสมาชิกที่ไม่ใช้สะสมไหม?", a: "ไม่ เครดิตสมาชิกรีเซ็ตต้นรอบบิลถัดไป หากต้องการเพิ่มเป็นประจำ อัปเกรดแพลนหรือซื้อแพ็กเติม — เครดิตเติมไม่มีวันหมดอายุ" },
        { q: "ข้อความ Cara เดียวใช้มากกว่า 5 เครดิตได้ไหม?", a: "ได้ ข้อความพื้นฐานใช้ 5 เครดิต แต่ถ้า Cara สร้างภาพ (15 ต่อภาพ) หรือวิดีโอ (25 ต่อคลิป) ระหว่างตอบ จะเรียกเก็บเพิ่ม การปรึกษาออกแบบทั่วไปพร้อมเรนเดอร์ 2–3 รายการใช้ประมาณ 50–70 เครดิตรวม" },
        { q: "บัญชีผู้ดูแลถูกเรียกเก็บเครดิตไหม?", a: "ไม่ บัญชีผู้ดูแลได้รับการยกเว้นค่าเครดิตสำหรับการทดสอบภายในและปฏิบัติการ" },
        { q: "อะไรคือความแตกต่างระหว่าง Essentials Kit กับ Caratzon Kit?", a: "Essentials Kit (10 เครดิต) สร้างภาพพร้อมลงแคตตาล็อก สเปค และ SEO copy Caratzon Kit (100 เครดิต) รวมทุกอย่างใน Essentials บวกลุคบุ๊กครบชุดพร้อมภาพถ่ายไลฟ์สไตล์ ภาพบรรณาธิการ และสื่อพร้อมโพสต์โซเชียล" },
      ],
    },
    actions: {
      photoStudio: [
        { action: "Essentials Kit", detail: "ภาพแคตตาล็อก สเปค & SEO copy" },
        { action: "Caratzon Kit", detail: "Photo studio ครบชุด — ภาพไลฟ์สไตล์ line sheet & สื่อโซเชียล" },
        { action: "สร้างภาพเดียวใหม่", detail: "สร้างภาพที่ไม่พอใจใหม่" },
        { action: "PDF ลุคบุ๊ก", detail: "PDF line sheet ค้าส่งที่มีแบรนด์" },
      ],
      caraAi: [
        { action: "ข้อความ", detail: "วิเคราะห์ภาพร่าง ถามตอบ วิทยาศาสตร์วัสดุ ตรวจสอบโครงสร้าง หรือปรึกษาการออกแบบ" },
        { action: "ภาพร่าง", detail: "ภาพร่างแนวคิดเร็วจากคำอธิบาย" },
        { action: "เรนเดอร์ภาพ", detail: "เรนเดอร์ภาพร่างสู่แนวคิดที่ซื่อสัตย์ มูดบอร์ด ภาพแคตตาล็อก หรือปรับแบบ" },
        { action: "ภาพลุคบุ๊ก", detail: "ภาพลุคบุ๊กบรรณาธิการสำหรับ deck นำเสนอ" },
        { action: "วิดีโอ 360°", detail: "วิดีโอหมุนรอบแบบของคุณจากทุกมุม" },
      ],
    },
  },

  demo: {
    meta: {
      title: "Cara AI สาธิต · Caratzon",
      description: "ลอง Cara — AI วิศวกรรมเครื่องประดับที่ออกแบบเพื่อพื้นโรงงานและมือมนุษย์ การหดตัว ค่าเผื่อ กลศาสตร์การหล่อ การสวมใส่ — ทุกแนวคิดพร้อมผลิต สาธิตสด",
    },
    splash: {
      eyebrow: "AI วิศวกรรมเครื่องประดับ",
      heading: "พบกับ Cara",
      subheading: "AI วิศวกรรมที่ออกแบบเครื่องประดับที่โรงงานสามารถสร้างได้และลูกค้าอยากสวมใส่ — ตั้งแต่ภาพร่างแรก",
      cta: "เริ่มออกแบบ",
      enterHint: "กด {key} เพื่อเริ่ม",
      promptDivider: "หรือลองพรอมต์",
      signIn: "เข้าสู่ระบบ",
      noAccount: "ไม่ต้องสร้างบัญชี",
      notSaved: "บทสนทนาจะไม่ถูกบันทึก",
      fullAccess: "เข้าถึงแพลตฟอร์มเต็มรูปแบบ →",
      namePlaceholder: "ชื่อของคุณ (แสดงในแกลเลอรี)",
      nameHint: "เพื่อให้เราให้เครดิตผลงานของคุณ",
    },
    prompts: [
      { label: "แหวนหมั้น", text: "ออกแบบแหวนหมั้นเพชรเม็ดเดี่ยวสมัยใหม่ เพชรทรงโอวัล 1 กะรัต ทองคำโรส 18K" },
      { label: "แหวนค็อกเทล Art Deco", text: "สร้างแหวนค็อกเทลที่โดดเด่นแรงบันดาลใจจากเรขาคณิต Art Deco กับมรกตและออนิกซ์" },
      { label: "สร้อยข้อมือเทนนิส", text: "ออกแบบสร้อยข้อมือเทนนิสมินิมอลกับแซฟไฟร์และเพชรสลับในแพลทินัม" },
      { label: "กำไลปฏิมากรรม", text: "ฉันต้องการกำไลทองปฏิมากรรมที่มีเส้นโค้งออร์แกนิก ไม่มีอัญมณี แค่งานโลหะล้วน" },
    ],
    capabilities: [
      { label: "ภาพร่างสู่พิมพ์เขียวการผลิต", desc: "อัปโหลดภาพร่างบนกระดาษ — Cara วิศวกรรมเพื่อพื้นโรงงาน" },
      { label: "การวิเคราะห์การหล่อและการหดตัว", desc: "การชดเชยการหดตัวเฉพาะโลหะ การตรวจสอบความหนาผนัง" },
      { label: "การแมปค่าเผื่ออัญมณี", desc: "ตำแหน่งเขี้ยว ความลึกที่นั่ง และระยะห่างเอว — วิศวกรรมแล้ว" },
      { label: "การสวมใส่และความสบาย", desc: "โปรไฟล์วง การกระจายน้ำหนัก รัศมีขอบ — ออกแบบสำหรับสวมทั้งวัน" },
    ],
    header: {
      brandLabel: "Cara AI",
      tabs: { create: "สร้าง", gallery: "แกลเลอรี" },
      back: "← ย้อนกลับ",
      fullAccess: "เข้าถึงเต็มรูปแบบ",
    },
    gallery: {
      loading: "กำลังโหลดแกลเลอรี…",
      emptyTitle: "ยังไม่มีแบบ",
      emptyBody: "เป็นคนแรกที่สร้าง แบบที่สร้างระหว่างเซสชันสาธิตจะปรากฏที่นี่ให้ทุกคนเห็น",
      emptyAction: "สร้างแบบแรก",
      sectionTitle: "สร้างในงานนี้",
      countSingular: "{count} แบบสร้างโดยผู้เข้าชมสาธิต",
      countPlural: "{count} แบบสร้างโดยผู้เข้าชมสาธิต",
      createYours: "สร้างของคุณ",
      createdWith: "สร้างด้วย Cara AI",
      generating: "กำลังสร้างเรื่องราว…",
      viewStory: "ดูเรื่องราว",
      toolLabels: {
        render: "AI Render",
        mood_board: "มูดบอร์ด",
        catalog_render: "เรนเดอร์แคตตาล็อก",
      },
      fallbackTool: "เรนเดอร์",
      timeAgo: {
        justNow: "เมื่อกี้",
        minutes: "{n} นาทีที่แล้ว",
        hours: "{n} ชั่วโมงที่แล้ว",
        days: "{n} วันที่แล้ว",
      },
    },
    story: {
      backToGallery: "← กลับแกลเลอรี",
      fromSketch: "จากภาพร่าง",
      theSketch: "ภาพร่าง",
      sketchCaption: "ภาพร่างต้นฉบับโดย {name}",
      theDetails: "รายละเอียด",
      detailType: "ประเภท",
      detailMetal: "โลหะ",
      detailStyle: "สไตล์",
      detailStones: "อัญมณี",
      detailFinish: "ฟินิช",
      detailWeight: "น้ำหนัก",
      detailPrice: "ราคาประมาณ",
      structuralAnalysis: "การวิเคราะห์โครงสร้าง",
      theStory: "เรื่องราว",
      showcase: "โชว์เคส",
      designJourney: "การเดินทางของการออกแบบ",
      theConversation: "บทสนทนา",
      moreMessages: "อีก {n} ข้อความในบทสนทนานี้",
      createdBy: "สร้างโดย",
      createdWith: "สร้างด้วย Cara AI ที่ {event}",
      eventName: "สาธิตสด",
      tryIt: "ลอง Cara เอง →",
      artifactLabels: {
        render: "เรนเดอร์แบบ",
        catalog_render: "เรนเดอร์แคตตาล็อก",
        concept_sketch: "ภาพร่างแนวคิด",
        mood_board: "มูดบอร์ด",
        structural_analysis: "การวิเคราะห์โครงสร้าง",
        material_recommendation: "การวิเคราะห์วัสดุ",
        bom: "รายการวัสดุ",
        sketch_analysis: "การวิเคราะห์ภาพร่าง",
        lookbook: "ลุคบุ๊ก",
        video: "วิดีโอหมุนรอบ",
        inspiration: "การวิเคราะห์แรงบันดาลใจ",
        design_specs: "สเปคแบบ",
        finalize_design: "แบบสุดท้าย",
        gallery_share: "แชร์แกลเลอรี",
      },
    },
    brands: {
      splash: {
        eyebrow: "อัจฉริยะการออกแบบสำหรับแบรนด์",
        subheading: "อธิบายวิสัยทัศน์ ดูเรนเดอร์ ส่งสู่การผลิต",
        cta: "เริ่มสำรวจ",
        namePlaceholder: "ชื่อหรือแบรนด์ของคุณ",
        nameHint: "เพื่อให้เราปรับประสบการณ์ส่วนตัว",
        fullAccess: "เริ่มบัญชีค้าส่ง →",
      },
      prompts: [
        { label: "สร้อยข้อมือเทนนิสสั่งทำ", text: "ปรับสร้อยข้อมือเทนนิสนี้เป็นทองโรสสำหรับคอลเลกชันฤดูใบไม้ผลิ" },
        { label: "จี้เอกลักษณ์", text: "สร้างจี้เอกลักษณ์ด้วยลวดลายเรขาคณิตของแบรนด์ — มินิมอล ทอง 14K" },
        { label: "ตัวเลือกแหวนแต่งงาน", text: "แสดงตัวเลือกแหวนแต่งงานมินิมอลที่สามราคา" },
        { label: "ภาพร่างสู่การผลิต", text: "ฉันมีภาพร่างกำไล — ช่วยทำให้พร้อมผลิตได้ไหม?" },
      ],
      capabilities: [
        { label: "ตัวอย่างการปรับแต่ง", desc: "ดูวิสัยทัศน์การออกแบบที่เรนเดอร์อย่างเหมือนจริง" },
        { label: "ตัวเลือกวัสดุและฟินิช", desc: "สำรวจโลหะ อัญมณี และฟินิช — เทียบเคียงกัน" },
        { label: "ราคาตัวอย่าง", desc: "ประมาณการทันทีสำหรับต้นแบบและผลิตล็อตเล็ก" },
        { label: "ไทม์ไลน์การผลิต", desc: "จากแนวคิดสู่จัดส่ง — ดูเส้นทางการผลิตทั้งหมด" },
      ],
      header: {
        fullAccess: "เริ่มบัญชีค้าส่ง",
      },
    },
  },

  productionDashboard: {
    title: "แดชบอร์ดการผลิต",
    tabs: { portfolio: "พอร์ตโฟลิโอ", board: "บอร์ด" },
    zoom: "ซูม",
    day: "วัน",
    week: "สัปดาห์",
    month: "เดือน",
    search: "ค้นหา...",
    searchPlaceholder: "ค้นหาแผน แบบ ผู้ผลิต...",
    keyboardShortcuts: "ทางลัดแป้นพิมพ์",
    groupBy: "จัดกลุ่มตาม",
    status: "สถานะ",
    phase: "เฟส",
    dragDisabledInPhase: "ปิดการลากในมุมมองเฟส",
    backToPortfolio: "พอร์ตโฟลิโอ",
    subOrders: "คำสั่งย่อย",
    unassigned: "ยังไม่มอบหมาย",
    noItems: "ไม่มีรายการ",
    densityCompact: "มุมมองกะทัดรัด",
    densityComfortable: "มุมมองสบาย",
    empty: {
      portfolioTitle: "ไม่มีการผลิตที่ดำเนินอยู่",
      portfolioDescription: "แผนที่สร้างใน Production Planner จะปรากฏที่นี่เมื่อได้รับอนุมัติ",
      portfolioLink: "เปิด Production Planner",
      boardTitle: "ไม่มีคำสั่งย่อย",
      boardDescription: "ไม่มีคำสั่งย่อยที่ตรงกับตัวกรอง",
      boardLink: "ดูพอร์ตโฟลิโอ",
      planTitle: "ไม่มีคำสั่งย่อย",
      planDescription: "แผนนี้ยังไม่มีคำสั่งย่อย",
      planLink: "เปิด Production Planner",
    },
    filters: {
      allStatuses: "ทุกสถานะ",
      allDesigners: "นักออกแบบทั้งหมด",
      allBuyers: "ผู้ซื้อทั้งหมด",
    },
    command: {
      noResults: "ไม่พบผลลัพธ์",
      productionPlans: "แผนการผลิต",
      quickActions: "ดำเนินการด่วน",
      goToPortfolio: "ไปที่พอร์ตโฟลิโอ",
      goToBoard: "ไปที่บอร์ด",
      navigate: "นำทาง",
      open: "เปิด",
      close: "ปิด",
    },
    kanban: {
      blockedAndCancelled: "ติดขัดและยกเลิก",
      columns: {
        PENDING: "รอดำเนินการ",
        QUOTED: "เสนอราคาแล้ว",
        ASSIGNED: "มอบหมายแล้ว",
        IN_PROGRESS: "กำลังดำเนินการ",
        QA: "QA",
        COMPLETED: "เสร็จสิ้น",
        BLOCKED: "ติดขัด",
        CANCELLED: "ยกเลิก",
      },
    },
    gantt: {
      today: "วันนี้",
      criticalPath: "เส้นทางวิกฤต",
      duration: "ระยะเวลา",
      days: "วัน",
      manufacturer: "ผู้ผลิต",
      dependsOn: "ขึ้นอยู่กับ",
    },
    detail: {
      status: "สถานะ",
      manufacturer: "ผู้ผลิต",
      duration: "ระยะเวลา",
      dependencies: "ขึ้นอยู่กับ",
    },
    hover: {
      duration: "ระยะเวลา",
      manufacturer: "ผู้ผลิต",
    },
  },

  buyerTracker: {
    title: "ความคืบหน้าการผลิต",
    inProgress: "กำลังดำเนินการ",
    pending: "รอดำเนินการ",
    milestones: {
      orderConfirmed: "ยืนยันคำสั่งซื้อ",
      designEngineering: "วิศวกรรมแบบ",
      sampleProduction: "ผลิตตัวอย่าง",
      approval: "อนุมัติ",
      manufacturing: "การผลิต",
      finalFinishing: "ตกแต่งขั้นสุดท้าย",
      qualityCheckDelivery: "ตรวจคุณภาพและจัดส่ง",
    },
  },
};
